/* Motore del carrello a scomparsa (hn-cart) — meccanismo puro.
   Fino al 2026-08-15 viaggiava INLINE nell HTML di ogni pagina (circa 43 KB gzip
   per pagina, mai in cache). Ora e un asset: scaricato una volta, poi riusato.
   Il codice e identico, spostato verbatim; serviva {% raw %} solo perche stava
   dentro un file .liquid, e qui non serve piu.
   POLICY (testi, default, impostazioni) resta in snippets/hn-cart.liquid:
   window.HN_CART_DEFAULTS e window.HN_CART_BOOT, dichiarati PRIMA di questo file.
   Presidiato dal test U9 di tools/run-head-tests.mjs. */
(function () {
  'use strict';
  if (window.__HN_CART_LOADED__) return;
  window.__HN_CART_LOADED__ = true;

  var BOOT = window.HN_CART_BOOT || { moneyFormat: '€{{amount_with_comma_separator}}', root: '/' };
  var DESIGN = !!(window.Shopify && window.Shopify.designMode); // editor del tema: anteprima non invasiva
  // Diagnostica barra premi: attiva SOLO con ?hncartdebug nell'URL (i clienti non la vedono mai).
  // Mostra una riga con lo stato reale del riempimento (larghezza, colore, contenitore) per capire
  // dal vivo perché la barra non si colora, quando l'ambiente reale differisce dai test headless.
  var HN_DEBUG = false;
  try { HN_DEBUG = /hncartdebug/i.test(window.location.search || ''); } catch (e) {}

  // Config = DEFAULT dello snippet, FUSI con le impostazioni della sezione (Theme Editor)
  // oppure con un override manuale via window.HN_CART_CONFIG.
  function isObj(x) { return x && typeof x === 'object' && !Array.isArray(x); }
  function deepMerge(base, over) {
    var out = {}, k;
    for (k in base) if (Object.prototype.hasOwnProperty.call(base, k)) out[k] = base[k];
    for (k in over) {
      if (!Object.prototype.hasOwnProperty.call(over, k) || over[k] === undefined) continue;
      out[k] = (isObj(base[k]) && isObj(over[k])) ? deepMerge(base[k], over[k]) : over[k];
    }
    return out;
  }
  // Un color-picker di Shopify può salvare un colore "legato al brand" come stringa Liquid NON
  // risolta (es. "{{ shop.brand.colors.primary[0].background }}") se il merchant usa l'icona
  // "colore del brand" nell'editor. Se questa stringa finisce in una CSS custom property, la
  // rende invalida (elemento senza colore, invisibile) senza alcun errore visibile. Filtriamo
  // qualsiasi valore che non sembri un colore CSS vero, e torniamo al default dello snippet.
  function looksLikeCssColor(v) {
    if (typeof v !== 'string') return false;
    v = v.trim();
    if (!v || v.indexOf('{') >= 0 || v.indexOf('}') >= 0) return false;
    return /^(#[0-9a-fA-F]{3,8}|rgba?\(|hsla?\(|[a-zA-Z]+)$/.test(v);
  }
  function safeColor(v) { return looksLikeCssColor(v) ? v : undefined; } // undefined -> deepMerge usa il default

  // mappa le impostazioni PIATTE della sezione (window.HN_CART_SETTINGS) nella struttura del config
  /* Due modi di meritarsi un regalo, e sono davvero diversi:
       - a SOGLIA  (`threshold`): scatta quando il subtotale idoneo la supera. E' quello
         storico, disegnato anche come tappa sulla barra premi.
       - a PRODOTTO (`triggerProductId`): scatta quando un prodotto preciso e' nel
         carrello, a prescindere dal totale. Serve per "compri il Kit, il dopobarba e'
         incluso": e' una promessa legata all'articolo, non al valore speso.
     ⚠️ Un tier a prodotto NON ha una soglia, quindi non e' una tappa della barra premi e
     non deve finire in `nextUnmetGoal` — altrimenti la barra proporrebbe un traguardo a
     0€ e il messaggio sopra impazzirebbe. Vedi la guardia in nextUnmetGoal. */
  function giftTiers(s) {
    var tiers = [];
    /* ⚠️ Ogni gruppo di regali ha il SUO interruttore (dal 2026-10-13). Prima
       `freegift_enabled` (il regalo a soglia) accendeva e spegneva l'intero modulo:
       spegnere il sacchetto dei 75 € avrebbe spento in silenzio anche i regali delle
       offerte Kit Viso, che la landing promette. */
    if (s.freegift_enabled && s.freegift_variant) {
      tiers.push({ threshold: s.freegift_threshold, variantId: s.freegift_variant, title: 'Omaggio', image: '' });
    }
    if (s.giftproduct_enabled && s.giftproduct_variant && s.giftproduct_trigger) {
      tiers.push({
        triggerProductId: s.giftproduct_trigger,
        variantId: s.giftproduct_variant,
        title: s.giftproduct_title || 'Omaggio',
        image: ''
      });
    }
    /* Regali per QUANTITA' dello stesso prodotto (dal 2026-10-13, le offerte 2 e 3
       Kit Viso della landing: «aggiungi 2 o 3 kit nel carrello e aggiungi anche i
       prodotti come omaggio, con lo stesso meccanismo del sacchetto»). Sono tier a
       prodotto con una quantita' minima: da 2 pezzi il primo regalo, da 3 anche il
       secondo. Con la quantita' minima a 1 sarebbero identici al tier qui sopra.
       Dal 2026-10-28 i gruppi sono due, ognuno col suo prodotto e il suo interruttore
       (`giftqty_*` il Kit Viso, `giftqty2_*` le offerte della landing Crema Viso:
       3 creme → siero in omaggio). Spegnerne uno non tocca l'altro. */
    ['giftqty', 'giftqty2'].forEach(function (g) {
      if (!s[g + '_enabled'] || !s[g + '_trigger']) return;
      [1, 2].forEach(function (i) {
        var v = s[g + '_variant_' + i], min = parseInt(s[g + '_min_' + i], 10);
        if (v && min >= 1) {
          tiers.push({
            triggerProductId: s[g + '_trigger'],
            triggerMinQty: min,
            variantId: v,
            title: s[g + '_title'] || 'Omaggio',
            image: ''
          });
        }
      });
    });
    return tiers;
  }
  /* la regola di un tier come la leggono gli ordini (`_hn_tier`) e la diagnostica:
     la soglia in euro, oppure l'id del prodotto che lo innesca, con la quantita'
     minima quando e' piu' di uno («prodotto:123x2») */
  function tierTag(tier) {
    if (!tier.triggerProductId) return String(tier.threshold);
    return 'prodotto:' + tier.triggerProductId + (tier.triggerMinQty > 1 ? 'x' + tier.triggerMinQty : '');
  }

  function settingsToConfig(s) {
    var goals = [];
    [1, 2, 3].forEach(function (i) {
      if (s['goal' + i + '_enabled'] && s['goal' + i + '_amount'] > 0)
        goals.push({
          type: s['goal' + i + '_type'], label: s['goal' + i + '_label'], amount: s['goal' + i + '_amount'],
          /* Etichetta alternativa mostrata SOTTO la barra quando il traguardo e' raggiunto
             ("Hai ottenuto la Spedizione Gratuita"). Vuota = si tiene l'etichetta normale.
             E' per-traguardo e non un template tipo "Hai ottenuto {label}" perche' in italiano
             l'articolo cambia: "la Spedizione Gratuita" ma "l'Omaggio". */
          labelReached: s['goal' + i + '_label_reached']
        });
    });
    var cfg = {
      enabled: s.enabled,
      design: {
        position: s.position, width: s.width,
        accent: s.use_theme_colors ? '' : safeColor(s.accent),
        accentText: s.use_theme_colors ? '' : safeColor(s.accent_text),
        progressColor: safeColor(s.progress_color),
        success: s.use_theme_colors ? '' : safeColor(s.success_color)
      },
      announcement: s.announcement || '',
      /* onlyBelow = entro quanti EURO dal traguardo il messaggio dice «solo» (0 = mai).
         Resta `undefined` se l'HTML e' stato messo in cache prima di questo deploy: deepMerge
         salta gli undefined (riga 29), quindi vale il default della policy invece di spegnere
         la parola su tutte le pagine ancora in cache. */
      rewards: { enabled: s.rewards_enabled, goals: goals, onlyBelow: s.goal_only_below },
      freeGifts: { enabled: !!(s.freegift_enabled || s.giftproduct_enabled || s.giftqty_enabled || s.giftqty2_enabled), tiers: giftTiers(s) },
      upsells: { enabled: s.upsells_enabled, limit: s.upsells_limit, manualHandles: s.upsell_handles || [] },
      addons: { enabled: s.addons_enabled, items: s.addon_items || [] },
      discountBox: { enabled: s.discountbox_enabled },
      note: { enabled: s.note_enabled },
      terms: { enabled: s.terms_enabled, url: s.terms_url || '' },
      urgency: { countdown: { enabled: s.urgency_enabled, minutes: s.urgency_minutes } },
      trust: { enabled: s.trust_enabled, badges: String(s.trust_badges || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean) },
      paymentIcons: { enabled: s.payment_icons_enabled, html: s.payment_icons_html || '' },
      lineRemove: { enabled: s.remove_enabled },
      delivery: { enabled: s.delivery_enabled, cfg: s.delivery_cfg || '', engine: s.delivery_engine || '' },
      co: { enabled: s.co_enabled, holdout: s.co_holdout, country: s.country, offers: s.co_offers },
      text: {}
    };
    var tmap = { title: 'text_title', checkout: 'text_checkout', savedLabel: 'text_saved', upsellsHeading: 'upsells_heading', recommendedHeading: 'recommended_heading',
      shippingProgress: 'text_shipping_progress', shippingReached: 'text_shipping_reached', giftProgress: 'text_gift_progress',
      onlyWord: 'text_only_word',
      giftReached: 'text_gift_reached', allGoalsReached: 'text_all_reached', urgencyText: 'text_urgency', add: 'text_add', details: 'text_details', empty: 'text_empty',
      upsellUnlockShipping: 'text_up_unlock_shipping', upsellUnlockGift: 'text_up_unlock_gift',
      coTitle: 'co_title', coSub: 'co_sub', coWhy: 'co_why', coSave: 'co_save', coShip: 'co_ship', coGift: 'co_gift', coBoth: 'co_both',
      coUpTitle: 'co_up_title', coUpLine: 'co_up_line', coUpSwap: 'co_up_swap', coUpAdds: 'co_up_adds',
      coUpSave: 'co_up_save', coUpSoaps: 'co_up_soaps', coYes: 'co_yes', coNo: 'co_no' };
    Object.keys(tmap).forEach(function (k) { var v = s[tmap[k]]; if (v != null && v !== '') cfg.text[k] = v; });
    return cfg;
  }
  var OVER = window.HN_CART_SETTINGS ? settingsToConfig(window.HN_CART_SETTINGS) : (window.HN_CART_CONFIG || {});
  var CFG = deepMerge(window.HN_CART_DEFAULTS || {}, OVER);
  if (CFG.enabled === false) return;

  var ROOT = BOOT.root || '/';
  var _fetch = window.fetch.bind(window); // riferimento ORIGINALE (bypassa i nostri interceptor)

  // Colori: config esplicita > colore bottoni del tema (brand) > fallback neutro
  var DS = CFG.design || {};
  var ACCENT = DS.accent || BOOT.themeAccent || '#111111';
  var ACCENT_TEXT = DS.accentText || BOOT.themeAccentText || '#ffffff';
  var SUCCESS = DS.success || ACCENT;
  var PROGRESS = DS.progressColor || '#8a5a2b'; // colore barra mentre carica (marrone)
  var TRASH = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>';

  /* ------------------------------ util ------------------------------ */
  function d(o, def) { return (o === undefined || o === null) ? def : o; }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function toCents(eur) { return Math.round(parseFloat(eur || 0) * 100); }
  /* «SOLO» SOLO QUANDO IL TRAGUARDO E' VICINO (richiesta del merchant, 2026-09-18).
     La parola agisce sulla percezione della DISTANZA, quindi ha senso su «ti mancano solo
     9,10 €» e lavora contro di noi su «ti mancano solo 42,10 €»: da lontano ammette che la
     strada e' lunga. Percio' la si aggiunge solo sotto una soglia in euro (`rewards.onlyBelow`).

     ⚠️ La parola NON e' scritta nel testo del messaggio, e non e' una svista: i testi vivono
     nelle impostazioni della sezione e il merchant li riscrive dall'editor, quindi una versione
     «con solo» e una «senza» sarebbero due copie da tenere allineate a mano — il difetto numero
     uno di questo repo. Qui il testo resta uno, e la parola la mette il meccanismo.

     ⚠️ Va DAVANTI alla cifra ma FUORI dal markup che la avvolge: in «Ti mancano <b>{amount}</b>»
     il grassetto e' della cifra, e infilarci dentro anche la parola la renderebbe grassetta —
     cioe' enfatizzerebbe proprio cio' che deve suonare leggero. Da qui il gruppo che cattura i
     tag di apertura prima del segnaposto. */
  var RX_AMOUNT_TAGS = /((?:<[a-z][^>]*>\s*)*)\{amount\}/i;
  function withOnlyWord(tpl, gapCents) {
    var w = (CFG.text && CFG.text.onlyWord) || '';
    var maxEuro = (CFG.rewards && CFG.rewards.onlyBelow) || 0;
    if (!w || !maxEuro) return tpl;                                  // parola vuota o soglia 0 = mai
    if (!(gapCents > 0) || gapCents >= toCents(maxEuro)) return tpl; // traguardo lontano
    /* se il merchant l'ha gia' scritta a mano nel testo, non la raddoppiamo */
    var g = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (new RegExp('(^|[\\s>])' + g + '($|[\\s<])', 'i').test(tpl)) return tpl;
    return tpl.replace(RX_AMOUNT_TAGS, function (_, tags) { return w + ' ' + tags + '{amount}'; });
  }
  /* `gapCents` e' opzionale: lo passano solo i messaggi di avvicinamento a un traguardo. */
  function t(key, vars, gapCents) {
    var s = (CFG.text && CFG.text[key]) || '';
    if (gapCents != null) s = withOnlyWord(s, gapCents);
    if (vars) Object.keys(vars).forEach(function (k) { s = s.replace('{' + k + '}', vars[k]); });
    return s;
  }
  function money(cents) {
    var f = BOOT.moneyFormat || '€{{amount_with_comma_separator}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = d(precision, 2); thousands = d(thousands, ','); decimal = d(decimal, '.');
      if (isNaN(number) || number == null) number = 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = f.match(re); var ph = m ? m[1] : 'amount'; var val = '';
    switch (ph) {
      case 'amount': val = fmt(cents, 2); break;
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': val = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
      default: val = fmt(cents, 2);
    }
    return f.replace(re, val);
  }
  function track(event, data) {
    if (!(CFG.analytics && CFG.analytics.dataLayer)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  /* ------------------------------------------------------------------------
     add_to_cart in forma GA4: `ecommerce.items` col SOLO prodotto aggiunto.

     ⚠️ PERCHE' ESISTE, e cosa correggeva (verificato su GA4 il 2026-08-17).
     Prima questo evento portava solo `variant_id` e `quantity`, senza alcun
     oggetto `ecommerce`. Il tag GA4 in GTM e' agganciato a un trigger A CLIC e
     leggeva `ecommerce.items` dal dataLayer: ma l'ultimo a scriverlo era
     `snippets/dataLayer.liquid`, che a ogni caricamento di pagina spinge
     `view_cart` con TUTTO il carrello. Risultato: ogni aggiunta veniva
     registrata con l'intero carrello come articoli, e ogni prodotto gia' nel
     carrello veniva ricontato a ogni aggiunta successiva.
     Le misure: 3.548 eventi add_to_cart -> 9.575 articoli = 2,70 per evento,
     contro ~1 atteso — e quel 2,70 coincide con gli articoli per ordine (2,79).
     Controprova: il "Portasapone in bambu' – Omaggio" risultava aggiunto 43
     volte con 0 viste, e nessuno clicca "aggiungi" su un omaggio.
     Effetto: la colonna "aggiunte per prodotto" in GA4 era inutilizzabile.

     ⚠️ `ecommerce: null` PRIMA dell'evento non e' cosmetico: senza il reset,
     GA4 e GTM fondono l'oggetto `ecommerce` con quello precedente, ed e'
     esattamente il meccanismo del difetto. Stessa cosa che fa
     snippets/dataLayer.liquid alle righe 4, 31 e 57.

     ⚠️ La seconda meta' della correzione e' in GTM e NON e' in questo file: il
     tag va spostato da trigger "a clic" a "evento personalizzato = add_to_cart",
     con Items da `ecommerce.items`. Finche' resta a clic, questo payload piu'
     ricco viene ignorato. Nell'ordine: prima questo, poi GTM — mai il contrario,
     o si resta senza dati. Istruzioni in tools/hn-datalayer.md.

     ⚠️ QUESTA FUNZIONE COPRE SOLO LE AGGIUNTE FATTE DAL DRAWER (l'upsell). Le
     altre — il pulsante "AGGIUNGI" delle schede, la pagina prodotto, la barra
     fissa, le app — passano dal tema e sono la stragrande maggioranza: le copre
     `trackAddFromResponse` qui sotto. Le due insieme sono la condizione perche'
     lo spostamento del tag in GTM non faccia perdere dati.
     ------------------------------------------------------------------------ */
  function trackAdd(cart, variantId, qty, meta) {
    if (!(CFG.analytics && CFG.analytics.dataLayer)) return;
    var righe = (cart && cart.items) || [];
    var linea = null;
    for (var i = 0; i < righe.length; i++) {
      if (String(righe[i].variant_id) === String(variantId)) { linea = righe[i]; break; }
    }
    var art = {
      /* item_id = product_id, come in snippets/dataLayer.liquid: se qui usassimo
         la variante, lo stesso prodotto risulterebbe due articoli diversi fra
         view_item e add_to_cart, e il funnel per prodotto non si chiuderebbe. */
      item_id: String((linea && linea.product_id) || (meta && meta.product_id) || variantId),
      item_variant: String(variantId),
      item_name: (linea && (linea.product_title || linea.title)) || '',
      quantity: qty
    };
    /* `final_price` e' in centesimi ed e' nella valuta di PRESENTAZIONE, la stessa
       che vede il cliente: e' quella giusta per GA4. */
    if (linea && typeof linea.final_price === 'number') art.price = Math.round(linea.final_price) / 100;
    if (meta && meta.item_list_name) art.item_list_name = meta.item_list_name;

    var eco = { items: [art] };
    if (cart && cart.currency) eco.currency = cart.currency;
    if (art.price != null) eco.value = Math.round(art.price * qty * 100) / 100;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    /* `ecommerce` per ultimo: se un domani `meta` portasse una chiave con lo
       stesso nome, non deve poter sovrascrivere gli articoli. */
    /* `hn_via` sempre presente: «button» per il bottone di una proposta, «popup»
       per un'anteprima. ⚠️ Non è un'aggiunta di forma: il modello del dataLayer
       di GTM è CUMULATIVO, quindi una chiave scritta solo dalle anteprime
       resterebbe appiccicata alle aggiunte col bottone fatte dopo, e GA4 le
       conterebbe tutte come «popup». */
    track('hn_add_to_cart', Object.assign({ variant_id: variantId, quantity: qty, hn_via: 'button' }, meta || {}, { ecommerce: eco }));
  }

  /* ------------------------------------------------------------------------
     add_to_cart per le aggiunte fatte DAL TEMA e dalle app: il pulsante
     "AGGIUNGI" delle schede, la pagina prodotto, la barra fissa, il quick shop,
     l'ordine espresso, i popup di Selleasy. Prima del 2026-08-17 **nessuna di
     queste spingeva nulla nel dataLayer** — e sono la stragrande maggioranza
     degli add_to_cart del negozio. L'unica cosa che GA4 riceveva era il tag a
     clic di GTM, che leggeva l'`ecommerce.items` stantio di
     `snippets/dataLayer.liquid` (cioe' il carrello intero).

     ⚠️ PERCHE' A LIVELLO DI RETE E NON SUI PULSANTI. Il tema aggiunge al
     carrello da almeno tre punti diversi e con due trasporti diversi:
     `fetch` (assets/theme.js ~3457, quick shop) e `$.ajax`, cioe' XHR
     (~4301 con `async: false`, ~6844 ordine espresso). Piu' le app, che non
     controlliamo. Sorvegliare i pulsanti significherebbe sorvegliare la forma
     particolare del difetto invece della categoria — l'errore che ha reso
     inutile la guardia U4 per giorni. `/cart/add.js` invece e' il collo di
     bottiglia obbligato: qualunque strada prenda l'aggiunta, passa da li'.

     Gli interceptor esistevano gia' (servivano ad aggiornare il drawer quando il
     tema tocca il carrello): qui si aggiunge solo la lettura della risposta.
     Le chiamate NOSTRE usano `_fetch` e non li riattivano, quindi le aggiunte
     dell'upsell restano di `trackAdd` — con la sua attribuzione — e non
     vengono contate due volte.

     Forma della risposta di `/cart/add.js`: la riga aggiunta, oppure
     `{items: [...]}` per le aggiunte multiple. Un 422 (esaurito) non ha `id`,
     quindi non produce evento: giusto, non c'e' stata alcuna aggiunta.
     ------------------------------------------------------------------------ */
  function valutaCorrente() {
    if (state.cart && state.cart.currency) return state.cart.currency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) return window.Shopify.currency.active;
    return BOOT.currency || null;
  }

  function trackAddFromResponse(json) {
    if (!(CFG.analytics && CFG.analytics.dataLayer)) return;
    if (!json) return;
    var linee = (json.items && json.items.length) ? json.items : (json.id ? [json] : []);
    if (!linee.length) return;

    var items = [], valore = 0, haPrezzo = false;
    for (var i = 0; i < linee.length; i++) {
      var l = linee[i];
      var q = typeof l.quantity === 'number' ? l.quantity : 1;
      var a = {
        // item_id = product_id, come in trackAdd e in snippets/dataLayer.liquid
        item_id: String(l.product_id || l.id),
        item_variant: String(l.variant_id || l.id),
        item_name: l.product_title || l.title || '',
        quantity: q
      };
      if (typeof l.final_price === 'number') {
        a.price = Math.round(l.final_price) / 100;
        valore += a.price * q;
        haPrezzo = true;
      }
      items.push(a);
    }

    var eco = { items: items };
    var val = valutaCorrente();
    if (val) eco.currency = val;
    if (haPrezzo) eco.value = Math.round(valore * 100) / 100;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    track('hn_add_to_cart', { hn_source: 'theme', ecommerce: eco });
  }

  /* begin_checkout: fino al 2026-08-17 partiva con payload VUOTO — `track(...,
     {})`. Il tag in GTM e' agganciato a un trigger a clic e leggeva
     `ecommerce.items` dal dataLayer, cioe' l'ultimo scritto da
     snippets/dataLayer.liquid: stessa identica meccanica di add_to_cart.
     Qui il carrello e' gia' in mano (`state.cart`), quindi il payload giusto
     costa niente. ⚠️ Ma il TRIGGER in GTM non va spostato su evento
     personalizzato insieme a quello di add_to_cart: questo evento lo spinge solo
     il bottone del drawer, e chi arriva al checkout da /cart o da un wallet non
     passa di qui. Vedi tools/hn-datalayer.md. */
  /* Righe del carrello in forma GA4. Usata da begin_checkout e view_cart. */
  function righeCarrello(cart) {
    return (cart.items || []).map(function (l) {
      var a = {
        item_id: String(l.product_id || l.id),
        item_variant: String(l.variant_id || l.id),
        item_name: l.product_title || l.title || '',
        quantity: l.quantity
      };
      if (typeof l.final_price === 'number') a.price = Math.round(l.final_price) / 100;
      return a;
    });
  }
  function ecoCarrello(cart) {
    var eco = { items: righeCarrello(cart) };
    if (cart.currency) eco.currency = cart.currency;
    if (typeof cart.total_price === 'number') eco.value = Math.round(cart.total_price) / 100;
    return eco;
  }
  function trackCheckout() {
    var cart = state.cart;
    if (!cart || !cart.items) { track('hn_begin_checkout', {}); return; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    track('hn_begin_checkout', { ecommerce: ecoCarrello(cart) });
  }
  /* Apertura del drawer. Prima spingeva `view_cart` con payload VUOTO, e siccome
     in GTM esiste un attivatore "evento personalizzato = view cart" (usato da
     snippets/dataLayer.liquid sulla pagina /cart), ogni apertura del carrello
     faceva partire quel tag con l'`ecommerce` di qualcun altro. Ora ha un nome
     suo e porta le sue righe. */
  function trackViewCart() {
    var cart = state.cart;
    if (!cart || !cart.items) { track('hn_view_cart', {}); return; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    track('hn_view_cart', { ecommerce: ecoCarrello(cart) });
  }

  function leggiRispostaAdd(txt) {
    if (!txt) return;
    var j = null;
    try { j = JSON.parse(txt); } catch (e) { return; }
    try { trackAddFromResponse(j); } catch (e) { /* la misura non deve mai rompere un'aggiunta */ }
    /* la scheda del prodotto appena aggiunto parte SUBITO, in parallelo alla rilettura
       del carrello: e' il dato che il disegno della riga aspetta (prezzo barrato) */
    try {
      var righe = j && (j.items || (j.variant_id ? [j] : []));
      (righe || []).forEach(function (it) { if (it && it.handle) productData(it.handle); });
    } catch (e2) {}
  }

  /* ----------------------- cronologia (?hncartdebug=1) -----------------------
     Nata il 2026-10-08 dal merchant: «quando aggiungo al carrello ci vogliono almeno
     due secondi prima che lo apre, e a volte non lo apre proprio» e «col cestino e'
     molto lento ad aggiornare». La sandbox non raggiunge il sito, quindi i tempi VERI
     di Shopify si leggono solo dal telefono di chi prova: qui si annota ogni passo
     dell'ultima operazione (richiesta partita, risposta, attesa in coda, disegno,
     apertura) in ms dal suo inizio, e il riquadro HNDBG-TEMPI li stampa. Senza il
     parametro non si registra niente. */
  var tl = { t0: 0, nome: '', rows: [], polls: 0, scartati: 0, ultimoPoll: 0 };
  function tnow() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function tlStart(nome) {
    if (!HN_DEBUG) return;
    tl.t0 = tnow(); tl.nome = nome; tl.rows = [];
    tlPaint();
  }
  function tlMark(s) {
    if (!HN_DEBUG || !tl.t0) return;
    tl.rows.push('+' + Math.round(tnow() - tl.t0) + ' ms  ' + s);
    if (tl.rows.length > 30) tl.rows.splice(0, tl.rows.length - 30);
    tlPaint();
  }
  // una richiesta: segna la partenza e restituisce la funzione che ne segna l'arrivo
  function tlReq(label) {
    if (!HN_DEBUG || !tl.t0) return function () {};
    var a = tnow();
    tlMark(label + ' partita');
    return function (esito) { tlMark(label + ' ' + (esito || 'arrivata') + ' (' + Math.round(tnow() - a) + ' ms)'); };
  }
  function tlPaint() {
    if (!HN_DEBUG || !els || !els.panel) return;
    try {
      var box = els.panel.querySelector('[data-hn-tldbg]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-hn-tldbg', '');
        box.style.cssText = 'flex:none;font:10px/1.45 monospace;color:#123;background:#eef7ee;border-top:1px solid #9c9;' +
          'padding:4px 8px;max-height:30vh;overflow:auto;white-space:pre-wrap;word-break:break-all';
        els.panel.appendChild(box);
      }
      box.textContent = 'HNDBG-TEMPI  ' + (tl.nome || '(nessuna operazione)') + '\n' + tl.rows.join('\n') +
        '\ncontrolli in sottofondo: ' + tl.polls + ' (scartati ' + tl.scartati + ')' +
        (tl.ultimoPoll ? ', ultimo ' + tl.ultimoPoll + ' ms' : '') + ' | ogni ' +
        (state.open ? POLL_OPEN : POLL_CLOSED) / 1000 + ' s' + (document.hidden ? ' (pagina nascosta: fermi)' : '');
    } catch (e) {}
  }
  function stato(r) { return r && r.status ? String(r.status) : 'arrivata'; }

  /* --------------------------- cart api layer --------------------------- */
  // Tutte le chiamate usano _fetch (fetch originale) -> NON riattivano i nostri interceptor.
  var API = {
    get: function (opts) {
      var fine = tlReq('GET /cart.js');
      return _fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' }, signal: (opts && opts.signal) || undefined })
        .then(function (r) { fine(stato(r)); return r.json(); });
    },
    add: function (items) {
      var fine = tlReq('POST /cart/add.js');
      /* Un set con un sapone esaurito parte COL SUO PREDEFINITO, qualunque strada nostra lo
         aggiunga (upsell, blocchi della pagina prodotto, anteprima, offerta al checkout):
         bysItems lascia gli stessi oggetti se non c'e' niente da scrivere. Vedi «SET A SCELTA». */
      items = bysItems(items);
      return _fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { fine(stato(r)); return r.json(); });
    },
    change: function (payload) { // {id: key, quantity, properties?}
      var fine = tlReq('POST /cart/change.js');
      return _fetch(ROOT + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { fine(stato(r)); return r.json(); });
    },
    update: function (payload) { // {updates?, note?, attributes?, discount?}
      var fine = tlReq('POST /cart/update.js' + (payload && payload.attributes && !payload.updates && !payload.discount ? ' (attributo)' : ''));
      return _fetch(ROOT + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { fine(stato(r)); return r.json(); });
    },
    product: function (handle) {
      var fine = tlReq('GET /products/' + handle + '.js');
      return _fetch(ROOT + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { fine(stato(r)); return r.ok ? r.json() : null; }).catch(function () { fine('errore'); return null; });
    },
    recommendations: function (productId, intent, limit) {
      var u = ROOT + 'recommendations/products.json?product_id=' + productId + '&limit=' + (limit || 4) + '&intent=' + (intent || 'related');
      return _fetch(u, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; }).catch(function () { return []; });
    }
  };

  /* ------------------------------ state ------------------------------ */
  var state = { cart: null, open: false, busy: false, upsellFailed: {}, relatedTried: {}, pinCache: {}, pinsToFetch: [], lastFocus: null, popTrigger: null, popMeta: null, rewardPct: 0, scrollLocked: false, lastSig: '', closeTimer: null, stock: {},
                /* aggiunte del tema/app in volo (il drawer si apre quando PARTONO, vedi
                   startExternalAdd); `addDismissed`: il cliente l'ha chiuso nel frattempo */
                adding: 0, addDismissed: false, addingTimer: null,
                /* quantità mostrate prima della risposta di Shopify (key -> {n: operazioni
                   in volo, q: quantità promessa}): vedi changeQty */
                optimQty: {} };

  /* Disponibilità verificata a runtime (pid -> true/false).
     Il campo `av` del catalogo è una FOTOGRAFIA: un prodotto esaurito dopo la
     generazione resta consigliabile fino alla rigenerazione. E' successo col
     Kit Viaggio. Qui la si verifica su /products/<handle>.js dopo il primo
     paint (mai prima: il paint sincrono è un requisito, test P1) e si ricorda
     per la sessione. Corregge in una sola direzione — toglie ciò che non è più
     acquistabile — perché ciò che il catalogo esclude non viene mai chiesto. */
  var STOCK_KEY = 'hn_reco_stock';
  try {
    var savedStock = sessionStorage.getItem(STOCK_KEY);
    if (savedStock) state.stock = JSON.parse(savedStock) || {};
  } catch (e) { state.stock = {}; }
  /* Disponibilità per VARIANTE (2026-10-05). `stock` dice se il prodotto ha almeno
     una variante acquistabile, e non bastava: il Kit Starter ha la Combinazione 2
     esaurita (DENY a −61) mentre la 1 si vende, e il catalogo le dava entrambe
     disponibili. Sulla pagina di Spirito Mediterraneo e dello Shampoo Anticaduta,
     che stanno solo nella 2, «Prendi il Kit Starter» chiedeva proprio quella:
     /cart/add.js la rifiutava e il bottone tornava com'era — «non succede nulla»
     (merchant, 2026-10-05). Dalla STESSA risposta che già si scarica per lo stock
     si ricordano le varianti che il catalogo dà disponibili e Shopify no. `seen`
     dice quali prodotti sono stati letti così: una sessione verificata prima di
     questa correzione rilegge il prodotto una volta. Una variante tornata
     disponibile esce dall'elenco. */
  var VSOLD_KEY = 'hn_reco_vsold';
  state.vsold = {}; state.vseen = {};
  try {
    var savedV = JSON.parse(sessionStorage.getItem(VSOLD_KEY) || 'null');
    if (savedV) { state.vsold = savedV.sold || {}; state.vseen = savedV.seen || {}; }
  } catch (e) { state.vsold = {}; state.vseen = {}; }
  function checked(pid) { return state.stock[pid] !== undefined && !!state.vseen[pid]; }
  function rememberVariants(pid, live) {
    var e = D.p[pid], changed = false;
    (live && live.variants || []).forEach(function (v) {
      var cv = null;
      ((e && e.vs) || []).forEach(function (x) { if (String(x.id) === String(v.id)) cv = x; });
      if (!cv || cv.av === false) return;            // ciò che il catalogo esclude non si resuscita
      var gone = v.available === false;
      if (gone && !state.vsold[v.id]) { state.vsold[v.id] = 1; changed = true; }
      else if (!gone && state.vsold[v.id]) { delete state.vsold[v.id]; changed = true; }
    });
    state.vseen[pid] = 1;
    try { sessionStorage.setItem(VSOLD_KEY, JSON.stringify({ sold: state.vsold, seen: state.vseen })); } catch (e2) {}
    return changed;
  }
  function rememberStock(pid, ok) {
    if (state.stock[pid] === ok) return false;
    state.stock[pid] = ok;
    try { sessionStorage.setItem(STOCK_KEY, JSON.stringify(state.stock)); } catch (e) {}
    return true;
  }

  /* Prezzo verificato a runtime (pid -> [prezzo, prezzo_pieno] in cent).
     Stessa storia di `av`, ma peggiore: il 2026-08-12 il Siero Viso era tornato
     da 17,90 a 21,90 e il catalogo lo proponeva ancora scontato, con un 21,90
     BARRATO accanto a 17,90 — cioè un prezzo diverso da quello che il checkout
     addebita, non solo un dato vecchio.
     Si legge dalla STESSA risposta che verifyStock già scarica per lo stock, quindi
     non costa nemmeno una richiesta in più. Il primo paint resta sincrono e senza
     rete (requisito, test P1): la correzione arriva subito dopo.
     Qui si memorizzano SOLO le correzioni vere: se il listino combacia col
     catalogo non si scrive nulla, così non si ridisegna per confermare la
     normalità (è l'errore che avevo fatto con lo stock, test Q6). */
  var PRICE_KEY = 'hn_reco_price';
  state.price = {};
  try {
    var savedPrice = sessionStorage.getItem(PRICE_KEY);
    if (savedPrice) state.price = JSON.parse(savedPrice) || {};
  } catch (e) { state.price = {}; }
  function savePrice() {
    try { sessionStorage.setItem(PRICE_KEY, JSON.stringify(state.price)); } catch (e) {}
  }
  function rememberPrice(pid, pr, cp) {
    var cur = state.price[pid];
    if (cur && cur[0] === pr && cur[1] === cp) return false;
    state.price[pid] = [pr, cp];
    savePrice();
    return true;
  }
  function forgetPrice(pid) {
    if (!state.price[pid]) return false;
    delete state.price[pid];
    savePrice();
    return true;
  }
  var MOBILE_BREAKPOINT = 600; // deve combinare con la media query CSS
  function isMobileViewport() { return window.innerWidth <= MOBILE_BREAKPOINT; }
  // Serializza TUTTE le operazioni sul carrello per evitare race condition.
  var chain = Promise.resolve();
  /* `gen` cresce a ogni operazione sul carrello (nostra o del tema): un controllo in
     sottofondo partito PRIMA e' una fotografia vecchia e va buttato (vedi pollCart). */
  var gen = 0;
  function bump() { gen++; }
  function enqueue(fn) { bump(); return enqueueRaw(fn); }
  function enqueueRaw(fn) {
    chain = chain.then(function () { return fn(); }, function () { return fn(); });
    return chain;
  }
  function isGift(item) {
    var p = item.properties || {};
    return p._hn_gift === 'true' || p._hn_gift === true;
  }
  /* Riga da trattare come OMAGGIO davanti al cliente (dal 2026-10-14): quelle che il motore ha
     marcato — regalo dei 75 €, regalo legato a un prodotto, regali per quantita' dei Kit Viso —
     e qualunque prodotto a 0 € (un omaggio preso a mano dalla sua pagina non ha la marca). Decide
     SOLO cio' che il cliente puo' fare dalla riga: foto e nome aprono l'anteprima informativa e
     mai la pagina prodotto, dove c'e' un «Aggiungi al carrello» a 0 €. Soglie, regali e pulizia
     continuano a guardare isGift: una riga a 0 € di un'altra app NON diventa un nostro regalo. */
  function isGiftLine(item) {
    return isGift(item) || item.original_price === 0;
  }
  // Prezzo "barrato" di un omaggio: il regalo è una variante a pagamento SEPARATA (id
  // diverso), non uno sconto 100% sulla riga — original_line_price è legittimamente 0 e non
  // dice quanto varrebbe. Il valore vero si legge dal gemello a pagamento via EQ (x.eq nel
  // catalogo), la stessa mappa che il recommender usa per non riproporre il regalo appena
  // sbloccato. EQ e D sono popolati più sotto ma referenziati per closure: alla prima
  // chiamata reale (dopo il caricamento del carrello) sono già pronti.
  function giftTwinPrice(item) {
    var twins = EQ[item.product_id] || [];
    var unit = 0;
    twins.forEach(function (id) { var e = D.p[id]; if (e && e.pr > unit) unit = e.pr; });
    return unit ? unit * (item.quantity || 1) : item.original_line_price;
  }
  function isAddon(item) {
    var p = item.properties || {};
    return p._hn_addon === 'true' || p._hn_addon === true;
  }
  // subtotale idoneo alla soglia = tutto TRANNE i regali (importi in cent)
  function qualifyingSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, it) {
      /* il buono regalo non conta: Shopify non lo somma alla soglia della spedizione (provato il
         2026-11-03), e contarlo qui prometteva la spedizione gratuita e, da 75 €, aggiungeva il
         sacchetto omaggio a chi comprava un buono, cioe' un pacco da spedire a sue spese (GC1) */
      return sum + ((isGift(it) || it.gift_card) ? 0 : it.final_line_price);
    }, 0);
  }
  // true se il cliente vede il carrello in una valuta DIVERSA da quella base del negozio.
  // Con Shopify Markets (conversione automatica attiva), /cart.js restituisce gli importi nella
  // valuta di PRESENTAZIONE del cliente (cart.currency), non necessariamente quella del negozio
  // (BOOT.currency = shop.currency). Le soglie configurate dal commerciante (spedizione, regalo,
  // omaggio) sono numeri nella valuta BASE: Shopify non espone al tema/allo storefront un tasso di
  // cambio affidabile, quindi confrontarle direttamente con un totale in un'altra valuta darebbe
  // risultati sbagliati (traguardi segnalati come raggiunti quando non lo sono, o viceversa — e nel
  // caso del regalo automatico, un regalo dato via troppo presto). Meglio disattivare queste
  // funzioni per quella sessione piuttosto che mostrare un progresso sbagliato o regalare qualcosa
  // per errore.
  function isForeignCurrency(cart) {
    return !!(cart && cart.currency && BOOT.currency && cart.currency !== BOOT.currency);
  }

  /* --------------------- misurazione upsell (Layer 4) ---------------------
     Due canali, entrambi marcati con la versione della mappa dati (hn_map),
     così ogni evento/ordine è segmentabile per versione del motore:
     1) dataLayer (GTM già attivo sul tema): view_item_list / select_item /
        add_to_cart con item_list_name e sorgente del suggerimento.
     2) attributo carrello "hn_reco": Shopify lo propaga fino a
        Order.customAttributes -> lega i suggerimenti al fatturato reale.
        È il dato su cui si ricalibrerà il motore (aggiunte/impression).
     Scrittura attributo con debounce e SOLO tramite API.update (_fetch):
     /cart/update.js è tra gli endpoint sorvegliati dai nostri interceptor,
     con window.fetch si innescherebbe un ciclo render->update->render.
     Niente PII; tetto 500 caratteri (gli attributi sono visibili in admin). */
  function mapVersion() {
    return (window.HN_CART_DATA && window.HN_CART_DATA.gen) || 'v0';
  }
  // Prossimo obiettivo NON raggiunto (unione barra premi + tier regalo), in cent.
  // null = nessun obiettivo, tutti raggiunti, o valuta estera (soglie non confrontabili).
  /* Elenco dei traguardi a soglia (spedizione, omaggio), in centesimi e in ordine.
     Una sola definizione per il drawer e per il pacchetto della pagina prodotto,
     che deve sapere QUALI soglie il suo totale fa superare. */
  function goalList() {
    var goals = [];
    if (CFG.rewards && CFG.rewards.enabled) (CFG.rewards.goals || []).forEach(function (g) { goals.push(g); });
    if (CFG.freeGifts && CFG.freeGifts.enabled) (CFG.freeGifts.tiers || []).forEach(function (tr) {
      /* `!tr.triggerProductId`: un regalo legato a un prodotto non e' una tappa — non
         c'e' una soglia da raggiungere, ce l'hai o non ce l'hai.
         ⚠️ Nota verificata con una contro-prova, perche' e' facile raccontarsela:
         TOGLIERE questo filtro oggi non rompe nulla. `tr.threshold` sarebbe undefined
         e `toCents(undefined)` vale 0 (non NaN: `undefined || 0`), ma nextUnmetGoal
         considera solo i traguardi con `amt > q`, e 0 non lo e' mai — quindi la tappa
         verrebbe scartata comunque. Il filtro resta perche' dice l'intenzione e
         perche' e' l'unica difesa se un domani `threshold` prendesse un default
         numerico vero; non e' la correzione di un difetto osservato. */
      if (tr.variantId && !tr.triggerProductId) goals.push({ type: 'gift', amount: tr.threshold, label: tr.title || 'Omaggio' });
    });
    return goals.map(function (g) { return { type: g.type, cents: toCents(g.amount), label: g.label }; })
      .sort(function (a, b) { return a.cents - b.cents; });
  }
  function nextUnmetGoal(cart) {
    if (!cart || isForeignCurrency(cart)) return null;
    var goals = goalList();
    if (!goals.length) return null;
    var q = qualifyingSubtotal(cart), best = null;
    goals.forEach(function (g) {
      var amt = g.cents;
      if (amt > q && (!best || amt < best.amt)) best = { amt: amt, type: g.type, label: g.label };
    });
    return best ? { gapCents: best.amt - q, type: best.type, label: best.label } : null;
  }
  var reco = { impressions: {}, adds: [], lastImpKey: '', lastWritten: '', timer: null, afterHold: false };
  function recoValue(cart) {
    var goal = nextUnmetGoal(cart);
    /* formato 3 (2026-09-10): impression `pid.<n per slot>.s` e aggiunte
       `pid@src:slot`. Nel formato 2 lo slot non c'era, e senza di esso il tasso
       di aggiunta per slot non e' calcolabile a posteriori: la sorgente non lo
       sostituisce, perche' `affinity` e `margin` possono finire in entrambi gli
       slot e solo `complement`/`explore` sono slot 2 per costruzione.
       ⚠️ Le impression si contano PER SLOT (`2-1` = due volte al primo posto,
       una al secondo) e non come totale piu' "l'ultimo slot visto": il drawer
       ridisegna a ogni cambio di carrello e un prodotto CAMBIA slot fra un
       render e l'altro, quindi un solo slot per prodotto darebbe un
       denominatore sbagliato proprio nel confronto fra slot. Verificato: nel
       test H4b il primo prodotto finisce allo slot 1 dopo l'aggiunta.
       Il prefisso di versione serve esattamente a questo: un lettore scritto
       per il 2 sa che quel dato non c'e', invece di dedurlo dall'assenza. */
    var imp = Object.keys(reco.impressions).map(function (pid) {
      var r = reco.impressions[pid];
      return pid + '.' + r.k.join('-') + '.' + r.s;
    });
    function build() {
      return '3;m:' + mapVersion() + '|g:' + (goal ? goal.gapCents : '-') +
        '|i:' + imp.join(',') + (reco.adds.length ? '|a:' + reco.adds.join(',') : '');
    }
    var v = build();
    while (v.length > 500 && imp.length) { imp.shift(); v = build(); } // scarta le impression più vecchie
    return v;
  }
  function writeRecoNow() {
    if (reco.timer) { clearTimeout(reco.timer); reco.timer = null; }
    reco.afterHold = false;
    var cart = state.cart; if (!cart) return;
    var v = recoValue(cart);
    if (v === reco.lastWritten) return; // nessun cambiamento reale -> nessuna richiesta
    reco.lastWritten = v;
    API.update({ attributes: { hn_reco: v } }).catch(function () {});
  }
  function scheduleRecoWrite() {
    if (reco.timer) clearTimeout(reco.timer);
    /* Mentre «Aggiunto ✓» tiene fermi i consigliati (UPSELL_HOLD) la scrittura aspetta il
       loro ridisegno e parte subito dopo, nello stesso istante in cui partiva prima: l'aggiunta
       e le impression che ne seguono restano UNA scrittura. Senza, la prima arrivava senza le
       impression nuove e una seconda le aggiungeva 1,2 s dopo (H4b, PP9). Se il ridisegno non
       arrivasse, il timer qui sotto scrive comunque. */
    var hold = state.upsellHold - Date.now();
    reco.afterHold = hold > 0;
    reco.timer = setTimeout(writeRecoNow, hold > 0 ? hold + 1200 : 1200);
  }
  function upsellSource(p) { return (p && p.__hnSrc) || 'legacy'; }
  /* Prodotti che la PAGINA PRODOTTO ha mostrato nel viewport senza che il
     cliente li aggiungesse, letti dal log di sessione che scrivono i blocchi
     hn-pdp. Serve solo al drawer, e solo con `seenPenalty > 0` (oggi 0), quindi
     in fase 1 questa funzione non viene mai chiamata: vedi tools/hn-pdp.md §5. */
  function seenFromPdpLog() {
    try {
      var raw = sessionStorage.getItem('hn_pdp'); if (!raw) return null;
      var log = JSON.parse(raw); if (!log || !log.i) return null;
      var out = {}, aggiunti = {};
      (log.a || []).forEach(function (r) { aggiunti[String(r.p)] = true; });
      Object.keys(log.i).forEach(function (pid) { if (!aggiunti[pid]) out[pid] = true; });
      return out;
    } catch (e) { return null; }
  }
  /* Fotografia minima del carrello. Serve al PRIMO disegno dei blocchi della
     pagina prodotto, che deve essere sincrono e senza rete (stessa regola di P1
     per il drawer): senza, la prima pagina prodotto della navigazione
     classificherebbe su un carrello vuoto e ridisegnerebbe appena arriva quello
     vero — cioè un salto visibile proprio sotto il pulsante d'acquisto.
     Solo i campi che il motore legge; nessun dato personale. */
  var CART_SNAP_KEY = 'hn_cart_snap';
  function saveCartSnapshot(cart) {
    try {
      sessionStorage.setItem(CART_SNAP_KEY, JSON.stringify({
        t: Date.now(), token: cart.token || '', currency: cart.currency || '',
        items: (cart.items || []).map(function (i) {
          return { product_id: i.product_id, variant_id: i.variant_id, handle: i.handle,
                   quantity: i.quantity, final_line_price: i.final_line_price,
                   final_price: i.final_price, properties: i.properties || null };
        })
      }));
    } catch (e) {}
  }
  function readCartSnapshot() {
    try {
      var raw = sessionStorage.getItem(CART_SNAP_KEY); if (!raw) return null;
      var s = JSON.parse(raw);
      return (s && s.items) ? s : null;
    } catch (e) { return null; }
  }
  /* Attributo carrello per i moduli fuori dal drawer (la pagina prodotto scrive
     `hn_pdp`). Invia SOLO la propria chiave: l'AJAX cart fa merge degli
     attributi, quindi `hn_reco` e `hn_ab` non vengono toccati — è la stessa
     regola che tiene separati quei due. */
  /* ⚠️ Si scrive SOLO su un carrello con almeno un articolo (non si crea un
     carrello a chi rimbalza). Finché è vuoto il valore resta IN ATTESA in
     sessionStorage e parte alla prima render con articoli, su QUALUNQUE pagina.
     Difetto vero del 2026-10-01: hn-pdp.js vive solo sulle pagine prodotto, e
     chi le guardava col carrello vuoto e poi aggiungeva dalla griglia arrivava
     al checkout senza `hn_pdp` — impressioni perse proprio di chi non aggiunge
     dal blocco, cioè il denominatore. Test PD46. */
  var ATTR_PENDING_KEY = 'hn_attr_pending';
  var attrTimers = {}, attrLast = {};
  function pendingAttrs() {
    try { var p = JSON.parse(sessionStorage.getItem(ATTR_PENDING_KEY) || 'null'); return (p && typeof p === 'object') ? p : {}; }
    catch (e) { return {}; }
  }
  function savePendingAttrs(p) {
    try {
      if (Object.keys(p).length) sessionStorage.setItem(ATTR_PENDING_KEY, JSON.stringify(p));
      else sessionStorage.removeItem(ATTR_PENDING_KEY);
    } catch (e) {}
  }
  function settleAttr(key, value) {
    var p = pendingAttrs(); if (p[key] === value) { delete p[key]; savePendingAttrs(p); }
  }
  function cartHasItems() { return !!(state.cart && state.cart.item_count > 0); }
  function setAttribute(key, value) {
    if (!key || attrLast[key] === value) return;
    var p = pendingAttrs(); p[key] = value; savePendingAttrs(p);
    if (attrTimers[key]) clearTimeout(attrTimers[key]);
    attrTimers[key] = setTimeout(function () {
      attrTimers[key] = null;
      if (!cartHasItems()) return;      // carrello vuoto: resta in attesa
      if ((state.cart.attributes || {})[key] === value) { attrLast[key] = value; settleAttr(key, value); return; }
      attrLast[key] = value;
      var payload = {}; payload[key] = value;
      API.update({ attributes: payload })
        .then(function () { settleAttr(key, value); })
        .catch(function () { attrLast[key] = null; });
    }, 1200);
  }
  function flushPendingAttrs() {
    if (!cartHasItems()) return;
    var p = pendingAttrs();
    Object.keys(p).forEach(function (k) { if (attrLast[k] !== p[k]) setAttribute(k, p[k]); });
  }
  /* Sorgente in 1 carattere, per stare nel tetto di 500 char dell'attributo.
     Mappa esplicita + fallback alla prima lettera: regge anche sorgenti nuove. */
  var SRC_CODE = { affinity: 'a', margin: 'm', explore: 'e', related: 'r',
                   crosssell: 'c', complement: 'x', legacy: 'l', pin: 'p' };
  function srcCode(src) { return SRC_CODE[src] || String(src || '?').charAt(0); }
  // Registra le impression di un set mostrato (dedup su carrello+set: il poll
  // da 1.5s ridisegna spesso lo stesso stato, non deve gonfiare i numeri).
  function noteImpressions(products, cart) {
    if (!products || !products.length) return;
    var key = cartSignature(cart) + '::' + products.map(function (p) { return p.id; }).join(',');
    if (key === reco.lastImpKey) return;
    reco.lastImpKey = key;
    products.forEach(function (p, slot) {
      /* {k: [quante volte in ciascuno slot], s: sorgente dell'ultimo render}.
         `products` e' gia' in ordine di slot: lo stesso indice che finisce in
         `index` nelle righe del dataLayer qui sotto, e in `upsellMeta` quando
         il cliente clicca — cosi' numeratore e denominatore del tasso per slot
         vengono dalla stessa fonte. */
      var cur = reco.impressions[p.id] || { k: [], s: '' };
      while (cur.k.length <= slot) cur.k.push(0);
      cur.k[slot]++;
      cur.s = srcCode(upsellSource(p));
      reco.impressions[p.id] = cur;
    });
    var goal = nextUnmetGoal(cart);
    var righe = products.map(function (p, i) {
      return { item_id: String(p.id), item_name: p.title,
               price: (p.price != null ? p.price : (p.price_min || 0)) / 100,
               index: i,
               item_list_id: 'hn-cart-upsell', item_list_name: 'hn_cart_upsell',
               hn_source: upsellSource(p) };
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    track('hn_view_item_list', {
      item_list_id: 'hn-cart-upsell', item_list_name: 'hn_cart_upsell',
      hn_map: mapVersion(), hn_gap_cents: goal ? goal.gapCents : null, hn_goal: goal ? goal.type : null,
      items: righe,                 // retrocompatibile: c'era prima, non si toglie
      ecommerce: { items: righe }   // forma GA4, la stessa degli altri eventi
    });
    scheduleRecoWrite();
  }
  // Metadati di attribuzione per un'aggiunta partita da una card upsell.
  function upsellMeta(p, idx) {
    var goal = nextUnmetGoal(state.cart);
    var price = p.price != null ? p.price : (p.price_min || 0);
    return {
      item_list_id: 'hn-cart-upsell', item_list_name: 'hn_cart_upsell',
      index: idx || 0, product_id: p.id, price: price / 100,
      hn_source: upsellSource(p), hn_map: mapVersion(),
      hn_gap_cents: goal ? goal.gapCents : null,
      hn_crosses_threshold: !!(goal && price >= goal.gapCents)
    };
  }
  function noteRecoAdd(meta) {
    if (!meta || meta.product_id == null) return;
    /* `hn_reco` è il registro del DRAWER e basta. Un'aggiunta partita dalla
       pagina prodotto ha la sua lista e il suo attributo (`hn_pdp`):
       registrarla anche qui la conterebbe due volte e falserebbe proprio il
       tasso per slot su cui si tara il carrello. */
    if (meta.item_list_id !== 'hn-cart-upsell') return;
    reco.adds.push(meta.product_id + '@' + (meta.hn_source || 'x') + ':' + (meta.index || 0));
    if (reco.adds.length > 12) reco.adds.shift();
    scheduleRecoWrite();
  }

  /* ---------------- prezzi "di partenza" (compare-at, per i saldi) ----------------
     cart.js non espone il compare_at_price: lo recuperiamo una volta per handle
     da /products/{handle}.js e lo teniamo in cache per la sessione. */
  var productCache = {}; // handle -> { variantId: compare_at_price_cents }
  /* ⚡ 2026-10-08 («ci vogliono almeno due secondi prima che lo apre»). Questa scheda
     e' l'unico dato che il disegno della riga aspetta, e prima si chiedeva DOPO la
     rilettura del carrello: due giri di rete in fila prima di vedere il prodotto
     appena aggiunto. Ora (1) si ricorda per la sessione, quindi una pagina nuova non
     la richiede per ogni riga del carrello; (2) la richiesta e' la stessa delle
     verifiche (productFull, una per pagina e condivisa mentre e' in volo) e (3) per
     un'aggiunta parte quando PARTE l'aggiunta (variante -> scheda, dal catalogo) o al
     piu' tardi alla sua risposta, in parallelo alla rilettura del carrello. Il disegno
     resta quello di prima: aspetta il dato vero. */
  var CMP_KEY = 'hn_cart_cmp';
  try {
    var savedCmp = JSON.parse(sessionStorage.getItem(CMP_KEY) || 'null');
    if (savedCmp && typeof savedCmp === 'object') productCache = savedCmp;
  } catch (e) { productCache = {}; }
  function productData(h) {
    if (!h || productCache[h] !== undefined) return Promise.resolve();
    // la STESSA richiesta delle verifiche (productFull): una sola /products/<handle>.js per pagina
    return productFull(h).then(function (p) {
      var map = {};
      if (p && p.variants) p.variants.forEach(function (v) { map[v.id] = v.compare_at_price || 0; });
      productCache[h] = map;
      if (p && p.variants) {
        try { sessionStorage.setItem(CMP_KEY, JSON.stringify(productCache)); } catch (e) {}
      }
    });
  }
  function ensureProductData(cart) {
    var handles = [];
    (cart.items || []).forEach(function (it) {
      if (it.handle && productCache[it.handle] === undefined && handles.indexOf(it.handle) < 0) handles.push(it.handle);
    });
    if (!handles.length) return Promise.resolve(cart);
    return Promise.all(handles.map(productData)).then(function () { return cart; });
  }
  // la scheda di una VARIANTE (aggiunta appena partita): dal catalogo all'handle
  function prefetchVariant(variantId) {
    var id = String(variantId || '');
    if (!id || !D || !D.p) return;
    Object.keys(D.p).some(function (pid) {
      var e = D.p[pid];
      var hit = String(e.vid) === id || (e.vs || []).some(function (v) { return String(v.id) === id; });
      if (hit && e.h) productData(e.h);
      return hit;
    });
  }
  function compareAtUnit(it) { // prezzo pieno unitario in cent (0 se il prodotto non è in saldo)
    var m = productCache[it.handle];
    return (m && m[it.variant_id]) || 0;
  }

  /* Attributo `hn_gift_err`: la memoria fuori dal browser di un regalo rifiutato.
     Debounce e skip-se-invariato come lo scrittore di `hn_reco`, e manda SOLO la
     propria chiave, cosi' convive con `hn_reco` e `hn_ab` (Shopify fonde per chiave).
     Deve passare da API.update, cioe' da `_fetch`: /cart/update.js e' intercettato. */
  var giftErr = { valore: '', scritto: '', timer: null };
  function noteGiftError(tier) {
    var voce = (tier.variantId || '?') + '@' + (tier.triggerProductId ? 'p' + tier.triggerProductId + (tier.triggerMinQty > 1 ? 'x' + tier.triggerMinQty : '') : 's' + tier.threshold);
    if (giftErr.valore.indexOf(voce) === -1) {
      giftErr.valore = (giftErr.valore ? giftErr.valore + ',' : '') + voce;
    }
    if (giftErr.timer) clearTimeout(giftErr.timer);
    giftErr.timer = setTimeout(function () {
      giftErr.timer = null;
      if (!state.cart || giftErr.valore === giftErr.scritto) return;
      giftErr.scritto = giftErr.valore;
      API.update({ attributes: { hn_gift_err: giftErr.valore.slice(0, 200) } }).catch(function () {});
    }, 1200);
  }

  /* --------------------- REGALI: riconciliazione auto --------------------- */
  // Aggiunge/rimuove i regali in base al subtotale idoneo. Ritorna il carrello aggiornato.
  var giftFailed = {}; // variantId -> true : regalo esaurito/non acquistabile, non ritentare in questa sessione
  /* Diagnostica dei regali (?hncartdebug=1), nata dal difetto del 2026-09-18: il
     dopobarba innescato dal Kit non arrivava MAI in carrello, con la configurazione
     giusta, il prodotto acquistabile e i due tier regolarmente costruiti — e senza un
     solo errore da nessuna parte. Un tier che non scatta e' invisibile, quindi qui si
     registra la DECISIONE per ogni tier (spetta? c'e' gia'? l'aggiunta e' stata
     rifiutata?) e non il risultato finale: la domanda e' DOVE si perde. */
  var giftDbg = { motivo: 'mai eseguito', righe: [] };
  function reconcileGifts(cart) {
    if (isForeignCurrency(cart)) {
      giftDbg = { motivo: 'valuta estera (' + cart.currency + '): non si tocca niente', righe: [] };
      return Promise.resolve(cart); // soglia in valuta base: non confrontabile in modo affidabile in un'altra valuta
    }
    /* ⚠️ NON si esce presto quando i tier mancano: se un regalo e' stato spento (o il
       suo prodotto innesco cambiato) mentre qualcuno lo aveva in carrello, quella riga
       resta ORFANA — e un regalo non ha il pulsante per rimuoverlo (lockQuantity),
       quindi il cliente non puo' togliersela. E' successo davvero il 2026-09-18,
       spegnendo `giftproduct_enabled`: il dopobarba e' rimasto nel carrello fino al
       checkout. La pulizia sotto e' la ragione per cui si arriva fino in fondo. */
    var attivo = !!(CFG.freeGifts && CFG.freeGifts.enabled);
    var tiers = attivo ? (CFG.freeGifts.tiers || []).filter(function (x) { return x.variantId; }) : [];
    giftDbg = {
      motivo: !attivo ? 'modulo regali spento: si rimuovono gli orfani'
        : (tiers.length ? tiers.length + ' tier valutati'
          : 'nessun tier con variantId: le impostazioni non sono arrivate al motore'),
      righe: []
    };

    var qualifying = qualifyingSubtotal(cart);
    var toAdd = [], updates = {}; // updates: key -> quantità

    /* Quanti pezzi di un prodotto ci sono, sommando le righe (lo stesso prodotto puo'
       stare su piu' righe, con proprieta' diverse). Le righe che sono a loro volta
       regali non contano: un omaggio non deve innescarne un altro a catena. */
    function pezziDi(pid) {
      return (cart.items || []).reduce(function (n, it) {
        return n + (!isGift(it) && String(it.product_id) === String(pid) ? (it.quantity || 0) : 0);
      }, 0);
    }

    /* UNA decisione per VARIANTE regalata, non per tier (dal 2026-10-13): due regole
       possono regalare lo stesso prodotto — il dopobarba col Kit Cura della Pelle e coi
       3 Kit Viso. Decise una alla volta, quella che non spetta toglieva la riga che
       l'altra aveva appena tenuto. La variante spetta se la merita ALMENO una regola,
       e la riga porta in `_hn_tier` la regola che l'ha meritata. */
    var perVariante = {}, ordine = [];
    tiers.forEach(function (tier) {
      /* ⚠️ Il regalo a prodotto NON guarda il subtotale: guarda quanti pezzi di quel
         prodotto ci sono (almeno uno, o la quantita' minima del tier). Il confronto e'
         fra `product_id`, non fra variante, perche' la promessa e' sul PRODOTTO
         ("compri il Kit") e un domani potrebbe avere piu' varianti. */
      var merita = tier.triggerProductId
        ? pezziDi(tier.triggerProductId) >= (tier.triggerMinQty || 1)
        : qualifying >= toCents(tier.threshold);
      var k = String(tier.variantId);
      var pv = perVariante[k];
      if (!pv) { pv = perVariante[k] = { tier: tier, merita: false, togli: false }; ordine.push(k); }
      if (merita && !pv.merita) pv.tier = tier;
      pv.merita = pv.merita || merita;
      /* Tolto il prodotto che lo innescava, il regalo se ne va con lui: lasciarlo
         regalerebbe un articolo che nessuno si e' piu' meritato. Per i tier a soglia
         resta valida l'impostazione autoRemoveBelow. */
      if (tier.triggerProductId || CFG.freeGifts.autoRemoveBelow) pv.togli = true;
      giftDbg.righe.push({
        etichetta: tier.title || '?',
        innesco: tier.triggerProductId
          ? 'prodotto ' + tier.triggerProductId + (tier.triggerMinQty > 1 ? ' da ' + tier.triggerMinQty + ' pezzi (ora ' + pezziDi(tier.triggerProductId) + ')' : '')
          : 'soglia ' + tier.threshold + ' (q=' + qualifying + ')',
        variante: tier.variantId,
        merita: merita
      });
    });

    ordine.forEach(function (k) {
      var pv = perVariante[k];
      /* La riga del regalo si riconosce dalla VARIANTE, non dalla marca `_hn_gift`.
         ⛔ Con la sola marca, un omaggio a 0 € aggiunto A MANO dalla sua pagina
         prodotto (gli omaggi sono prodotti pubblici, con un URL loro) era
         invisibile qui: sopra soglia il motore ne aggiungeva un SECONDO, sotto soglia
         restava gratis senza aver raggiunto il traguardo. Trovato il 2026-09-28 in un
         checkout abbandonato vero, con la riga del regalo senza proprieta'.
         La variante di un tier E' il nostro regalo per configurazione, chiunque
         l'abbia messa in carrello; se le righe sono piu' d'una se ne tiene UNA,
         preferendo quella marcata (si disegna come omaggio, bloccata).
         La marca resta invece obbligatoria per la pulizia degli orfani qui sotto:
         li' si toglie una riga che nessun tier rivendica, e senza marca non si
         puo' sapere che e' nostra. */
      var copie = (cart.items || []).filter(function (it) {
        return String(it.variant_id) === k;
      });
      var line = copie.filter(isGift)[0] || copie[0] || null;
      copie.forEach(function (it) { if (it !== line) updates[it.key] = 0; });
      giftDbg.righe.forEach(function (r) {
        if (String(r.variante) !== k) return;
        r.giaPresente = !!line;
        r.aMano = !!line && !isGift(line);
        r.doppioni = copie.length > 1 ? copie.length - 1 : 0;
        r.esito = r.merita
          ? (line ? 'gia in carrello' : (giftFailed[k] ? 'BLOCCATO: aggiunta gia fallita in questa sessione' : 'da aggiungere'))
          : (pv.merita ? 'non spetta per questa regola, ma lo regala un\'altra' : 'non spetta');
      });
      if (pv.merita) {
        if (!line && !giftFailed[k]) toAdd.push(pv.tier);
        else if (line && CFG.freeGifts.lockQuantity && line.quantity !== 1) updates[line.key] = 1;
      } else if (line && pv.togli) {
        updates[line.key] = 0;
      }
    });

    /* Orfani: righe marcate come nostro regalo che NESSUN tier attuale rivendica.
       Succede quando un regalo viene spento, quando cambia il suo prodotto innesco,
       o quando cambia la variante regalata. Vanno tolte, altrimenti restano in
       carrello per sempre e il cliente non ha il pulsante per farlo. */
    var rivendicate = {};
    tiers.forEach(function (t) { rivendicate[String(t.variantId)] = true; });
    var orfani = 0;
    (cart.items || []).forEach(function (it) {
      if (!isGift(it)) return;
      if (rivendicate[String(it.variant_id)]) return;
      if (updates[it.key] !== undefined) return;
      updates[it.key] = 0;
      orfani++;
    });
    if (orfani) giftDbg.orfani = orfani;

    // niente da fare: evita GET/POST inutili
    if (!toAdd.length && !Object.keys(updates).length) return Promise.resolve(cart);

    var ops = Promise.resolve();
    if (Object.keys(updates).length) ops = ops.then(function () { return API.update({ updates: updates }); });
    // aggiunte (una alla volta, con la proprietà che marca il regalo)
    toAdd.forEach(function (tier) {
      /* la riga di diagnostica di QUESTO tier, per scriverci l'esito dell'aggiunta:
         e' l'unico punto in cui si vede un rifiuto di /cart/add.js, che altrimenti
         viene inghiottito da giftFailed senza lasciare traccia */
      var dbgRiga = null;
      giftDbg.righe.forEach(function (r) { if (String(r.variante) === String(tier.variantId)) dbgRiga = r; });
      ops = ops.then(function () {
        return API.add([{
          id: parseInt(tier.variantId, 10), quantity: 1,
          /* `_hn_tier` finisce negli ordini e serve a capire QUALE regola ha regalato:
             per i tier a soglia il valore in euro, per quelli a prodotto l'id
             dell'innesco. Prima scriveva la stringa "undefined" per i secondi. */
          properties: {
            _hn_gift: 'true',
            _hn_tier: tierTag(tier)
          }
        }]).then(function (res) {
          if (res && res.status) {
            giftFailed[tier.variantId] = true; // esaurito/non acquistabile
            if (dbgRiga) dbgRiga.esito = 'RIFIUTATO da /cart/add.js (' + res.status + '): ' + (res.description || res.message || '');
            /* ⛔ Un regalo rifiutato era INVISIBILE: giftFailed lo inghiottiva e nessuno
               lo sapeva — e' cosi' che il dopobarba e' mancato in 7 ordini per tre
               settimane. Ora lascia due tracce: un evento nel dataLayer e un attributo
               sul carrello, che finisce nell'ordine e si interroga con una query. */
            track('hn_gift_failed', {
              variant_id: tier.variantId, hn_gift_title: tier.title || '',
              hn_gift_reason: (res.description || res.message || res.status) + ''
            });
            noteGiftError(tier);
          } else {
            if (dbgRiga) dbgRiga.esito = 'aggiunto';
            track('hn_gift_unlocked', { variant_id: tier.variantId, threshold: tier.threshold });
          }
          return res;
        }).catch(function () {
          giftFailed[tier.variantId] = true;
          if (dbgRiga) dbgRiga.esito = 'errore di rete sull aggiunta';
          return null;
        });
      });
    });
    return ops.then(function () { return API.get(); });
  }

  /* --------------------------- refresh + render --------------------------- */
  // "firma" leggera del carrello, per capire se è cambiato qualcosa senza confrontare l'intero oggetto
  function cartSig(cart) { return cart ? (cart.token + '|' + cart.item_count + '|' + cart.total_price + '|' + (cart.items || []).length) : ''; }

  function refresh(opts) {
    opts = opts || {};
    return enqueue(function () {
      setBusy(true);
      tlMark('rilettura del carrello: tocca a lei');
      return API.get()
        .then(function (cart) { return coReconcileCodes(cart); })
        .then(function (cart) { return reconcileCart(cart); })
        .then(function (cart) { return ensureProductData(cart); })
        .then(function (cart) {
          state.cart = cart;
          state.lastSig = cartSig(cart);
          poll.last = Date.now(); // carrello appena letto: il prossimo controllo puo' aspettare
          render();
          syncNativeBubble(cart);
          setBusy(false);
          tlMark('carrello disegnato');
          if (opts.fromAdd) endExternalAdd();
          if (opts.open) openDrawer();
          if (state.viewPending && !state.adding) { state.viewPending = false; if (state.open) trackViewCart(); }
          return cart;
        })
        .catch(function (e) {
          setBusy(false);
          if (opts.fromAdd) endExternalAdd();
          if (state.viewPending && !state.adding) { state.viewPending = false; if (state.open) trackViewCart(); }
          console && console.warn && console.warn('[hn-cart]', e);
        });
    });
  }

  /* --------------------------- polling di sicurezza ---------------------------
     L'aggiornamento "in tempo reale" dipende dall'intercettare fetch/XHR delle
     chiamate al carrello: se un'ALTRA app della pagina modifica window.fetch DOPO
     di noi senza richiamare la versione precedente (capita con più app installate
     insieme), la nostra intercettazione può non vedere quella mutazione e la barra
     resta ferma. Questo controllo leggero è una rete di sicurezza indipendente.

     ⛔ Fino al 2026-10-08 era una lettura del carrello ogni 1,5 s, su ogni pagina e
     anche a carrello chiuso, messa IN CODA con le operazioni del cliente. Misurato con
     la rete lenta: un'aggiunta aspettava che finisse la lettura in volo e poi ne
     faceva un'altra (carrello aperto dopo 4,4 s invece di 2,7), e se una lettura
     durava piu' di 1,5 s le successive si accodavano una dietro l'altra. Ora:
       - FUORI dalla coda: un'operazione del cliente non aspetta mai un controllo;
       - una lettura alla volta, e un controllo partito prima di un'operazione si
         butta (`gen`), perche' e' una fotografia vecchia;
       - ogni 1,5 s solo a carrello APERTO, ogni 10 s da chiuso, mai a pagina
         nascosta; in piu' quando la pagina torna visibile (altra scheda, ritorno
         con «indietro») e all'apertura del carrello;
       - una lettura che non risponde in 8 s si abbandona. */
  var POLL_OPEN = 1500, POLL_CLOSED = 10000;
  var poll = { busy: false, last: 0 };
  function startPolling() {
    poll.last = Date.now(); // la rilettura dell'avvio vale come primo controllo
    setInterval(function () {
      if (document.hidden) return;
      if (Date.now() - poll.last < (state.open ? POLL_OPEN : POLL_CLOSED)) return;
      pollCart();
    }, 250); // passo fine: a carrello aperto il ritmo resta 1,5 s come prima, non 1,5 + mezzo passo
    document.addEventListener('visibilitychange', function () { if (!document.hidden) pollCart(); });
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) pollCart(); });
  }
  function pollCart() {
    if (poll.busy || state.busy || state.adding) return;
    poll.busy = true; poll.last = Date.now();
    var g = gen, t0 = tnow();
    var ctl = null;
    try { ctl = typeof AbortController === 'function' ? new AbortController() : null; } catch (e) { ctl = null; }
    var scaduto = false;
    var timer = setTimeout(function () {
      scaduto = true; poll.busy = false;
      try { if (ctl) ctl.abort(); } catch (e) {}
    }, 8000);
    API.get({ signal: ctl ? ctl.signal : null }).then(function (cart) {
      clearTimeout(timer);
      if (scaduto) return;
      poll.busy = false;
      if (HN_DEBUG) { tl.polls++; tl.ultimoPoll = Math.round(tnow() - t0); }
      if (!cart || !cart.items) return;
      if (g !== gen || state.busy) { if (HN_DEBUG) { tl.scartati++; tlPaint(); } return; }
      if (cartSig(cart) === state.lastSig) { if (HN_DEBUG) tlPaint(); return; } // nessuna variazione reale -> non ridisegnare
      return enqueueRaw(function () {
        if (g !== gen) return;              // nel frattempo e' partita un'operazione: ci pensa lei
        setBusy(true);
        return reconcileCart(cart)
          .then(function (c2) { return ensureProductData(c2); })
          .then(function (c2) {
            state.cart = c2; state.lastSig = cartSig(c2);
            render(); syncNativeBubble(c2); setBusy(false);
          }, function () { setBusy(false); });
      });
    }, function () { clearTimeout(timer); if (!scaduto) poll.busy = false; });
  }

  function setBusy(v) { state.busy = v; if (els.root) els.root.classList.toggle('is-busy', v); }

  /* ------------------------------ DOM build ------------------------------ */
  var els = {};
  function buildDOM() {
    var ds = CFG.design || {};
    var root = document.createElement('div');
    root.className = 'hn-cart';
    root.id = 'hn-cart';
    root.setAttribute('data-pos', ds.position === 'left' ? 'left' : 'right');
    root.style.cssText =
      '--hn-width:' + (ds.width || 420) + 'px;' +
      '--hn-accent:' + ACCENT + ';' +
      '--hn-accent-text:' + ACCENT_TEXT + ';' +
      '--hn-progress:' + PROGRESS + ';' +
      '--hn-bg:' + (ds.bg || '#fff') + ';' +
      '--hn-text:' + (ds.text || '#111') + ';' +
      '--hn-muted:' + (ds.muted || '#6b7280') + ';' +
      '--hn-success:' + SUCCESS + ';' +
      '--hn-radius:' + (ds.radius || 12) + 'px;' +
      '--hn-overlay:' + (ds.overlay || 'rgba(17,17,17,.45)') + ';';
    root.innerHTML =
      '<div class="hn-cart__overlay" data-hn-close></div>' +
      '<aside class="hn-cart__panel" role="dialog" aria-modal="true" aria-label="' + esc(t('title')) + '">' +
        (CFG.announcement ? '<div class="hn-cart__ann">' + esc(CFG.announcement) + '</div>' : '') +
        '<div class="hn-cart__head">' +
          '<h2 class="hn-cart__title">' + esc(t('title')) + '</h2>' +
          '<button class="hn-cart__close" data-hn-close aria-label="Chiudi">&times;</button>' +
        '</div>' +
        (urgencyEnabled() ? '<div class="hn-cart__urgency" data-hn-urgency>' + renderUrgency() + '</div>' : '') +
        '<div class="hn-cart__rewards" data-hn-rewards></div>' +
        '<div class="hn-cart__body" data-hn-body></div>' +
        '<div class="hn-cart__foot" data-hn-foot></div>' +
        '<div class="hn-pop" data-hn-pop><div class="hn-pop__bg" data-hn-pop-close></div>' +
          '<div class="hn-pop__card" role="dialog" aria-modal="true" data-hn-pop-card></div></div>' +
      '</aside>';
    document.body.appendChild(root);
    els.root = root;
    els.panel = root.querySelector('.hn-cart__panel');
    els.rewards = root.querySelector('[data-hn-rewards]');
    els.body = root.querySelector('[data-hn-body]');
    els.foot = root.querySelector('[data-hn-foot]');
    els.pop = root.querySelector('[data-hn-pop]');
    els.popCard = root.querySelector('[data-hn-pop-card]');
    // regione aria-live SEPARATA dal drawer (che è display:none da chiuso): così gli annunci
    // (es. "esaurito" dallo sticky ATC) restano leggibili dagli screen reader anche a drawer chiuso
    var live = document.createElement('div');
    live.className = 'hn-cart__live';
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
    els.live = live;
    bindStaticEvents();
    startUrgency(); // sotto il titolo: indipendente dal contenuto del carrello, parte una volta sola al montaggio
  }

  function announce(msg) { if (els.live) els.live.textContent = msg; }

  /* ------------------------------ RENDER ------------------------------ */
  var lastBroadcast = '';
  function render() {
    var cart = state.cart; if (!cart || !els.root) return;
    renderRewards(cart);
    renderBody(cart);
    renderFoot(cart);
    if (HN_DEBUG) reportGiftDebug(); // dopo renderBody, che riscrive il corpo
    /* Fotografia + annuncio del cambiamento, per i moduli fuori dal drawer.
       ⚠️ Solo quando il carrello è DAVVERO cambiato: `render()` viene chiamata
       anche dal polling ogni 1,5 s, e un evento a ogni giro farebbe ricalcolare
       la pagina prodotto di continuo per nulla. La firma include quantità e
       totale, non solo il set di prodotti, perché cambiare quantità sposta il
       gap verso la soglia. */
    var firma = cartSignature(cart) + '|' + (cart.item_count || 0) + '|' + (cart.total_price || 0);
    if (firma === lastBroadcast) return;
    lastBroadcast = firma;
    saveCartSnapshot(cart);
    flushPendingAttrs();
    try {
      document.dispatchEvent(new CustomEvent('hn:cart:changed', { detail: { sig: firma, cart: cart } }));
    } catch (e) {}
  }

  function renderRewards(cart) {
    if (!(CFG.rewards && CFG.rewards.enabled) || !(CFG.rewards.goals || []).length) { els.rewards.innerHTML = ''; return; }
    // soglie configurate in valuta BASE: in un'altra valuta (Markets) il confronto non è
    // affidabile senza un tasso di cambio — meglio non mostrare un progresso sbagliato.
    if (isForeignCurrency(cart)) { els.rewards.innerHTML = ''; return; }
    var goals = CFG.rewards.goals.slice().sort(function (a, b) { return a.amount - b.amount; });
    var qualifying = qualifyingSubtotal(cart);
    var N = goals.length;

    // TAPPE EQUIDISTANTI: l'obiettivo i sta a ((i+1)/N)*100% (2 obiettivi -> 50% e 100%),
    // a prescindere dagli euro. Il riempimento è proporzionale DENTRO ogni segmento.
    function goalPos(i) { return ((i + 1) / N) * 100; }
    var prev = 0, filled = 100;
    for (var i = 0; i < N; i++) {
      var amt = toCents(goals[i].amount);
      if (qualifying < amt) {
        var within = (amt - prev) > 0 ? (qualifying - prev) / (amt - prev) : 0;
        filled = (i + Math.max(0, Math.min(1, within))) * (100 / N);
        break;
      }
      prev = amt;
    }
    var pct = Math.max(0, Math.min(100, filled));

    // la barra diventa verde una volta raggiunta la SPEDIZIONE gratuita (o l'ultimo obiettivo se non c'è)
    var shipGoal = null;
    goals.forEach(function (g) { if (g.type === 'shipping' && shipGoal == null) shipGoal = g; });
    var greenReached = shipGoal ? (qualifying >= toCents(shipGoal.amount)) : (qualifying >= toCents(goals[N - 1].amount));

    // prossimo obiettivo non raggiunto -> messaggio
    var next = null;
    for (var j = 0; j < N; j++) { if (qualifying < toCents(goals[j].amount)) { next = goals[j]; break; } }
    var msg;
    if (!next) {
      // tutti gli obiettivi raggiunti: se l'ultimo è il regalo, mostra il messaggio dedicato (come MonsterCart)
      var last = goals[N - 1];
      msg = last.type === 'gift' ? t('giftReached', { label: last.label })
          : last.type === 'shipping' ? t('shippingReached')
          : t('allGoalsReached');
    } else {
      var gapCents = toCents(next.amount) - qualifying;
      var diff = money(gapCents);
      /* il terzo argomento e' il divario: da li' t() decide se dire «solo» (vedi withOnlyWord) */
      msg = next.type === 'shipping' ? t('shippingProgress', { amount: diff }, gapCents)
          : next.type === 'gift'     ? t('giftProgress', { amount: diff }, gapCents)
          :                            t('goalProgress', { amount: diff, label: next.label }, gapCents);
    }

    function edgeClass(pos) { return pos <= 3 ? ' at-start' : (pos >= 97 ? ' at-end' : ''); }
    // display:block!important inline: i trattini sono <span> VUOTI e la stessa regola ":empty" del
    // tema che nascondeva il riempimento nasconderebbe anche loro. L'inline !important li protegge.
    var ticks = goals.map(function (g, i) {
      var pos = goalPos(i), r = qualifying >= toCents(g.amount);
      return '<span class="hn-cart__tick' + (r ? ' is-reached' : '') + edgeClass(pos) + '" style="left:' + pos + '%;display:block !important"></span>';
    }).join('');
    var goalLabels = goals.map(function (g, i) {
      var pos = goalPos(i), r = qualifying >= toCents(g.amount);
      /* A traguardo raggiunto l'etichetta puo' diventare una frase di conferma
         ("Hai ottenuto la Spedizione Gratuita"). ⚠️ NON si tocca g.label: quello e' usato anche
         da giftReached ("Hai sbloccato un {label}") e da goalProgress.
         La classe has-reached-text serve al CSS per riposizionarla: `is-reached` non basta,
         perche' ce l'ha anche "Omaggio" a traguardo, che resta corto e centrato sul trattino. */
      var lungo = r && g.labelReached;
      var testo = lungo ? g.labelReached : g.label;
      return '<span class="hn-cart__goal' + (r ? ' is-reached' : '') + (lungo ? ' has-reached-text' : '') +
        edgeClass(pos) + '" style="left:' + pos + '%">' + esc(testo) + '</span>';
    }).join('');

    /* Animazione "carica ancora" (riflesso che scorre nel riempimento): va accesa finche' c'e'
       qualcosa da guadagnare.
       ⚠️ `is-complete` NON e' il segnale giusto: scatta gia' alla spedizione gratuita (49 €) mentre
       la barra e' al 50% e l'omaggio e' ancora da prendere — cioe' proprio quando l'invito serve.
       Si esclude anche pct == 0, per non animare un elemento a larghezza zero. */
    var riempimentoInCorso = pct > 0 && pct < 100;

    var startPct = state.rewardPct != null ? state.rewardPct : 0; // parti dal valore precedente e anima
    els.rewards.innerHTML =
      '<div class="hn-cart__reward-msg">' + msg + '</div>' + // msg contiene <b> voluti (config, non input utente)
      '<div class="hn-cart__bar"><div class="hn-cart__bar-fill' + (greenReached ? ' is-complete' : '') +
        (riempimentoInCorso ? ' is-filling' : '') +
        '" data-hn-fill style="width:' + startPct + '%"></div>' + ticks + '</div>' +
      '<div class="hn-cart__goals">' + goalLabels + '</div>';
    var fill = els.rewards.querySelector('[data-hn-fill]');
    if (fill) {
      var fillColor = greenReached ? (SUCCESS || '#1d6b17') : (PROGRESS || '#8a5a2b');
      // CAUSA REALE (confermata dalla diagnostica dal vivo: il riempimento risultava a 0x0 pixel
      // con larghezza calcolata ancora in "%", cioè NON risolta = elemento display:none, mentre
      // il contenitore aveva larghezza regolare). Il tema Halo (o un'app) ha una regola che nasconde
      // gli elementi VUOTI (del tipo ":empty{display:none}"): il riempimento è un <div> senza figli,
      // quindi veniva nascosto — ecco perché nessun fix su larghezza/colore aveva effetto. Le
      // etichette, avendo testo, restavano visibili (coerente con gli screenshot).
      // display:block inline con !important batte quella regola, qualunque essa sia.
      fill.style.setProperty('display', 'block', 'important');
      // COLORE + LARGHEZZA inline con !important: battono anche eventuali regole CSS esterne
      // (con o senza !important) su sfondo/larghezza. (+ fallback colore contro var CSS non risolta.)
      fill.style.setProperty('background-color', fillColor, 'important');
      // LARGHEZZA committata in modo SINCRONO — MAI solo dentro requestAnimationFrame: un rAF
      // perso/rimandato (tab in background, bfcache, app che rimpiazza rAF, main thread saturo al
      // primo paint della pagina /cart dove il drawer si apre da solo) lasciava la barra a 0.
      // transition:none -> width(start) -> reflow -> ripristino -> width(target): impegna il valore
      // FINALE adesso (nessun frame differito) conservando l'animazione start->target.
      var _t = fill.style.transition;
      fill.style.transition = 'none';
      fill.style.setProperty('width', startPct + '%', 'important');
      void fill.offsetWidth; // forza il reflow: registra lo stato di partenza
      fill.style.transition = _t || '';
      fill.style.setProperty('width', pct + '%', 'important'); // valore finale, sincrono, !important
    }
    state.rewardPct = pct;
    if (HN_DEBUG) reportBarDebug(fill, pct, qualifying, greenReached);
  }

  // Diagnostica su pagina (solo con ?hncartdebug): riporta lo stato REALE del riempimento — così
  // basta uno screenshot per capire se la larghezza è 0, se il contenitore ha larghezza, se il
  // colore è trasparente o se una regola esterna sta sovrascrivendo. Nessun cliente la vede.
  function reportBarDebug(fill, pct, qualifying, greenReached) {
    setTimeout(function () {
      try {
        if (!els.rewards) return;
        var bar = els.rewards.querySelector('.hn-cart__bar');
        var cs = fill ? getComputedStyle(fill) : null;
        var dbg = els.rewards.querySelector('[data-hn-dbg]');
        if (!dbg) {
          dbg = document.createElement('div');
          dbg.setAttribute('data-hn-dbg', '');
          dbg.style.cssText = 'font-size:10px;line-height:1.3;color:#c00;background:#fff8f0;border:1px solid #f0c;text-align:left;word-break:break-all;padding:3px 5px;margin-top:4px;border-radius:4px';
          els.rewards.appendChild(dbg);
        }
        var fresh = els.rewards.querySelector('[data-hn-fill]'); // fill ATTUALE nel DOM (non catturato)
        var fcs = fresh ? getComputedStyle(fresh) : null;
        dbg.textContent = 'HNDBG pct=' + (pct != null ? pct.toFixed(1) : '?') +
          ' | fill: esiste=' + (!!fill) +
          ' disp=' + (fcs ? fcs.display : '-') +
          ' inlineW=' + (fresh ? fresh.style.width : '-') +
          ' compW=' + (fcs ? fcs.width : '-') +
          ' pxW=' + (fresh ? Math.round(fresh.getBoundingClientRect().width) : '-') +
          ' pxH=' + (fresh ? Math.round(fresh.getBoundingClientRect().height) : '-') +
          ' bg=' + (fcs ? fcs.backgroundColor : '-') +
          ' | barW=' + (bar ? bar.clientWidth : '-') +
          ' complete=' + (fresh ? fresh.classList.contains('is-complete') : '-') +
          ' q=' + qualifying;
      } catch (e) {}
    }, 250);
  }

  // Diagnostica (solo con ?hncartdebug): la prima ipotesi era corretta in teoria ma cart_level_
  // discount_applications risultava vuoto anche con total_discount>0 — screenshot precedente
  // confermato: significa uno sconto che punta a prodotti/righe specifiche, non all'intero
  // carrello o alla spedizione (Shopify riserva cart_level_discount_applications solo a
  // quest'ultimo caso). Riporta OGNI possibile posizione del dato (cart.discount_applications,
  // cart.cart_level_discount_applications, e per ogni riga: total_discount/discounts/
  // line_level_discount_allocations) così basta un altro screenshot per scrivere il fix
  // definitivo invece di un'altra ipotesi parziale.
  function reportDiscountDebug(cart, codes) {
    try {
      var box = document.getElementById('hn-disc-debug');
      if (!box) {
        box = document.createElement('div');
        box.id = 'hn-disc-debug';
        box.style.cssText = 'position:fixed;left:8px;bottom:56px;z-index:2147483647;max-width:94vw;' +
          'max-height:32vh;overflow:auto;background:#eef6ff;border:2px solid #06c;color:#024;' +
          'font:10px/1.4 monospace;padding:6px 8px;border-radius:6px;white-space:pre-wrap;word-break:break-all';
        document.body.appendChild(box);
      }
      var itemsInfo = (cart.items || []).map(function (it) {
        return { key: it.key, total_discount: it.total_discount, discounts: it.discounts, line_level_discount_allocations: it.line_level_discount_allocations };
      });
      box.textContent = 'HNDBG-SCONTO2 currency=' + cart.currency + ' total_discount=' + cart.total_discount +
        '\ncart.discount_applications=' + JSON.stringify(cart.discount_applications) +
        '\ncart.cart_level_discount_applications=' + JSON.stringify(cart.cart_level_discount_applications) +
        '\ncart.discount_codes=' + JSON.stringify(cart.discount_codes) +
        '\nitems=' + JSON.stringify(itemsInfo) +
        '\ndiscountCodesForDisplay()=' + JSON.stringify(codes) +
        '\nULTIMO_APPLY=' + JSON.stringify(window.__hnDiscDbg || null);
    } catch (e) {}
  }

  /* Mentre l'aggiunta del tema e' in volo il carrello e' gia' aperto (startExternalAdd):
     senza questa riga mostrerebbe il carrello di prima — e a carrello vuoto, cioe' alla
     prima aggiunta della visita, «Il tuo carrello è vuoto» subito dopo «Aggiungi». */
  function addingHTML() {
    return '<div class="hn-adding" role="status"><span class="hn-spin"></span><span>' + esc(t('adding') || '…') + '</span></div>';
  }
  function paintAdding() {
    if (!els.body || els.body.querySelector('.hn-adding')) return;
    var empty = els.body.querySelector('.hn-empty');
    if (empty) { empty.insertAdjacentHTML('beforebegin', addingHTML()); empty.parentNode.removeChild(empty); return; }
    var items = els.body.querySelector('.hn-cart__items');
    (items || els.body).insertAdjacentHTML('afterbegin', addingHTML());
  }
  function renderBody(cart) {
    if (state.adding && (!cart.items || !cart.items.length)) { els.body.innerHTML = addingHTML(); return; }
    if (!cart.items || !cart.items.length) {
      state.lastQty = {};
      els.body.innerHTML = '<div class="hn-empty"><p>' + esc(t('empty')) + '</p>' +
        '<a href="' + ROOT + 'collections">' + esc(t('emptyCta')) + '</a></div>';
      renderUpsells(cart, true); // consigliati anche a carrello vuoto? no -> skip inside
      return;
    }
    /* Dopo un'aggiunta la riga del prodotto (nuova, o con un pezzo in piu') si illumina per un
       attimo: e' la conferma che il cliente cerca con l'occhio, anche se ha toccato «Aggiungi»
       in fondo al carrello. Solo dopo un'aggiunta (`flashAdds`), mai al primo disegno, mai per
       +/− o per il cestino. */
    var prima = state.lastQty, nuove = {};
    if (state.flashAdds && !state.adding && prima) {
      cart.items.forEach(function (it) { if (!(it.key in prima) || it.quantity > prima[it.key]) nuove[it.key] = 1; });
      state.flashAdds = false;
    }
    state.lastQty = {};
    cart.items.forEach(function (it) { state.lastQty[it.key] = it.quantity; });
    var itemsHtml = cart.items.map(function (it, idx) { return itemHTML(it, idx, !!nuove[it.key]); }).join('');
    // upsell + add-on + sconto/note vanno in un blocco SEPARATO, spinto più in basso e con un
    // divisorio netto rispetto ai prodotti già nel carrello (altrimenti si confondono con essi)
    var tools = toolsHTML(cart);
    var hasExtras = (CFG.upsells && CFG.upsells.enabled) || (CFG.addons && CFG.addons.enabled) || tools !== '';
    // Preserva lo stato aperto/chiuso dei <details> "tool" (sconto/note) tra un render e l'altro:
    // all'apertura del drawer il body è vuoto -> partono chiusi; dopo aver applicato/rimosso uno
    // sconto (che rifà l'innerHTML) restano aperti, così si può accodare subito un altro codice.
    var openTools = {};
    els.body.querySelectorAll('.hn-tool[data-hn-tool]').forEach(function (dt) { if (dt.open) openTools[dt.getAttribute('data-hn-tool')] = true; });
    /* Dopo un'aggiunta del tema i consigliati entrano un attimo DOPO il prodotto (merchant,
       2026-10-08: «il prodotto viene aggiunto e prima vengono caricati i prodotti
       consigliati»). Mentre l'aggiunta e' in volo restano nascosti (CSS, `is-adding`):
       sarebbero quelli del carrello di prima. Non rallentavano niente — si calcolano qui,
       senza rete, in pochi millisecondi — ma l'occhio deve trovare prima il prodotto. */
    var late = state.extrasLate && !state.adding;
    if (late) state.extrasLate = false;
    /* «Aggiunto ✓» sulla card toccata: senza questo il blocco si ridisegnava insieme alle
       righe, la card spariva sotto il dito e la conferma con lei. Il blocco vecchio resta per
       UPSELL_HOLD ms (i suoi pulsanti funzionano), poi i consigliati si aggiornano. */
    var tieni = state.upsellHold > Date.now() ? els.body.querySelector('[data-hn-upsells]') : null;
    els.body.innerHTML =
      '<div class="hn-cart__items">' + (state.adding ? addingHTML() : '') + itemsHtml + '</div>' +
      (hasExtras ? '<div class="hn-cart__extras' + (late ? ' hn-late' : '') + '"><div data-hn-upsells></div><div data-hn-addons></div>' + tools + '</div>' : '');
    els.body.querySelectorAll('.hn-tool[data-hn-tool]').forEach(function (dt) { if (openTools[dt.getAttribute('data-hn-tool')]) dt.open = true; });
    var nuovo = els.body.querySelector('[data-hn-upsells]');
    if (tieni && nuovo) {
      nuovo.parentNode.replaceChild(tieni, nuovo);
      clearTimeout(state.upsellTimer);
      state.upsellTimer = setTimeout(function () {
        state.upsellHold = 0;
        var scrivi = reco.afterHold;
        var host = els.body && els.body.querySelector('[data-hn-upsells]');
        if (host && state.cart && (state.cart.items || []).length) {
          renderUpsells(state.cart, false);
          host.classList.remove('hn-fade'); void host.offsetWidth; host.classList.add('hn-fade');
        }
        if (scrivi) writeRecoNow(); // la scrittura rimandata dall'attesa (scheduleRecoWrite)
      }, Math.max(0, state.upsellHold - Date.now()));
    } else renderUpsells(cart, false);
    renderAddons(cart);
    bindToolEvents();
  }

  var UPSELL_HOLD = 1200;
  function itemHTML(it, idx, nuova) {
    var gift = isGift(it);
    var line = idx + 1;
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
    // un set coi saponi scelti: la variante («Combinazione 1») direbbe il contrario della riga «Saponi scelti»
    var opts = hasChoice(it) ? '' : (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.name + ': ' + o.value); }).join(' · ');
    // proprietà visibili (non quelle che iniziano con _)
    var props = Object.keys(it.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; })
      .map(function (k) { return esc(k + ': ' + it.properties[k]); }).join('<br>');
    var priceHtml;
    if (gift) {
      priceHtml = '<span class="hn-item__price"><s>' + money(giftTwinPrice(it)) + '</s><span class="hn-item__free">' + esc(t('free')) + '</span></span>';
    } else {
      // prezzo di partenza = compare-at (saldo) oppure prezzo pieno pre-sconto riga
      var baseLine = Math.max(compareAtUnit(it), it.original_price) * it.quantity;
      priceHtml = '<span class="hn-item__price">' +
        (baseLine > it.final_line_price ? '<s>' + money(baseLine) + '</s>' : '') +
        money(it.final_line_price) + '</span>';
    }
    // tocchi +/− ancora in volo: si mostra la quantità promessa, non quella di un passo fa (changeQty)
    var oq = state.optimQty[it.key];
    var locked = gift && CFG.freeGifts.lockQuantity;
    var qNow = oq ? oq.q : it.quantity;
    /* A quantita' 1 il − toglie la riga, e lo dice: a chi non vede il disegno (aria-label) e a chi
       ci passa sopra col puntatore (title). Dal 2026-10-08 e' il modo di togliere un prodotto,
       perche' il cestino e' spento (lineRemove, sotto). */
    var meno = qNow <= 1 ? ' aria-label="' + esc(t('remove')) + '" title="' + esc(t('remove')) + '"' : ' aria-label="-"';
    var qtyControls = locked
      ? '<span></span>' // il badge omaggio è accanto al titolo, non qui; solo spaziatore per allineare il prezzo a destra
      : '<div class="hn-qty" data-line="' + line + '">' +
          '<button data-hn-qty="-1"' + meno + '>−</button>' +
          '<span>' + qNow + '</span>' +
          '<button data-hn-qty="1" aria-label="+">+</button>' +
        '</div>';
    /* Cestino: solo se acceso dalla sezione (merchant, 2026-10-08: «toglilo, tanto se vogliono
       cancellare spingono su −1»). Senza cestino la riga porta `no-rm` e il titolo si riprende lo
       spazio che gli lasciava (hn-cart.css). */
    var removeBtn = (!locked && CFG.lineRemove && CFG.lineRemove.enabled) ?
      '<button class="hn-item__remove" data-hn-remove="' + line + '" aria-label="' + esc(t('remove')) + '" title="' + esc(t('remove')) + '">' + TRASH + '</button>' : '';
    /* Immagine e titolo portano alla pagina prodotto: sono <a> con href vero, non un click
       gestito in JS, così valgono apri-in-nuova-scheda, tasto centrale e menu contestuale.
       it.url arriva da /cart.js e include gia' ?variant=, quindi la pagina apre la variante
       giusta. Il delegate dei click nel drawer non intercetta gli <a> (nessun data-hn-*),
       quindi la navigazione avviene di suo.
       ⛔ Tranne gli OMAGGI (merchant, 2026-10-14: «se uno clicca sul prodotto non si deve aprire
       la pagina prodotto ma al massimo il popup con le informazioni, non deve essere possibile
       aggiungerlo al carrello»). La pagina di un omaggio e' un prodotto a 0 € col suo «Aggiungi
       al carrello»: da li' se ne prendeva un secondo. Niente href, quindi nemmeno tasto
       centrale o «apri in una nuova scheda»: foto e nome aprono l'anteprima (openGiftPreview). */
    var info = isGiftLine(it);
    var url = info ? '' : (it.url || (it.handle ? '/products/' + it.handle : ''));
    var titleEl = info
      ? '<p class="hn-item__title hn-item__info" data-hn-gift-info role="button" tabindex="0" aria-haspopup="dialog">' + esc(it.product_title) + '</p>'
      : url
        ? '<a class="hn-item__title hn-item__link" href="' + esc(url) + '">' + esc(it.product_title) + '</a>'
        : '<p class="hn-item__title">' + esc(it.product_title) + '</p>';
    var imgInner = img
      ? '<img class="hn-item__img" src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">'
      : '<div class="hn-item__img"></div>';
    var imgEl = info
      ? '<span class="hn-item__imglink hn-item__info" data-hn-gift-info aria-hidden="true">' + imgInner + '</span>'
      : url ? '<a class="hn-item__imglink" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + imgInner + '</a>' : imgInner;
    return '<div class="hn-item ' + (gift ? 'hn-gift' : '') + (removeBtn ? '' : ' no-rm') + (nuova ? ' is-new' : '') + (oq ? ' is-pending' + (oq.q === 0 ? ' is-removing' : '') : '') + '" data-key="' + esc(it.key) + '">' +
      imgEl +
      '<div class="hn-item__main">' +
        (gift ?
          '<div class="hn-item__titlerow">' + titleEl +
          '<span class="hn-item__badge">' + esc(t('giftBadge')) + '</span></div>' :
          titleEl) +
        (opts ? '<p class="hn-item__variant">' + opts + '</p>' : '') +
        (props ? '<p class="hn-item__props">' + props + '</p>' : '') +
        '<div class="hn-item__row">' + qtyControls + priceHtml + '</div>' +
      '</div>' +
      removeBtn +
    '</div>';
  }

  function toolsHTML(cart) {
    var html = '';
    if (CFG.note && CFG.note.enabled) {
      html += '<details class="hn-tool" data-hn-tool="note"><summary>' + esc(t('noteLabel')) + ' <span>＋</span></summary>' +
        '<textarea data-hn-note placeholder="' + esc(t('notePlaceholder')) + '">' + esc(cart.note || '') + '</textarea>' +
        '<button class="hn-note__save" data-hn-note-save>' + esc(t('apply')) + '</button></details>';
    }
    if (CFG.discountBox && CFG.discountBox.enabled) {
      // Il "details" parte SEMPRE collassato all'apertura del drawer (body vuoto -> nessuno
      // stato da ripristinare), ma lo stato aperto/chiuso viene poi PRESERVATO tra un render e
      // l'altro (vedi renderBody): così dopo aver applicato un codice la sezione resta aperta e se
      // ne può accodare subito un altro.
      // I codici sono STACKABILI: cart.discount_codes è la lista autorevole di TUTTI i codici sul
      // carrello ([{code, applicable}]). Ogni codice ha la sua chip removibile; il pulsante
      // "Aggiungi codice" svela il modulo per accodarne un altro (l'API SOSTITUISCE l'intero set,
      // quindi applyDiscount re-invia i codici già presenti + quello nuovo — vedi sotto).
      // L'etichetta (generica, es. "Hai un codice sconto?") NON cambia coi codici attivi: i codici
      // si vedono SOLO nelle chip, una volta sola.
      var codes = discountCodesForDisplay(cart); // [{code, applicable, amount}]
      if (HN_DEBUG) reportDiscountDebug(cart, codes);
      html += '<details class="hn-tool" data-hn-tool="discount"><summary>' + esc(t('discountLabel')) + ' <span>＋</span></summary>';
      if (codes.length) {
        html += '<div class="hn-disc-active">' +
          codes.map(function (c) {
            return '<div class="hn-chip' + (c.applicable ? '' : ' hn-chip--void') + '">🏷️ ' + esc(c.code) +
              (c.applicable ? (c.amount ? ' (−' + money(c.amount) + ')' : '') : ' · ' + esc(t('discountNotApplicable'))) +
              '<button data-hn-disc-remove="' + esc(c.code) + '" aria-label="' + esc(t('remove')) + '">×</button></div>';
          }).join('') +
          '<button class="hn-disc-change" data-hn-disc-change type="button">' + esc(t('discountAdd')) + '</button></div>' +
          '<div class="hn-disc" data-hn-disc-form hidden>' +
            '<input type="text" data-hn-disc placeholder="' + esc(t('discountPlaceholder')) + '">' +
            '<button data-hn-disc-apply>' + esc(t('apply')) + '</button></div>';
      } else {
        html +=
          '<div class="hn-disc"><input type="text" data-hn-disc placeholder="' + esc(t('discountPlaceholder')) + '">' +
            '<button data-hn-disc-apply>' + esc(t('apply')) + '</button></div>';
      }
      html += '<div class="hn-disc__msg" data-hn-disc-msg></div>' + automaticDiscountsHTML(cart) + '</details>';
    }
    return html;
  }

  // Il codice CLIENTE (digitato o da ?discount= in URL) ha type "discount_code"; uno sconto
  // automatico (es. BXGY del regalo) ha type "automatic" e non deve comparire come "codice"
  // qui — non è rimovibile da questa UI (API.update({discount}) tocca solo i codici, non le
  // regole automatiche del carrello).
  // IMPORTANTE (confermato dal vivo via diagnostica ?hncartdebug): cart.cart_level_discount_
  // applications contiene SOLO gli sconti sull'INTERO carrello o sulla spedizione. Un codice
  // sconto su prodotti/righe specifiche (es. percentuale su una collezione — il caso più comune,
  // non "tutto il carrello") NON compare lì: resta vuoto anche con uno sconto attivo. Va cercato
  // per riga, in item.line_level_discount_allocations[].discount_application (che include "type").
  // Lista dei codici CLIENTE sul carrello, con applicabilità e importo. cart.discount_codes è la
  // fonte autorevole di TUTTI i codici digitati ([{code, applicable}]); l'importo per codice non è
  // lì, lo ricaviamo dalle applicazioni di type "discount_code" (cart-level total_allocated_amount
  // + somma delle allocazioni per riga), abbinando per titolo (per un codice, title == codice).
  // Uno sconto AUTOMATICO (BXGY del regalo, ecc.) NON compare in discount_codes: resta gestito da
  // automaticDiscountsHTML.
  function discountCodesForDisplay(cart) {
    var list = (cart.discount_codes || []).filter(function (d) { return d && d.code; });
    if (!list.length) return [];
    var amountByCode = {}; // CODICE maiuscolo -> importo in cent
    function add(code, amt) { if (!code) return; var k = String(code).toUpperCase(); amountByCode[k] = (amountByCode[k] || 0) + (amt || 0); }
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a && a.type === 'discount_code') add(a.title, a.total_allocated_amount);
    });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var da = al && al.discount_application;
        if (da && da.type === 'discount_code') add(da.title, al.amount);
      });
    });
    return list.map(function (d) {
      return { code: d.code, applicable: d.applicable !== false, amount: amountByCode[String(d.code).toUpperCase()] || 0 };
    });
  }
  // codici attualmente sul carrello come semplice array di stringhe (per costruire il set da inviare)
  function currentDiscountCodes(cart) {
    return ((cart && cart.discount_codes) || []).map(function (d) { return d.code; }).filter(Boolean);
  }

  // sconti AUTOMATICI (regole cart-level, es. il BXGY del regalo): solo informativi, SENZA
  // pulsante rimuovi — il cliente non può toglierli da qui, sarebbe fuorviante offrirglielo.
  function automaticDiscountsHTML(cart) {
    var apps = (cart.cart_level_discount_applications || []).filter(function (a) { return a.type !== 'discount_code'; });
    if (!apps.length) return '';
    return apps.map(function (a) {
      return '<div class="hn-chip hn-chip--auto">🏷️ ' + esc(a.title || a.key) + ' (−' + money(a.total_allocated_amount) + ')</div>';
    }).join('');
  }

  /* ------------------------------ UPSELLS ------------------------------ */
  /* Motore a segnali multipli. REGOLA ARCHITETTURALE: qui c'è solo il
     MECCANISMO (calcoli); tutti i NUMERI — pesi, affinità, categorie,
     bundle, blocklist — vivono in window.HN_CART_DATA (assets/
     hn-cart-catalog.js, generato). Ottimizzare = rigenerare quel file.
     Punteggio: gap (chiude la prossima soglia? — la leva più forte)
              + affinità (cosa si compra davvero insieme, smorzata se il
                candidato "somiglia" al carrello: anti sapone-consiglia-sapone)
              + dominio (accessori-sapone spinti quando il carrello è pieno
                di saponi) + margine (bucket 0..10, mai il COGS).
     Primo paint SINCRONO dal catalogo (zero rete); la rete è solo fallback.
     Se HN_CART_DATA manca, degrada alla catena related -> nessun errore. */
  var D = (window.HN_CART_DATA && window.HN_CART_DATA.v === 3) ? window.HN_CART_DATA
        : { v: 3, gen: 'v0', w: {}, p: {}, a: {}, x: { never: [], b: {} }, f: [], f2: [] };
  var W = deepMerge({ gap: 1.00, aff: 0.70, dom: 0.60, mar: 0.35, addShare: 0, catDamp: 0.5, domUnits: 6,
                      newScent: 0, scentFull: 7, scentMin: 5, comp: 0.70,
                      explorePct: 0.18, overshootTol: 1200, overshootTarget: 300,
                      gapCeilBase: 1500, gapCeilPct: 0.4, seenPenalty: 0 },
                    D.w || {});
  /* Pesi della PAGINA PRODOTTO (moduli hn-pdp). Stessa struttura di W: i default
     stanno qui, il catalogo (`D.w.pdp`) li sovrascrive — quella resta la sede
     della taratura. Le differenze dal drawer non sono preferenze, sono
     conseguenze della domanda diversa (vedi tools/hn-pdp.md §1):
     - `gap` 0.30 contro 1.00: in pagina prodotto la soglia è un'INFORMAZIONE
       («con questo hai la spedizione gratuita»), non la leva. La leva del
       drawer è la barra premi, che in pagina non esiste.
     - `aff` 1.00 contro 0.70: qui l'ancora è UN prodotto scelto dal cliente,
       non le tre righe più care di un carrello. È il segnale migliore che ci
       sia e non va diluito.
     - `sameCat: 'exclude'`: un secondo shampoo sulla pagina dello shampoo è un
       SOSTITUTO, non un compagno. Nel drawer la stessa cosa è solo smorzata
       (`catDamp`), perché lì l'ancora è il carrello intero.
     - `distinct: 1`: un bisogno per proposta (vedi `needsOf`) — fra le proposte
       di un blocco, e fra le proposte e l'ancora.
     - `explorePct`/`shufflePct` 0.5 in fase 1: senza randomizzazione la mappa
       futura imparerebbe dalle proprie scelte, che è il difetto che lo slot
       esplorativo del carrello esiste per evitare.
     ⚠️ `seenPenalty` è sempre 0 qui: è la memoria del DRAWER sulle impression
     della pagina, e la pagina non può penalizzarsi da sé. */
  var WPDP_DEFAULTS = { gap: 0.30, aff: 1.00, dom: 0.80, comp: 0.70, mar: 0.35,
                        sameCat: 'exclude', distinct: 1, explorePct: 0.5, shufflePct: 0.5,
                        limit: 2, upgradeMaxMult: 3, seenPenalty: 0 };
  var WPDP = null;
  function pdpWeights() {
    if (WPDP) return WPDP;
    WPDP = deepMerge(deepMerge(W, WPDP_DEFAULTS), (D.w && D.w.pdp) || {});
    WPDP.seenPenalty = 0;
    WPDP.surface = 'pdp';
    return WPDP;
  }
  // pesi di QUESTO contesto: il drawer non passa nulla (=== W, byte-identico)
  function wOf(ctx) { return (ctx && ctx.W) || W; }
  var NEVER = {}; ((D.x && D.x.never) || []).forEach(function (id) { NEVER[id] = true; });
  // esclusi dal SOLO carrello (`w.cartNever`): si legge da `D.w` e non dai pesi della
  // superficie, perché quelli della pagina prodotto e del foglio lo ereditano da `W`
  var CART_NEVER = {}; ((D.w && D.w.cartNever) || []).forEach(function (id) { CART_NEVER[id] = true; });
  /* Equivalenze (x.eq): due id prodotto che sono lo STESSO oggetto per il
     cliente. Serve ai prodotti "omaggio", che su Shopify sono prodotti separati
     dal gemello a pagamento: senza questa mappa il regalo nel carrello non
     copriva il gemello, e il recommender continuava a proporre il portasapone a
     chi lo aveva appena ricevuto in regalo. Simmetrica di proposito. */
  var EQ = {};
  (function () {
    var raw = (D.x && D.x.eq) || {};
    function link(a, b) { (EQ[a] = EQ[a] || []).push(b); }
    Object.keys(raw).forEach(function (k) {
      (raw[k] || []).forEach(function (id) { link(k, id); link(id, Number(k)); });
    });
  }());
  var HANDLE_IDX = {}; Object.keys(D.p).forEach(function (id) { HANDLE_IDX[D.p[id].h] = id; });
  // Composizione: una variante può differire dal prodotto (Kit Doccia e Kit
  // Starter hanno UNO shampoo per variante, il Set da 3 profumazioni disgiunte).
  // Con variantId noto si usa la variante; senza, il default del prodotto.
  function variantEntry(e, variantId) {
    if (!e || !e.vs || variantId == null) return null;
    for (var i = 0; i < e.vs.length; i++) if (String(e.vs[i].id) === String(variantId)) return e.vs[i];
    return null;
  }
  function scentsOf(productId, variantId) {   // profumazioni contenute
    var e = D.p[productId]; if (!e) return [];
    var v = variantEntry(e, variantId);
    return (v && v.sc) || e.sc || [];
  }
  function compsOf(productId, variantId) {    // componenti esatti non-sapone
    var e = D.p[productId]; if (!e) return [];
    var v = variantEntry(e, variantId);
    return (v && v.comp) || e.comp || (D.x.b && D.x.b[productId]) || [];
  }
  /* Set a scelta (assets/hn-bys.js, dal 2026-10-07): una riga di set può dire da
     sé quali saponi contiene, con la proprietà nascosta `_hn_sc` («<pid>:<n>,…»).
     Vale solo se ogni id è un sapone del catalogo e il totale è il numero di
     saponi del set; altrimenti si ricade sul catalogo, come per qualunque riga
     (un valore rovinato non deve mai far credere a un set vuoto). */
  function hasChoice(it) { return !!(it && it.properties && it.properties._hn_sc); }
  function chosenScents(it) {
    var e = it && D.p[it.product_id];
    if (!hasChoice(it) || !e || !e.su) return null;
    var out = [], tot = 0, ok = true;
    String(it.properties._hn_sc).split(',').forEach(function (part) {
      var m = /^\s*(\d+):(\d+)\s*$/.exec(part);
      if (!m || !D.p[m[1]] || D.p[m[1]].cat !== 'soap' || !(+m[2] >= 1)) { ok = false; return; }
      tot += +m[2];
      if (out.indexOf(+m[1]) < 0) out.push(+m[1]);
    });
    return ok && tot === e.su ? out : null;
  }
  // i saponi di una riga del carrello: quelli scelti, se ci sono, sennò quelli del catalogo
  function lineScents(it) { return chosenScents(it) || scentsOf(it.product_id, it.variant_id); }

  /* ====================================================================
     SET A SCELTA — IL PREDEFINITO VALE PER OGNI STRADA (2026-10-09)
     --------------------------------------------------------------------
     Dal 2026-10-08 la pagina prodotto di un set (assets/hn-bys.js) propone come
     predefinito i primi N saponi DISPONIBILI nell'ordine del pannello, e scrive le
     note della riga («Saponi scelti», `_hn_sc`, `_hn_sv`, `_hn_bys`) quando sono
     diversi da quelli dello SKU: Shopify Flow scompone l'ordine in saponi singoli
     e la logistica (Amphora, che lavora per SKU) spedisce quelli.

     Ma il set si aggiunge da MOLTE strade, e solo una passava dal modulo. Le altre
     (la scheda in griglia, i consigliati del carrello, i blocchi sotto il bottone,
     l'offerta al checkout) aggiungevano lo SKU standard, cioe' il set con lo Scirocco
     dentro anche quando lo Scirocco e' esaurito: 5 set su 11 dall'accensione del
     modulo, fra cui #IT219669 (merchant, 2026-10-09). Qui sta l'UNICA copia della
     regola, e vale per tutte le strade:
       1. le NOSTRE aggiunte (`API.add`, il collo di bottiglia di upsell, blocchi della
          pagina prodotto, anteprima, offerta al checkout) portano le note;
       2. le aggiunte del TEMA e delle app (`fetch` e XHR, come per add_to_cart) le
          ricevono nel corpo della richiesta, PRIMA che parta;
       3. un set gia' in carrello senza note (aggiunto da una strada che non si
          intercetta, prima di questo deploy, o prima che un sapone finisse) si
          sistema alla prima lettura del carrello (`reconcileSets`).
     Il modulo della pagina prodotto NON ha piu' una regola sua: chiede qui il
     predefinito e il formato delle note (`HNCart.bys`), cosi' le due strade non
     possono divergere.

     ⛔ Si sostituisce SOLO quando serve: se lo SKU contiene un sapone esaurito. Uno SKU
     interamente disponibile si spedisce com'e' (niente note, niente Flow, niente
     rumore negli ordini). E non si tocca MAI una scelta del cliente (`_hn_bys` = `c`).

     ⚠️ I dati arrivano dal Liquid, nell'HTML (`HN_CART_BOOT.bys`: quali set, e quali
     saponi con la loro disponibilita', nell'ordine del pannello), e non da una
     richiesta di rete: la disponibilita' deve essere nota al PRIMO tocco su
     «Aggiungi», senza aspettare niente. Senza `bys` (interruttore spento, o pagina in
     cache da prima del deploy) il motore resta inerte. Un sapone del pannello che il
     catalogo non sa dire (variante e prezzo, che Flow legge) spegne TUTTO: meglio il
     set di sempre che un ordine che la logistica non sa leggere.

     Limite noto: la disponibilita' e' quella del momento in cui la pagina e' stata
     servita. Una pagina aperta prima che un sapone finisca lo vede ancora disponibile;
     lo sistema `reconcileSets` alla prossima lettura del carrello, su una pagina nuova.
     ==================================================================== */
  var BYS_PROP = 'Saponi scelti';
  var BYS = (function () {
    var b = BOOT.bys, out = { sets: {}, byVid: {}, soaps: [], av: {} }, ok = true;
    if (!b || !Array.isArray(b.sets) || !Array.isArray(b.soaps)) return null;
    b.sets.forEach(function (id) {
      id = String(id);
      var e = D.p[id];
      if (!e || e.cat !== 'soapset' || !(e.su > 0)) return;      // un set che il catalogo non conosce non si tocca
      out.sets[id] = 1;
      if (e.vid) out.byVid[String(e.vid)] = id;
      (e.vs || []).forEach(function (v) { out.byVid[String(v.id)] = id; });
    });
    b.soaps.forEach(function (r) {
      var id = String(r && r[0]), c = D.p[id];
      if (!c || c.cat !== 'soap' || !(c.vid > 0) || !(c.pr > 0)) { ok = false; return; }
      out.soaps.push({ id: id, a: !!(r && r[1]) });
      out.av[id] = !!(r && r[1]);
    });
    return (ok && out.soaps.length > 1 && Object.keys(out.sets).length) ? out : null;
  }());
  // quanti pezzi di ogni sapone, uguali? (mappe id -> numero)
  function bysSame(a, b) {
    var k;
    for (k in a) if (a.hasOwnProperty(k) && (a[k] || 0) !== (b[k] || 0)) return false;
    for (k in b) if (b.hasOwnProperty(k) && (a[k] || 0) !== (b[k] || 0)) return false;
    return true;
  }
  // cosa spedisce lo SKU di quella variante, dal catalogo (la stessa composizione di Amphora)
  function bysSku(pid, vid) {
    var c = {};
    scentsOf(pid, vid).forEach(function (id) { id = String(id); c[id] = (c[id] || 0) + 1; });
    return c;
  }
  // c'e' un sapone esaurito, in questa composizione?
  function bysGone(c) {
    for (var id in c) if (c.hasOwnProperty(id) && c[id] && BYS.av[id] === false) return true;
    return false;
  }
  /* Il set PREDEFINITO (merchant, 2026-10-08): i primi N saponi disponibili
     nell'ordine del pannello, a giro, quindi se non bastano si raddoppia dall'alto.
     null se i disponibili sono meno di due (non c'e' scelta: il set si vende com'e'). */
  function bysBase(pid) {
    pid = String(pid);
    var e = D.p[pid];
    if (!BYS || !BYS.sets[pid] || !e) return null;
    var av = BYS.soaps.filter(function (s) { return s.a; }), c = {};
    if (av.length < 2) return null;
    for (var i = 0; i < e.su; i++) { var s = av[i % av.length]; c[s.id] = (c[s.id] || 0) + 1; }
    return c;
  }
  /* Le note della riga per quella scelta, nell'ordine del pannello:
       «Saponi scelti»  testo per chi legge (cliente, pagamento, chi prepara il pacco);
       `_hn_sc`         «<pid>:<n>,…» per il motore (lineScents) e per l'analisi;
       `_hn_sv`         «<variante>:<n>:<centesimi>,…» per Shopify Flow, che scompone
                        l'ordine in saponi singoli (tools/flow/hn-split.js): variante e
                        prezzo stanno qui perche' Flow legge solo l'ordine;
       `_hn_bys`        `c` se li ha scelti il cliente, `d` se e' il predefinito.
     Il prezzo e' quello che il carrello vede (catalogo, corretto a runtime se
     Shopify dice altro). null se la scelta non e' fatta di saponi del pannello. */
  function bysProps(pid, counts, kind) {
    if (!BYS) return null;
    var txt = [], sc = [], sv = [], tot = 0, want = 0;
    for (var k in counts) if (counts.hasOwnProperty(k)) want += counts[k] || 0;
    BYS.soaps.forEach(function (s) {
      var n = counts[s.id]; if (!n) return;
      var c = D.p[s.id], h = hydrate(s.id);
      txt.push(n + '× ' + (c.n || String(c.t || '').split(' - ')[0].trim()));
      sc.push(s.id + ':' + n);
      sv.push(c.vid + ':' + n + ':' + ((h && h.price > 0) ? Math.round(h.price) : c.pr));
      tot += n;
    });
    if (!tot || tot !== want) return null;
    var o = {};
    o[BYS_PROP] = txt.join(', '); o._hn_sc = sc.join(','); o._hn_sv = sv.join(',');
    o._hn_bys = kind === 'c' ? 'c' : 'd';
    return o;
  }
  /* Il piano per UNA variante di set: le note da aggiungere, oppure null se non servono
     (set non gestito, SKU interamente disponibile, meno di due saponi disponibili). */
  function bysPlan(pid, vid) {
    pid = String(pid);
    if (!BYS || !BYS.sets[pid]) return null;
    if (!bysGone(bysSku(pid, vid))) return null;        // lo SKU e' tutto disponibile: si spedisce com'e'
    var sel = bysBase(pid); if (!sel) return null;
    var props = bysProps(pid, sel, 'd'); if (!props) return null;
    return { sel: sel, props: props };
  }
  /* Le note per un'aggiunta in corso, o null. `has`: un oggetto di proprieta', o una
     funzione (nome) -> bool. Se la riga porta gia' una scelta (la scrive il modulo della
     pagina prodotto) non si tocca, e non si raddoppia niente. */
  function bysFor(vid, has) {
    if (!BYS) return null;
    var pid = BYS.byVid[String(vid)]; if (!pid) return null;
    var h = typeof has === 'function' ? has : function (n) { return !!(has && has[n] != null); };
    if (h('_hn_sc') || h(BYS_PROP)) return null;
    var plan = bysPlan(pid, vid);
    return plan ? plan.props : null;
  }
  // le nostre aggiunte (API.add): stessi oggetti se non cambia nulla, altrimenti copie con le note
  function bysItems(items) {
    if (!BYS || !items || !items.length) return items;
    var changed = false;
    var out = items.map(function (i) {
      var add = i && i.id != null ? bysFor(i.id, i.properties) : null;
      if (!add) return i;
      changed = true;
      return Object.assign({}, i, { properties: Object.assign({}, i.properties || {}, add) });
    });
    return changed ? out : items;
  }
  /* Le aggiunte del tema e delle app, nel corpo della richiesta. Quattro forme, tutte
     viste sul sito: FormData (theme.js, actionAddToCart2), stringa a codifica URL
     (`Shopify.addItem` in assets/global.js: «quantity=1&id=123»), URLSearchParams e
     JSON ({id,…} oppure {items:[…]}). Restituisce LO STESSO oggetto se non c'e' niente da
     scrivere, una copia altrimenti — mai si modifica quello del chiamante. Qualunque
     errore: si manda cio' che il chiamante ha preparato (mai rompere un'aggiunta). */
  function bysParams(p) {
    var adds = [], seen = {};
    function one(vid, pre) {
      var add = bysFor(vid, function (n) { return p.get(pre + '[' + n + ']') != null; });
      if (add) Object.keys(add).forEach(function (n) { adds.push([pre + '[' + n + ']', add[n]]); });
    }
    if (p.get('id') != null) one(p.get('id'), 'properties');
    p.forEach(function (v, k) {                                   // items[N][id] (aggiunte multiple a codifica URL)
      var m = /^items\[(\d+)\]\[id\]$/.exec(k);
      if (m && !seen[m[1]]) { seen[m[1]] = 1; one(v, 'items[' + m[1] + '][properties]'); }
    });
    return adds;
  }
  function bysJson(txt) {
    var j = JSON.parse(txt), changed = false;
    var list = (j && Array.isArray(j.items)) ? j.items : ((j && j.id != null) ? [j] : []);
    list.forEach(function (x) {
      if (!x || typeof x !== 'object' || Array.isArray(x.properties)) return;
      var add = bysFor(x.id, x.properties || {});
      if (!add) return;
      x.properties = Object.assign({}, x.properties || {}, add); changed = true;
    });
    return changed ? JSON.stringify(j) : txt;
  }
  function bysBody(body) {
    if (!BYS || body == null) return body;
    try {
      if (typeof body === 'string') {
        if (/^\s*[\{\[]/.test(body)) return bysJson(body);
        var adds = bysParams(new URLSearchParams(body));
        if (!adds.length) return body;
        return body + (body ? '&' : '') + adds.map(function (a) { return encodeURIComponent(a[0]) + '=' + encodeURIComponent(a[1]); }).join('&');
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var a2 = bysParams(body);
        if (!a2.length) return body;
        var fd = new FormData();
        body.forEach(function (v, k) { fd.append(k, v); });
        a2.forEach(function (a) { fd.append(a[0], a[1]); });
        return fd;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var a3 = bysParams(body);
        if (!a3.length) return body;
        var up = new URLSearchParams(body.toString());
        a3.forEach(function (a) { up.append(a[0], a[1]); });
        return up;
      }
    } catch (e) { /* si manda cio' che il chiamante ha preparato */ }
    return body;
  }
  /* Una riga del carrello che va sistemata, e con quali note; null se non serve.
       - nessuna nota: serve solo se lo SKU contiene un sapone esaurito (bysPlan);
       - note scritte dal SISTEMA (`_hn_bys` = `d`): si rifanno se nel frattempo un
         sapone che contengono e' finito;
       - ogni altra nota (scelta del cliente, o note senza marca) NON si tocca. */
  function bysRepair(it) {
    if (!BYS || isGift(it) || isAddon(it)) return null;
    var pid = BYS.byVid[String(it.variant_id)]; if (!pid) return null;
    var p = it.properties || {};
    if (p._hn_sc || p[BYS_PROP]) {
      if (p._hn_bys !== 'd') return null;
      var cur = {}, ok = true;
      String(p._hn_sc || '').split(',').forEach(function (part) {
        var m = /^\s*(\d+):(\d+)\s*$/.exec(part);
        if (!m) { ok = false; return; }
        cur[m[1]] = (cur[m[1]] || 0) + (+m[2]);
      });
      if (!ok || !bysGone(cur)) return null;
      var sel = bysBase(pid);
      return sel ? bysProps(pid, sel, 'd') : null;
    }
    var plan = bysPlan(pid, it.variant_id);
    return plan ? plan.props : null;
  }
  /* RETE DI SICUREZZA: un set gia' in carrello che ha bisogno delle note e non le ha
     (aggiunto da una strada che non si intercetta, un link /cart/<variante>:1, una
     pagina rimasta aperta mentre un sapone finiva, un carrello di prima del deploy).
     Si corregge con UNA /cart/change.js per riga, che restituisce il carrello intero (nessuna
     rilettura in piu'). Le proprieta' di una riga si SOSTITUISCONO in blocco: si rimandano
     anche quelle che aveva. ⛔ Una sola correzione per riga e al massimo sei per pagina:
     se Shopify non conservasse le note, un ciclo ritenterebbe all'infinito. */
  var bysFixed = {}, bysFixN = 0, bysDbg = { fatte: [], ultimo: '' };
  function reconcileSets(cart) {
    if (!BYS || !cart || !Array.isArray(cart.items)) return Promise.resolve(cart);
    var todo = [];
    cart.items.forEach(function (it) {
      if (bysFixed[it.key]) return;
      var props = bysRepair(it);
      if (props) todo.push({ it: it, props: props });
    });
    if (!todo.length) return Promise.resolve(cart);
    var cur = cart, ops = Promise.resolve();
    todo.forEach(function (x) {
      ops = ops.then(function () {
        if (bysFixN >= 6) return null;
        bysFixed[x.it.key] = 1; bysFixN++;
        var merged = Object.assign({}, x.it.properties || {}, x.props);
        return API.change({ id: x.it.key, quantity: x.it.quantity, properties: merged }).then(function (res) {
          if (isFullCart(res)) { cur = res; bysDbg.fatte.push(x.it.variant_id + ' → ' + x.props._hn_sc); }
          else bysDbg.ultimo = 'rifiutata: ' + ((res && (res.description || res.message)) || 'risposta senza carrello');
          return res;
        }, function () { bysDbg.ultimo = 'errore di rete'; return null; });
      });
    });
    return ops.then(function () { return cur; }, function () { return cur; });
  }
  // regali e set vanno riconciliati insieme, in questo ordine, a ogni lettura del carrello
  function reconcileCart(cart) { return reconcileGifts(cart).then(reconcileSets); }

  /* Risalita ai CONTENITORI: quali set/kit acquistabili contengono l'ancora.
     È il dato su cui vive il Modo 1 del pacchetto in pagina prodotto («lo trovi
     anche nel Set da 3»), e nel catalogo non esiste un campo che lo dica: lì è
     dichiarata solo la direzione opposta (`sc`/`comp`, per variante in `vs[]`).
     ⚠️ L'ancora non deve essere a sua volta un pacchetto, altrimenti la risalita
     prende fischi per fiaschi: il Kit Naturalis Starter contiene UNA
     profumazione, e la regola ingenua «una sola profumazione ⇒ è un singolo» lo
     dichiarerebbe contenuto nel Set da 7. Lo è la profumazione, non il kit. */
  /* BISOGNI: a cosa serve un prodotto, DERIVATO dal catalogo e mai scritto a
     mano. Un singolo risponde al bisogno della sua categoria (`cat`); un set o
     un kit a quelli di ciò che contiene (`sc`/`comp`, tutte le varianti). Così
     Set da 3, Set da 5 e Kit Doccia rispondono tutti al bisogno «sapone», e il
     Kit Cura della Pelle a tre (deodorante, siero, crema).
     Serve alla pagina prodotto per non proporre due cose che fanno la stessa
     cosa (merchant, 2026-10-01: «perché offre 2 set di saponi che si
     sovrappongono?»). Il drawer non lo usa. */
  var NEEDS = {};
  function needsOf(id, depth) {
    id = String(id);
    if (NEEDS[id]) return NEEDS[id];
    var e = D.p[id]; if (!e) return [];
    depth = depth || 0;
    var parts = [], seen = {}, out = [];
    var take = function (l) {
      (l || []).forEach(function (x) { x = String(x); if (x !== id && !seen[x]) { seen[x] = 1; parts.push(x); } });
    };
    take(e.sc); take(e.comp); take(D.x && D.x.b && D.x.b[id]);
    (e.vs || []).forEach(function (v) { take(v.sc); take(v.comp); });
    var add = function (n) { if (n && out.indexOf(n) < 0) out.push(n); };
    if (!parts.length || depth > 3) add(e.cat);
    else parts.forEach(function (p) {
      if (D.p[p]) needsOf(p, depth + 1).forEach(add);
      else add('id:' + p);                          // componente fuori catalogo: bisogno a sé
    });
    if (!depth) NEEDS[id] = out;
    return out;
  }
  function sharesNeed(a, b) {
    for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) >= 0) return true;
    return false;
  }

  function holdsAnchor(sc, comp, anchorId) {
    var i;
    for (i = 0; i < (sc || []).length; i++) if (String(sc[i]) === String(anchorId)) return true;
    for (i = 0; i < (comp || []).length; i++) if (String(comp[i]) === String(anchorId)) return true;
    return false;
  }
  function isContainer(id) {
    var e = D.p[id]; if (!e) return false;
    if (((e.sc || []).length + (e.comp || []).length) > 1) return true;
    return (e.vs || []).some(function (v) {
      return (((v.sc || e.sc || []).length) + ((v.comp || e.comp || []).length)) > 1;
    });
  }
  // true se il candidato contiene l'ancora in QUALUNQUE sua variante: per
  // l'esclusione (superficie A) la lettura prudente è la più larga.
  function bundleHolds(candidateId, anchorId) {
    var e = D.p[candidateId]; if (!e) return false;
    if (holdsAnchor(e.sc, e.comp, anchorId)) return true;
    return (e.vs || []).some(function (v) { return holdsAnchor(v.sc || e.sc, v.comp || e.comp, anchorId); });
  }
  /* Elenco dei contenitori acquistabili, CON la variante giusta: «Terra e Fuoco»
     sta nella Combinazione 1 del Set da 3 e non nella 2, e proporre la variante
     sbagliata è peggio che tacere. Mechanism only: il tetto sul salto di prezzo
     (`upgradeMaxMult`) è policy e vive nel catalogo. */
  function containersOf(productId, variantId) {
    var out = [];
    if (!D.p[productId] || isContainer(productId)) return out;
    Object.keys(D.p).forEach(function (id) {
      if (String(id) === String(productId)) return;
      var e = D.p[id];
      if (e.av === false || NEVER[id] || !isContainer(id)) return;
      var vs = (e.vs && e.vs.length) ? e.vs : null;
      if (vs) {
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].av === false || state.vsold[vs[i].id]) continue;
          if (holdsAnchor(vs[i].sc || e.sc, vs[i].comp || e.comp, productId)) {
            out.push({ id: parseInt(id, 10), variantId: vs[i].id, variantTitle: vs[i].t || '' });
            break;
          }
        }
      } else if (holdsAnchor(e.sc, e.comp, productId)) {
        out.push({ id: parseInt(id, 10), variantId: e.vid, variantTitle: '' });
      }
    });
    return out;
  }

  // firma leggera del SET di prodotti (per dedup impression e guardie anti-stale;
  // il ranking NON è mai cachato: si ricalcola a ogni render, così i cambi di
  // sola quantità — che muovono il subtotale e quindi il gap — riclassificano)
  function cartSignature(cart) {
    var ids = (cart.items || []).filter(function (i) { return !isGift(i) && !isAddon(i); })
      .map(function (i) { return i.product_id; });
    ids.sort();
    return ids.join(',');
  }
  function strHash(s) { var h = 5381; for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0; return Math.abs(h); }
  /* Finalizzatore a valanga (murmur3-style). Serve perche' djb2 ha i bit BASSI
     mal mescolati — h*33 = h*32 + h, quindi i bit bassi dipendono solo dai bit
     bassi — e lo slot esplorativo prende il modulo, cioe' usa proprio quelli.
     Senza questo, con un pool di 8 o 12 candidati alcune posizioni ricevevano
     ~un terzo di esplorazione in meno. */
  function mixHash(h) {
    h = h | 0;
    h ^= h >>> 16; h = Math.imul(h, 0x45d9f3b);
    h ^= h >>> 16; h = Math.imul(h, 0x45d9f3b);
    h ^= h >>> 16;
    return Math.abs(h | 0);
  }

  // entry del catalogo -> oggetto prodotto in forma Shopify (upsellHTML,
  // quick-add e anteprima consumano la stessa forma dei prodotti da API)
  function hydrate(id) {
    var e = D.p[id]; if (!e) return null;
    /* Unico punto in cui l'entry del catalogo diventa prodotto: correggere il
       prezzo qui sistema insieme ranking, card, quick-add e anteprima. */
    var ov = state.price[id];
    var pr = (ov && ov[0] != null) ? ov[0] : e.pr;
    var cp = (ov && ov[1] != null) ? ov[1] : (e.cp || 0);
    var variants = e.vs
      ? e.vs.map(function (v) { return { id: v.id, title: v.t, price: v.pr, available: v.av !== false && !state.vsold[v.id], option1: v.t, options: [v.t], compare_at_price: null }; })
      : [{ id: e.vid, title: 'Default Title', price: pr, available: e.av !== false, option1: 'Default Title', options: ['Default Title'], compare_at_price: null }];
    /* Nome breve e riga secondaria, per le card della pagina prodotto (dove la
       colonna di testo è ~184px a 390 e un titolo SEO su due righe è il difetto
       che si sta correggendo). Se il catalogo non li dichiara si ricavano dal
       titolo, che in questo negozio è scritto «nome - beneficio» oppure
       «nome | contenuto». ⚠️ È un RIPIEGO e non la regola: su alcuni titoli la
       spezzatura esce al contrario («Saponi Artigianali da Doccia - Set da 3»),
       ed è per questo che `n`/`d` stanno nel catalogo per tutti i prodotti
       proponibili. Il ripiego copre solo i prodotti nuovi non ancora curati.
       Sta qui e non nei blocchi perché `hydrate` è l'unico punto in cui una
       entry del catalogo diventa un prodotto: una copia sola per due superfici. */
    var pezzi = String(e.t || '').split(/\s+[-|]\s+/);
    return { id: parseInt(id, 10), handle: e.h, title: e.t,
             short_title: e.n || pezzi[0] || e.t,
             subtitle: e.d || (pezzi.length > 1 ? pezzi.slice(1).join(' \u00b7 ') : ''),
             price: pr, price_min: pr, price_varies: false,
             compare_at_price: cp, available: e.av !== false,
             featured_image: e.i || '', options: e.on ? [{ name: e.on }] : [],
             variants: variants };
  }

  /* `Wx`: i pesi di QUESTO contesto; `surface`: chi sta chiedendo. Il drawer non
     passa nulla — `ctx.W === W` e il comportamento resta byte-identico — mentre
     la pagina prodotto passa `pdpWeights()`. Senza questo le due superfici
     condividerebbero una sola taratura, e tararne una romperebbe l'altra. */
  function buildUpsellCtx(cart, Wx, surface) {
    var inCart = {}, cats = {}, covers = {}, bundleComp = {}, soapUnits = 0, soapContent = false;
    var scents = {}, scentCount = 0;
    /* `covers` = i reparti che il carrello COPRE, nello stesso vocabolario del
       candidato (`pv`), non la sua categoria. Per un singolo coincidono; per un
       set o un kit no: il Set da 3 è `cat: soapset` ma copre `soap`, il Kit
       Naturalis è `kit` ma copre sapone, shampoo, deo e crema. Confrontando
       `pv` con `cat` la complementarità non vedeva la sovrapposizione e
       proponeva il Kit Doccia a chi aveva il Set da 3 (merchant, 2026-10-02). */
    var cover = function (e) { (e.pv || (e.cat ? [e.cat] : [])).forEach(function (v) { covers[v] = true; }); };
    (cart.items || []).forEach(function (it) {
      inCart[it.product_id] = true;
      var e = D.p[it.product_id];
      if (e) {
        if (e.su) { soapUnits += e.su * it.quantity; soapContent = true; }
        if (e.cat) cats[e.cat] = true;
        cover(e);
      }
      // Un omaggio è lo stesso oggetto del suo gemello a pagamento: conta come
      // posseduto (e ne copre la categoria), ma NON somma unità di sapone —
      // non è un secondo prodotto, è lo stesso.
      (EQ[it.product_id] || []).forEach(function (pid) {
        inCart[pid] = true;
        var q = D.p[pid];
        if (q && q.cat) cats[q.cat] = true;
        if (q) cover(q);
        scentsOf(pid, null).forEach(function (id) {
          if (!scents[id]) { scents[id] = true; scentCount++; }
        });
        compsOf(pid, null).forEach(function (c) { bundleComp[c] = true; });
      });
      // profumazioni già possedute (variante per variante): è il dato che
      // permette di non riproporre un sapone contenuto in un set in carrello
      lineScents(it).forEach(function (id) {
        if (!scents[id]) { scents[id] = true; scentCount++; }
      });
      // direzione inversa del contenimento: un bundle in carrello blocca i suoi componenti ESATTI
      compsOf(it.product_id, it.variant_id).forEach(function (c) { bundleComp[c] = true; });
    });
    var anchors = (cart.items || []).filter(function (i) { return !isGift(i) && !isAddon(i); })
      .sort(function (a, b) { return b.final_line_price - a.final_line_price; }).slice(0, 3);
    var goal = nextUnmetGoal(cart);
    // tetto di raggiungibilità: se per chiudere la soglia serve un'aggiunta
    // spropositata rispetto al carrello, il layer soglia si SPEGNE (a un
    // carrello di 3 saponi non si propone un Set da 29,90€ solo perché
    // "chiude il gap": decide il resto del punteggio)
    var q = qualifyingSubtotal(cart);
    var Wc = Wx || W;
    var ceil = Math.max(Wc.gapCeilBase, Math.round(Wc.gapCeilPct * q));
    var gapOk = !!(goal && goal.gapCents <= ceil);
    return { cart: cart, inCart: inCart, anchors: anchors, cats: cats, covers: covers, bundleComp: bundleComp,
             soapUnits: soapUnits, soapContent: soapContent,
             scents: scents, scentCount: scentCount,
             goal: goal, gap: gapOk ? goal.gapCents : null,
             goalType: gapOk ? goal.type : null, goalLabel: gapOk ? goal.label : null,
             W: Wc, surface: surface || 'cart',
             // memoria fra superfici: si legge SOLO se la penalità è accesa (in
             // fase 1 è 0), e mai nel contesto della pagina prodotto — vedi
             // tools/hn-pdp.md §5.
             seen: (!surface || surface === 'cart') && Wc.seenPenalty > 0 ? seenFromPdpLog() : null,
             sig: cartSignature(cart) };
  }

  function candidatePrice(c) { return c.price != null ? c.price : (c.price_min != null ? c.price_min : 0); }

  // ritorna il MOTIVO di esclusione (per la diagnostica) o null se ammesso
  function upsellExcluded(c, ctx) {
    if (!c) return 'nullo';
    if (ctx.inCart[c.id]) return 'in_carrello';
    if (NEVER[c.id]) return 'blocklist';
    if (ctx.surface === 'cart' && CART_NEVER[c.id]) return 'escluso_carrello';
    if (c.available === false) return 'non_disponibile';
    if (state.stock[c.id] === false) return 'esaurito_verificato';
    if (state.upsellFailed[c.id]) return 'aggiunta_fallita';
    if (candidatePrice(c) <= 0) return 'prezzo_zero';
    if (ctx.bundleComp[c.id]) return 'componente_di_bundle_in_carrello';
    // anti-ripetizione esatta: se TUTTE le profumazioni che il candidato porta
    // sono già nel carrello, è una ripetizione (un sapone singolo contenuto in
    // un set, o un set più piccolo interamente compreso in uno più grande)
    var sc = scentsOf(c.id, null);
    if (sc.length) {
      var owned = 0; sc.forEach(function (id) { if (ctx.scents[id]) owned++; });
      if (owned === sc.length) return sc.length === 1 ? 'profumazione_posseduta' : 'saponi_tutti_posseduti';
    }
    var comps = compsOf(c.id, null);
    if (comps.length) {
      var hit = 0; comps.forEach(function (x) { if (ctx.inCart[x]) hit++; });
      if (hit / comps.length >= 0.5) return 'bundle_che_copre_il_carrello';
    }
    return null;
  }

  /* gapScore: 0..1. Sotto la soglia premia chi la avvicina, mai chi la chiude
     (max 0.55 a r=1) — discontinuità voluta: superare la soglia è
     qualitativamente diverso dall'avvicinarsi.
     SOPRA la soglia il picco NON è più "la chiude esatta" (price==gap): è
     gap + W.overshootTarget. Il merchant paga la spedizione comunque una
     volta sbloccata, quindi vuole spingere a superarla di un margine, non a
     fermarsi sul filo. Chi la chiude esatta resta comunque premiato (0.85,
     ben sopra il tetto 0.55 di chi non la chiude) — non è più il MASSIMO
     assoluto, quello ora è al bersaglio.
     overshootTarget:0 fa collassare questo ramo nella vecchia curva (picco a
     overshoot zero): è una valvola di rollback che si aziona editando SOLO
     il catalogo. */
  function gapScore(price, gap, Wx) {
    if (gap == null || gap <= 0 || price <= 0) return 0;
    var Wc = Wx || W;
    var r = price / gap;
    if (r < 1) return 0.55 * r * r;
    var over = price - gap;
    var target = Wc.overshootTarget || 0;
    if (target > 0 && over <= target) return 0.85 + 0.15 * (over / target);
    return 1 / (1 + (over - target) / Wc.overshootTol);
  }
  // massimo sulle ancore pesate (NON somma: tre saponi in carrello non devono
  // far vincere il quarto per accumulo); riga "*" come debole prior globale
  function affinityRaw(id, ctx) {
    var aw = [1, 0.6, 0.35], s = 0, k;
    ctx.anchors.forEach(function (a, i) {
      var row = D.a[a.product_id] || [];
      for (k = 0; k < row.length; k++) if (row[k][0] === id) { s = Math.max(s, (aw[i] || 0) * row[k][1] / 100); break; }
    });
    if (!s) {
      var g = D.a['*'] || [];
      for (k = 0; k < g.length; k++) if (g[k][0] === id) { s = 0.5 * g[k][1] / 100; break; }
    }
    return Math.min(1, s);
  }
  function dampedAffinity(c, ctx) {
    var s = affinityRaw(c.id, ctx);
    var e = D.p[c.id] || {};
    // smorzamento: candidato con contenuto-sapone su carrello con contenuto-sapone
    // (anti sapone-consiglia-sapone, vale anche sapone<->set), o stessa categoria
    if ((e.su > 0 && ctx.soapContent) || (e.cat && ctx.cats[e.cat])) s *= wOf(ctx).catDamp;
    return s;
  }
  // regola di dominio dichiarata (non appresa): gli accessori-sapone salgono
  // proporzionalmente a quante unità di sapone ci sono nel carrello
  function domainBoost(c, ctx) {
    var e = D.p[c.id] || {};
    if (!e.acc) return 0;
    return Math.min(1, ctx.soapUnits / wOf(ctx).domUnits);
  }
  /* "Completa la collezione": una profumazione che NON si possiede vale tanto
     più quante se ne possiedono già — chi ha il Set da 7 (7 su 9) si vedrebbe
     proporre Espresso Zen e Nèttare, le uniche due che nessun set contiene.
     DISATTIVATA per decisione commerciale (`newScent: 0` nel catalogo): vale
     €6,90 al margine più basso del catalogo e dice al cliente che il set che
     ha appena comprato è incompleto. Il meccanismo resta qui perché è una
     manopola: alzare `newScent` lo riaccende senza toccare il motore. */
  function newScentBoost(c, ctx) {
    var sc = scentsOf(c.id, null);
    if (sc.length !== 1 || ctx.scents[sc[0]]) return 0;
    // serve una collezione da completare: sotto scentMin profumazioni non c'è
    // nessun "completamento" da premiare, e spingere un altro sapone
    // riporterebbe il motore al vizio da cui siamo partiti (sapone su sapone,
    // il margine peggiore del catalogo).
    if (ctx.scentCount < wOf(ctx).scentMin) return 0;
    return Math.min(1, ctx.scentCount / wOf(ctx).scentFull);
  }
  /* Complementarità: premia chi apre territori scoperti. Serve DUE o più
     categorie nuove — cioè solo un set/kit può guadagnarlo, mai un prodotto
     singolo. Motivo: quasi ogni candidato porta almeno una categoria nuova, e
     un bonus piatto non discriminerebbe nulla (verificato dal vivo: valeva 0,23
     per tutti). Così il termine fa esattamente una cosa: far emergere
     l'espansione di categoria, es. Kit Doccia (saponi+shampoo) su un carrello
     di sola crema viso. Applicata SOLO dal secondo slot: vedi rankCandidates. */
  function complementarity(c, ctx) {
    var e = D.p[c.id] || {};
    var pv = e.pv || [];
    if (pv.length < 2) return 0;                      // solo set/kit multi-categoria
    // ZERO sovrapposizione, come la richiesta: "il set doccia che NON ha crema
    // viso". Se una sola categoria o un solo componente è già nel carrello, il
    // set ripete qualcosa e non è complementare — niente bonus. Questo esclude
    // il Kit Naturalis su un carrello con la crema (la contiene) e lascia il
    // Kit Doccia, che di quel carrello non ripete nulla.
    // ⚠️ `covers`, non `cats`: vedi buildUpsellCtx (Set da 3 = `soapset` ma copre `soap`)
    for (var i = 0; i < pv.length; i++) if (ctx.covers[pv[i]]) return 0;
    var comps = compsOf(c.id, null);
    for (var j = 0; j < comps.length; j++) if (ctx.inCart[comps[j]]) return 0;
    // Graduata sulla RISTRETTEZZA del carrello: espandere categoria ha senso
    // quando il cliente ne copre una sola (potenziale cliente "mono-reparto"),
    // molto meno quando ne ha già due, per nulla quando è già ampio. Evita che
    // un kit occupi lo slot 2 in ogni singolo carrello.
    // (l'ampiezza resta contata sulle categorie, come prima: è taratura, non il
    // difetto della sovrapposizione — se ne decide alla ritaratura del 29-10)
    var reparti = 0;
    for (var k in ctx.cats) if (Object.prototype.hasOwnProperty.call(ctx.cats, k)) reparti++;
    if (reparti >= 3) return 0;
    return reparti <= 1 ? 1 : 0.5;
  }
  /* Segnale di "valore" del candidato, pesato da W.mar. Mescola due bucket 0..10
     che stanno TUTTI nel catalogo (qui solo il meccanismo):
       mt = margine assoluto      ar = tasso di aggiunta osservato, smorzato
     W.addShare e' la quota che va al tasso di aggiunta: 0 = solo margine
     (comportamento storico, default del motore), 0.6 = scelta del merchant del
     2026-08-11.
     Se un prodotto NON ha `ar` si usa il solo margine: il catalogo assegna `ar`
     soltanto a chi ha esposizione sufficiente per dire qualcosa, e l'assenza di
     dati non deve spostare la policy (per i saponi singoli mt:1 e' deliberato,
     vedi CLAUDE.md: tirarli verso la media li rimetterebbe in gioco). */
  function valueSignal(e, Wx) {
    var mt = (e.mt || 0) / 10;
    if (typeof e.ar !== 'number') return mt;
    var share = (Wx || W).addShare || 0;
    return share * (e.ar / 10) + (1 - share) * mt;
  }
  function scoreCandidate(c, ctx) {
    var e = D.p[c.id] || {};
    var Wc = wOf(ctx);
    var parts = {
      gap: Wc.gap * gapScore(candidatePrice(c), ctx.gap, Wc),
      aff: Wc.aff * dampedAffinity(c, ctx),
      dom: Wc.dom * domainBoost(c, ctx),
      mar: Wc.mar * valueSignal(e, Wc),
      sce: Wc.newScent * newScentBoost(c, ctx),
      cmp: Wc.comp * complementarity(c, ctx)
    };
    /* Memoria fra superfici: PENALITÀ, non esclusione, sui prodotti che la
       pagina prodotto ha mostrato NEL VIEWPORT senza che il cliente li
       aggiungesse. Nasce a 0 (`seenPenalty`) perché è un'ipotesi e non un
       fatto: il merchant ha chiesto esplicitamente che ripetere un prodotto
       fra pagina e drawer resti permesso finché i dati non dicono altro. */
    if (ctx.seen && ctx.seen[c.id]) parts.seen = -(Wc.seenPenalty || 0);
    // base = punteggio per lo slot 1 (senza complementarità: il primo posto
    // resta al match per affinità/soglia reale). full = slot successivi.
    // I candidati che esistono SOLO come complementari (lista fc) hanno base 0:
    // non possono conquistare il primo posto né vincere per il solo margine.
    var base = c.__hnCompOnly ? 0
      : parts.gap + parts.aff + parts.dom + parts.mar + parts.sce + (parts.seen || 0) + (c.__hnPin ? 1000 : 0);
    return { base: base, full: base + parts.cmp, total: base + parts.cmp, parts: parts };
  }

  /* pool SINCRONO: pin -> affinità (ancore + globale) -> cross-sell -> margine.
     Ogni candidato porta la sua provenienza in __hnSrc (finisce nel tracking). */
  function syncCandidatePool(ctx) {
    var seen = {}, pool = [];
    function push(c, src, pin) {
      if (!c || seen[c.id]) return;
      seen[c.id] = true;
      c.__hnSrc = src; if (pin) c.__hnPin = true;
      pool.push(c);
    }
    (CFG.upsells.manualHandles || []).forEach(function (h) {
      var id = HANDLE_IDX[h];
      if (id) push(hydrate(id), 'pin', true);
      else if (state.pinCache[h]) push(state.pinCache[h], 'pin', true);
      else if (state.pinCache[h] !== null) state.pinsToFetch.push(h); // null = fetch già fallito
    });
    ctx.anchors.forEach(function (a) {
      (D.a[a.product_id] || []).forEach(function (row) { push(hydrate(row[0]), 'affinity'); });
    });
    (D.a['*'] || []).forEach(function (row) { push(hydrate(row[0]), 'affinity'); });
    (D.f || []).forEach(function (id) { push(hydrate(id), 'crosssell'); });
    (D.f2 || []).forEach(function (id) { push(hydrate(id), 'margin'); });
    // set/kit puramente complementari: entrano per ultimi (chi è già nel pool
    // conserva il punteggio normale) e con base zero -> solo slot >= 2
    (D.fc || []).forEach(function (id) {
      var before = pool.length;
      push(hydrate(id), 'complement');
      if (pool.length > before) pool[pool.length - 1].__hnCompOnly = true;
    });
    return pool;
  }

  /* `opts` (opzionale, solo per chi non è il drawer): `{seed, explorePct,
     shufflePct}`. Omesso, il comportamento è quello di sempre — nessuna
     duplicazione della funzione, che sarebbe la seconda copia da tenere
     allineata a mano, cioè il difetto numero uno di questo repo. */
  function rankCandidates(pool, ctx, limit, opts) {
    opts = opts || {};
    var scored = [];
    pool.forEach(function (c) {
      if (upsellExcluded(c, ctx)) return;
      scored.push({ c: c, sc: scoreCandidate(c, ctx) });
    });
    if (!scored.length) return [];
    // Ordinamento generale su "full" (complementarità inclusa) per gli slot >= 2.
    scored.sort(function (a, b) { return b.sc.full - a.sc.full; });
    // UN SOLO set complementare per render: ricevono tutti lo stesso punteggio
    // di complementarità e, senza questo limite, occuperebbero ogni slot
    // rimasto scacciando i candidati veri (verificato: tre kit di fila).
    var compSeen = false;
    scored = scored.filter(function (x) {
      if (!x.c.__hnCompOnly) return true;
      if (compSeen) return false;
      compSeen = true; return true;
    });
    var pins = 0; scored.forEach(function (x) { if (x.c.__hnPin) pins++; });
    // Il PRIMO slot non-pin si sceglie su "base", cioè SENZA complementarità:
    // il primo posto resta al match per affinità/soglia reale e un set
    // complementare non può scavalcarlo (scelta di prodotto). Slot 1 riservato
    // al gap-closer col punteggio base più alto — non col gapScore più alto:
    // con un gap minuscolo qualunque prodotto "chiude" e vincerebbe il più
    // economico (cioè un sapone). Solo quando il gap è raggiungibile: col tetto
    // spento la riserva reintrodurrebbe il pezzo grosso appena escluso.
    if (scored.length > pins) {
      var first = null;
      scored.forEach(function (x) {
        if (x.c.__hnPin) return;
        if (ctx.gap != null && candidatePrice(x.c) < ctx.gap) return; // in fase gap-closer
        if (!first || x.sc.base > first.sc.base) first = x;
      });
      if (!first) { // nessun gap-closer: il migliore su base, chiunque sia
        scored.forEach(function (x) {
          if (x.c.__hnPin) return;
          if (!first || x.sc.base > first.sc.base) first = x;
        });
      }
      if (first && scored.indexOf(first) > pins) {
        scored.splice(scored.indexOf(first), 1);
        scored.splice(pins, 0, first);
      }
    }
    /* Il drawer prende i primi `limit` così come sono. La pagina prodotto passa
       due regole in più (`opts.needs` / `opts.avoid`, da forProduct):
       - DUE PROPOSTE NON RISPONDONO MAI ALLO STESSO BISOGNO: niente Set da 3 e
         Set da 5 nella stessa fila, niente Kit Doccia accanto a uno shampoo;
       - con `avoid` (le proposte già mostrate nell'altro blocco) si prendono
         prima i bisogni NUOVI, poi gli altri prodotti nuovi, e solo in ultimo
         si ripete un prodotto: meglio un doppione che un gruppo monco.
       Il punteggio decide l'ordine dentro ciascun livello: le regole scelgono
       cosa si può mostrare insieme, non cosa vale di più. */
    var vincoli = !!(opts.needs || opts.avoid);
    var needsF = opts.needs || function () { return []; };
    var avoidIds = {}, avoidNeeds = [];
    (opts.avoid || []).forEach(function (id) {
      avoidIds[String(id)] = 1;
      needsF(id).forEach(function (n) { if (avoidNeeds.indexOf(n) < 0) avoidNeeds.push(n); });
    });
    var livello = function (x) {
      if (avoidIds[String(x.c.id)]) return 3;
      return sharesNeed(needsF(x.c.id), avoidNeeds) ? 2 : 1;
    };
    var compatibile = function (x, scelti) {
      var n = needsF(x.c.id);
      for (var i = 0; i < scelti.length; i++) if (sharesNeed(n, needsF(scelti[i].c.id))) return false;
      return true;
    };
    var out;
    if (!vincoli) out = scored.slice(0, limit);
    else {
      out = [];
      for (var lv = 1; lv <= 3 && out.length < limit; lv++) {
        scored.forEach(function (x) {
          if (out.length < limit && out.indexOf(x) < 0 && livello(x) === lv && compatibile(x, out)) out.push(x);
        });
      }
    }
    // slot esplorazione (~explorePct delle combinazioni carrello): l'ultimo
    // slot va a un candidato ammissibile FUORI classifica — è il generatore
    // di dati non distorti per le mappe future. Deterministico su token+set:
    // lo stesso carrello vede sempre la stessa proposta.
    var explorePct = (opts.explorePct != null) ? opts.explorePct : wOf(ctx).explorePct;
    var seedBase = (opts.seed != null && opts.seed !== '') ? String(opts.seed)
                 : String((ctx.cart && ctx.cart.token) || '') + '|' + ctx.sig;
    /* Fuori classifica, ma dentro le stesse regole: chi esplora rispetta i
       bisogni degli slot che restano e non scende di livello. */
    var rest = !vincoli ? scored.slice(limit) : scored.filter(function (x) {
      return out.length && out.indexOf(x) < 0 && compatibile(x, out.slice(0, -1)) &&
             livello(x) <= livello(out[out.length - 1]);
    });
    if (out.length >= 2 && rest.length > 0 && explorePct > 0) {
      /* DUE hash indipendenti, non uno. Usare lo stesso valore per decidere
         "questo carrello esplora?" (mod 100) e "quale candidato?" (mod pool)
         CORRELA le due decisioni quando il pool condivide fattori con 100.
         Misurato sull'implementazione precedente: con un pool di 10 candidati gli
         ultimi due ricevevano il 5,4% delle esplorazioni invece del 10% — meta'.
         Con pool 5, 8 e 12 lo stesso schema. Lo slot esiste per raccogliere dati
         NON distorti sui candidati fuori classifica, quindi una distorsione
         proprio qui e' il difetto peggiore possibile: falsa la taratura futura.
         Corretto il 2026-08-11; scostamento massimo ora ~5% su pool 5..15, cioe'
         rumore di campionamento. Test W1. */
      var hsh = mixHash(strHash(seedBase));
      if ((hsh % 100) < Math.round(explorePct * 100)) {
        var pick = rest[mixHash(strHash(seedBase + '|x')) % rest.length];
        if (pick && !out[out.length - 1].c.__hnPin) {
          pick.c.__hnSrc = 'explore';
          out[out.length - 1] = pick;
        }
      }
    }
    /* Scambio di POSIZIONE, solo se il chiamante lo chiede (il drawer non lo
       chiede mai). In fase 1 la pagina prodotto scambia i primi due nella metà
       delle visite: senza, lo slot 1 riceverebbe sempre lo stesso candidato e
       l'effetto-posizione resterebbe indistinguibile dal merito, falsando la
       taratura futura esattamente come farebbe un'esplorazione distorta.
       ⚠️ Seed INDIPENDENTE (`|pos`) da quelli dell'esplorazione, per la stessa
       ragione per cui gate e pick ne usano due: riusare lo stesso valore
       correla le due decisioni (misurato, vedi sopra). */
    if (opts.shufflePct > 0 && out.length >= 2 && !out[0].c.__hnPin && !out[1].c.__hnPin) {
      if ((mixHash(strHash(seedBase + '|pos')) % 100) < Math.round(opts.shufflePct * 100)) {
        var sw = out[0]; out[0] = out[1]; out[1] = sw;
      }
    }
    return out.map(function (x) { x.c.__hnScore = x.sc; return x.c; });
  }

  /* ------------------- pagina prodotto: contesto e ranking -------------------
     Le superfici della pagina prodotto (hn-pdp) riusano QUESTO motore invece di
     averne uno proprio: il carrello «virtuale» è il carrello reale più la riga
     del prodotto che si sta guardando, e da lì esclusioni, soglia, tetto di
     raggiungibilità e badge arrivano gratis e coerenti col drawer. */

  // Esclusioni proprie della pagina prodotto, IN AGGIUNTA a quelle del carrello.
  // Le inverse arrivano gratis dal carrello virtuale: su una pagina kit i
  // componenti escono per `componente_di_bundle_in_carrello`, su un set i saponi
  // contenuti per `profumazione_posseduta`.
  function pdpExcluded(c, ctx) {
    if (!c || !ctx.anchorId) return 'nullo';
    if (c.id === ctx.anchorId) return 'ancora';
    // esclusi dalla sola pagina prodotto (`w.pdp.never` nel catalogo): il carrello li propone ancora
    var nv = wOf(ctx).never || [];
    for (var n = 0; n < nv.length; n++) if (String(nv[n]) === String(c.id)) return 'escluso_pdp';
    var gem = EQ[ctx.anchorId] || [];
    for (var i = 0; i < gem.length; i++) if (String(gem[i]) === String(c.id)) return 'gemello_ancora';
    /* Un set che CONTIENE il prodotto che stai guardando non è un compagno, è un
       doppione. Ed è anche — per costruzione — esattamente il pool del pacchetto
       (Modo 1): è la ragione per cui le due superfici non possono proporre la
       stessa cosa senza doverle coordinare. */
    if (bundleHolds(c.id, ctx.anchorId)) return 'contiene_ancora';
    // stessa categoria = sostituto, non compagno. Nel drawer è solo smorzata
    // (catDamp), perché lì l'ancora è il carrello intero.
    if (wOf(ctx).sameCat === 'exclude') {
      var ea = D.p[ctx.anchorId] || {}, ec = D.p[c.id] || {};
      if (ea.cat && ec.cat && ea.cat === ec.cat) return 'stessa_categoria';
    }
    /* Stessa regola un livello più su: non la stessa CATEGORIA ma lo stesso
       BISOGNO. Su un kit che ha già tre saponi un Set da 7 è un doppione (tre
       profumazioni comprate due volte), e su un kit con lo shampoo antiforfora
       lo shampoo anticaduta è un sostituto. Le categorie da sole non lo vedono:
       `kit` e `soapset` sono categorie diverse da `soap`. */
    if (wOf(ctx).distinct && sharesNeed(needsOf(c.id), needsOf(ctx.anchorId))) return 'stesso_bisogno';
    return null;
  }

  function forProduct(o) {
    o = o || {};
    var anchorId = parseInt(o.productId || o.id, 10);
    var vuoto = { products: [], ctx: null, excluded: {} };
    if (!anchorId || !D.p[anchorId]) return vuoto;
    var e = D.p[anchorId];
    var base = o.cart || state.cart || readCartSnapshot() ||
               { items: [], currency: (BOOT && BOOT.currency) || '' };
    var items = (base.items || []).slice();
    // L'ancora entra nel carrello virtuale SOLO se non c'è già: altrimenti il
    // subtotale — e quindi il gap verso la soglia — la conterebbe due volte.
    var giaDentro = items.some(function (i) { return String(i.product_id) === String(anchorId); });
    var prezzo = o.price != null ? o.price : (e.pr || 0);
    if (!giaDentro) {
      items.push({ product_id: anchorId, variant_id: o.variantId || e.vid || null,
                   handle: o.handle || e.h || '', quantity: 1,
                   final_line_price: prezzo, final_price: prezzo,
                   original_line_price: prezzo, properties: {} });
    }
    var virtuale = { items: items, token: base.token || '', currency: base.currency || '',
                     attributes: base.attributes || {} };
    var ctx = buildUpsellCtx(virtuale, pdpWeights(), 'pdp');
    ctx.anchorId = anchorId;
    ctx.anchorVariantId = o.variantId || e.vid || null;
    ctx.anchorPrice = prezzo;
    ctx.virtualSubtotal = qualifyingSubtotal(virtuale);
    // in valuta estera il pool del catalogo si svuota (prezzi in valuta base):
    // stessa difesa del drawer, qui rafforzata dal gate Italia dello snippet
    var pool = isForeignCurrency(virtuale) ? [] : syncCandidatePool(ctx);
    var scartati = {};
    pool = pool.filter(function (c) {
      var m = pdpExcluded(c, ctx);
      if (m) { scartati[c.id] = m; return false; }
      return true;
    });
    var Wp = ctx.W;
    var shown = rankCandidates(pool, ctx, o.limit || Wp.limit || 2, {
      seed: o.seed,
      explorePct: DESIGN ? 0 : (o.explorePct != null ? o.explorePct : Wp.explorePct),
      shufflePct: DESIGN ? 0 : (o.shufflePct != null ? o.shufflePct : Wp.shufflePct),
      // un bisogno per proposta (spento con `distinct: 0` nel catalogo);
      // `avoid` = id già mostrati nell'altro blocco della pagina
      needs: Wp.distinct ? needsOf : null,
      avoid: (o.avoid && o.avoid.length) ? o.avoid : null
    });
    return { products: shown, ctx: ctx, excluded: scartati };
  }

  function renderUpsells(cart, emptyCart) {
    var host = els.body.querySelector('[data-hn-upsells]');
    if (!host) return;
    if (!(CFG.upsells && CFG.upsells.enabled) || emptyCart) { host.innerHTML = ''; return; }
    var ctx = buildUpsellCtx(cart);
    var limit = CFG.upsells.limit || 2;
    state.pinsToFetch = [];
    // Markets/valuta estera: i prezzi del catalogo sono in valuta BASE -> non
    // mostrarli (prezzo sbagliato su un bottone d'acquisto). Si usa solo la
    // rete (related/pin via .js, che risponde nella valuta di presentazione).
    var foreign = isForeignCurrency(cart);
    var pool = foreign ? [] : syncCandidatePool(ctx);
    var shown = rankCandidates(pool, ctx, limit);
    paintUpsells(host, shown, ctx);
    verifyStock(shown, host, limit);
    // fallback di rete SOLO se il pool utile è magro (catalogo assente/lacunoso/valuta estera)
    var usable = 0; pool.forEach(function (c) { if (!upsellExcluded(c, ctx)) usable++; });
    if (usable < limit * 2 && ctx.anchors.length && !state.relatedTried[ctx.sig]) {
      state.relatedTried[ctx.sig] = true;
      API.recommendations(ctx.anchors[0].product_id, 'related', 8).then(function (list) {
        if (!state.cart || cartSignature(state.cart) !== ctx.sig) return; // carrello cambiato: risposta stantia
        (list || []).forEach(function (p) { p.__hnSrc = 'related'; });
        var ctx2 = buildUpsellCtx(state.cart);
        paintUpsells(host, rankCandidates(pool.concat(list || []), ctx2, limit), ctx2);
      });
    }
    // pin configurati per handle ma assenti dal catalogo: idratali via rete una volta
    if (state.pinsToFetch.length) {
      var toFetch = state.pinsToFetch.slice(); state.pinsToFetch = [];
      Promise.all(toFetch.map(function (h) {
        return API.product(h).then(function (p) { state.pinCache[h] = p || null; });
      })).then(function () {
        if (!state.cart || cartSignature(state.cart) !== ctx.sig) return;
        var ctx3 = buildUpsellCtx(state.cart);
        paintUpsells(host, rankCandidates(syncCandidatePool(ctx3), ctx3, limit), ctx3);
      });
    }
  }

  /* Verifica DOPO il paint (mai prima) che i prodotti mostrati siano davvero
     acquistabili, e se non lo sono li sostituisce. Una richiesta per prodotto
     per sessione, non per apertura del drawer: l'esito sta in sessionStorage.
     Se la rete fallisce non cambia nulla — resta ciò che dice il catalogo. */
  /* Prezzo vivo dalla risposta di /products/<handle>.js, in cent.
     Si preferisce la variante che il catalogo indica (`vid`), altrimenti la prima
     acquistabile: è quella che il quick-add aggiungerebbe. Il prezzo pieno vale
     solo se è DAVVERO superiore, altrimenti niente barrato — la maggior parte dei
     prodotti ha compare_at uguale al prezzo, e barrare lo stesso numero è peggio
     che non barrarlo. */
  function livePriceOf(live) {
    var vs = (live && live.variants) || [];
    if (!vs.length) return null;
    var v = null;
    for (var i = 0; i < vs.length; i++) { if (vs[i].available !== false) { v = vs[i]; break; } }
    if (!v) v = vs[0];
    var pr = v.price != null ? v.price : (live.price != null ? live.price : null);
    if (pr == null) return null;
    var cp = v.compare_at_price || 0;
    return [pr, cp > pr ? cp : 0];
  }

  function verifyStock(products, host, limit) {
    var daVedere = (products || []).filter(function (p) {
      return p && p.handle && !checked(p.id);
    });
    if (!daVedere.length) return;
    /* Il prezzo si corregge solo in valuta base: con i Markets attivi non è
       dimostrato quale valuta restituisca questo endpoint a un visitatore estero,
       e mostrare un numero giusto nella valuta sbagliata sarebbe peggio del dato
       vecchio. Lo stock invece non dipende dalla valuta e si verifica sempre. */
    var prezziOk = !isForeignCurrency(state.cart);
    var sig = state.cart ? cartSignature(state.cart) : '';
    Promise.all(daVedere.map(function (p) {
      // productFull: la stessa richiesta delle verifiche dell'offerta, una sola per pagina
      return productFull(p.handle).then(function (live) {
        if (!live) return false;                     // risposta illeggibile: non si conclude nulla
        var vs = live.variants || [];
        var ok = live.available !== false && (!vs.length || vs.some(function (v) { return v.available !== false; }));
        rememberStock(p.id, ok);
        var varianti = rememberVariants(p.id, live);

        // Prezzo: si confronta col CATALOGO, non con quanto già memorizzato,
        // così confermare la normalità non costa una ripittura (errore fatto con
        // lo stock, presidiato da Q6) mentre una differenza vera la impone.
        var vuoleRidisegno = false;
        if (prezziOk) {
          var vivo = livePriceOf(live);
          var e = D.p[p.id];
          if (vivo && e) {
            var diverso = vivo[0] !== e.pr || vivo[1] !== (e.cp || 0);
            if (diverso) { rememberPrice(p.id, vivo[0], vivo[1]); vuoleRidisegno = true; }
            else if (forgetPrice(p.id)) { vuoleRidisegno = true; }
          }
        }
        // Si ridisegna SOLO se qualcosa è diventato non acquistabile o se un
        // prezzo mostrato è sbagliato: confermare che tutto è a posto (il caso
        // normale) non deve costare una ripittura a ogni apertura del carrello.
        return !ok || vuoleRidisegno || varianti;
      }).catch(function () { return false; });
    })).then(function (esauriti) {
      if (!esauriti.some(Boolean)) return;
      if (!state.cart || cartSignature(state.cart) !== sig) return;  // carrello cambiato: risposta stantia
      var ctx2 = buildUpsellCtx(state.cart);
      paintUpsells(host, rankCandidates(syncCandidatePool(ctx2), ctx2, limit), ctx2);
    });
  }

  /* La stessa verifica, SENZA ridisegnare il drawer: è la versione che serve
     alla pagina prodotto, che ha un DOM suo. Stesse due regole del drawer —
     si memorizzano solo le correzioni vere (Q6) e il prezzo non si tocca in
     valuta estera (Q8) — e la stessa cache di sessione, quindi una pagina e il
     carrello non interrogano due volte lo stesso handle. */
  /* /products/<handle>.js UNA volta per pagina: la verifica qui sotto e
     l'anteprima prodotto di hn-pdp leggono la stessa risposta, quindi
     l'anteprima si apre coi dati già in mano invece di aspettare la rete. Una
     risposta illeggibile non si tiene: alla richiesta dopo si riprova. Il drawer
     resta su `API.product` diretto, com'era. */
  var productMemo = {};
  function productFull(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productMemo[handle]) {
      productMemo[handle] = API.product(handle).then(function (p) {
        if (!p) delete productMemo[handle];
        return p;
      });
    }
    return productMemo[handle];
  }
  function verifyStockFor(products) {
    var vuoto = { changed: false, sold: [], priced: [], vsold: [] };
    var da = (products || []).filter(function (p) { return p && p.handle; });
    if (!da.length) return Promise.resolve(vuoto);
    var prezziOk = !isForeignCurrency(state.cart || { currency: (BOOT && BOOT.currency) || '' });
    var sold = [], priced = [], vsold = [];
    return Promise.all(da.map(function (p) {
      if (checked(p.id)) {
        if (state.stock[p.id] === false) sold.push(p.id);
        return null;                       // già verificato in questa sessione
      }
      return productFull(p.handle).then(function (live) {
        if (!live) return;                 // risposta illeggibile: non si conclude nulla
        var vs = live.variants || [];
        var ok = live.available !== false && (!vs.length || vs.some(function (v) { return v.available !== false; }));
        rememberStock(p.id, ok);
        if (!ok) sold.push(p.id);
        // una combinazione esaurita in un prodotto che si vende: chi l'ha scelta deve rifare la scelta
        if (rememberVariants(p.id, live) && ok) vsold.push(p.id);
        if (!prezziOk) return;
        var vivo = livePriceOf(live), e = D.p[p.id];
        if (!vivo || !e) return;
        if (vivo[0] !== e.pr || vivo[1] !== (e.cp || 0)) {
          if (rememberPrice(p.id, vivo[0], vivo[1])) priced.push(p.id);
        } else if (forgetPrice(p.id)) { priced.push(p.id); }
      }).catch(function () {});
    })).then(function () {
      return { changed: !!(sold.length || priced.length || vsold.length), sold: sold, priced: priced, vsold: vsold };
    });
  }

  function paintUpsells(host, products, ctx) {
    if (!products.length) { host.innerHTML = ''; return; }
    // titolo onesto: "Comprati Spesso Insieme" per pin/affinità, "Ti potrebbe
    // piacere" quando il set viene tutto dai fallback generici
    var fallbackOnly = products.every(function (p) {
      return p.__hnSrc === 'related' || p.__hnSrc === 'crosssell' ||
             p.__hnSrc === 'margin' || p.__hnSrc === 'complement';
    });
    var heading = fallbackOnly ? (t('recommendedHeading') || t('upsellsHeading')) : t('upsellsHeading');
    host.innerHTML =
      '<div class="hn-fbt"><div class="hn-fbt__head">' + esc(heading) + '</div>' +
      '<div class="hn-fbt__list">' + products.map(function (p, i) { return upsellHTML(p, ctx, i); }).join('') + '</div></div>';
    noteImpressions(products, ctx.cart);
    function prodById(id) { return products.filter(function (x) { return x.id === id; })[0]; }
    host.querySelectorAll('[data-hn-up-add]').forEach(function (btn) {
      var prod = prodById(parseInt(btn.getAttribute('data-hn-up-add'), 10)); if (!prod) return;
      btn.addEventListener('click', function () { quickAddUpsell(prod, btn, products.indexOf(prod)); });
    });
    host.querySelectorAll('[data-hn-up-details]').forEach(function (link) {
      var prod = prodById(parseInt(link.getAttribute('data-hn-up-details'), 10)); if (!prod) return;
      link.addEventListener('click', function () {
        track('hn_select_item', upsellMeta(prod, products.indexOf(prod)));
        openProductPreview(prod, link, upsellMeta(prod, products.indexOf(prod)));
      });
      if (link.tagName !== 'BUTTON') { // immagine/titolo: aggiungi la semantica/tastiera che non hanno di natura
        link.setAttribute('role', 'button'); link.setAttribute('tabindex', '0');
        link.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openProductPreview(prod, link); } });
      }
    });
    if (HN_DEBUG) reportUpsellDebug(host, products, ctx);
  }

  // Diagnostica su pagina (solo ?hncartdebug=1): stato reale dello scorer —
  // versione mappa, subtotale idoneo, soglia/gap attivo, e per ogni card il
  // punteggio scomposto nei layer. Uno screenshot basta a capire PERCHÉ il
  // motore ha scelto così (procedura CLAUDE.md: ground truth, non ipotesi).
  function reportGiftDebug() {
    try {
      if (!els.body || els.body.querySelector('[data-hn-giftdbg]')) return;
      var dbg = document.createElement('div');
      dbg.setAttribute('data-hn-giftdbg', '');
      dbg.style.cssText = 'font:10px/1.5 monospace;color:#5a3b00;background:#fffbe6;border:1px solid #e6d98a;' +
        'padding:4px 6px;margin-top:6px;border-radius:4px;word-break:break-all;white-space:pre-wrap';
      var t = 'HNDBG-REGALI  ' + (giftDbg.motivo || '-') +
        (giftDbg.orfani ? '  | orfani rimossi: ' + giftDbg.orfani : '') +
        (giftErr.valore ? '  | RIFIUTI: ' + giftErr.valore : '');
      /* set a scelta: il motore li conosce? quali saponi ci sono? quante righe ha corretto? */
      var bt = 'HNDBG-SET  ' + (BYS ? ('attivo | set ' + Object.keys(BYS.sets).length + ' | saponi (ordine del pannello, 1 = disponibile): ' +
        BYS.soaps.map(function (x) { return x.id + '=' + (x.a ? 1 : 0); }).join(' ') +
        ' | righe sistemate: ' + (bysDbg.fatte.length ? bysDbg.fatte.join('; ') : 'nessuna') + (bysDbg.ultimo ? ' | ' + bysDbg.ultimo : ''))
        : 'spento (HN_CART_BOOT.bys ' + (BOOT.bys ? 'presente ma non valido' : 'assente') + ')');
      giftDbg.righe.forEach(function (r) {
        t += '\n* ' + r.etichetta + '  [' + r.innesco + ']  variante ' + r.variante +
          '  spetta=' + r.merita + '  in carrello=' + r.giaPresente +
          (r.aMano ? ' (AGGIUNTO A MANO, senza marca)' : '') +
          (r.doppioni ? '  doppioni tolti=' + r.doppioni : '') + '  -> ' + r.esito;
      });
      dbg.textContent = t + '\n' + bt;
      els.body.appendChild(dbg);
    } catch (e) {}
  }

  function reportUpsellDebug(host, products, ctx) {
    try {
      var dbg = document.createElement('div');
      dbg.setAttribute('data-hn-updbg', '');
      dbg.style.cssText = 'font:10px/1.4 monospace;color:#046;background:#f0f8ff;border:1px solid #09c;padding:4px 6px;margin-top:4px;border-radius:4px;word-break:break-all';
      dbg.textContent = 'HNDBG-UPSELL map=' + mapVersion() + ' q=' + qualifyingSubtotal(ctx.cart) +
        ' goal=' + (ctx.goal ? ctx.goal.type + '@' + ctx.goal.gapCents : '-') +
        ' gapAttivo=' + (ctx.gap != null) + ' saponi=' + ctx.soapUnits +
        ' profumazioni=' + ctx.scentCount + '/9 | ' +
        products.map(function (p) {
          var s = p.__hnScore;
          return p.id + ':' + p.__hnSrc + (s ? ':base' + s.base.toFixed(2) + '/full' + s.full.toFixed(2) +
            '(g' + s.parts.gap.toFixed(2) + '/a' + s.parts.aff.toFixed(2) +
            '/d' + s.parts.dom.toFixed(2) + '/m' + s.parts.mar.toFixed(2) +
            '/s' + s.parts.sce.toFixed(2) + '/c' + s.parts.cmp.toFixed(2) + ')' : '');
        }).join(' ');
      host.appendChild(dbg);
    } catch (e) {}
  }

  function upsellHTML(p, ctx, idx) {
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
    var price = candidatePrice(p);
    var prefix = (p.price_varies ? 'da ' : '');
    var cmp = p.compare_at_price || p.compare_at_price_min || 0; // prezzo pieno (se in saldo)
    var priceHtml = (cmp > price ? '<s>' + money(cmp) + '</s> ' : '') + prefix + money(price);
    // badge soglia: solo se questo candidato CHIUDE il prossimo traguardo
    // (testo di config con <b> voluti — stessa convenzione della barra premi)
    // ⚠️ Sul gap GREZZO (ctx.goal), non su ctx.gap: il tetto di raggiungibilità
    // decide se INSEGUIRE un chiusore costoso (ranking/slot 1), ma qui il
    // prodotto è già in vetrina per altri meriti (margine, affinità) — se
    // aggiungerlo sblocca davvero il traguardo, dirlo è un fatto vero, non un
    // inseguimento. Nascondere un'informazione vera al cliente non serve a
    // niente: il tetto qui spegnerebbe un badge corretto senza motivo.
    var badge = '';
    if (ctx && ctx.goal && price >= ctx.goal.gapCents) {
      badge = ctx.goal.type === 'shipping' ? t('upsellUnlockShipping')
            : ctx.goal.type === 'gift' ? t('upsellUnlockGift')
            : t('upsellUnlockGeneric', { label: esc(ctx.goal.label || '') });
    }
    return '<div class="hn-up" data-id="' + p.id + '">' +
      (img ? '<img class="hn-up__img" src="' + esc(img) + '" alt="" loading="lazy" data-hn-up-details="' + p.id + '">' : '<div class="hn-up__img" data-hn-up-details="' + p.id + '"></div>') +
      '<div class="hn-up__main">' +
        '<p class="hn-up__title" data-hn-up-details="' + p.id + '">' + esc(p.title) + '</p>' +
        '<div class="hn-up__price">' + priceHtml + '</div>' +
        (badge ? '<div class="hn-up__unlock">' + badge + '</div>' : '') +
      '</div>' +
      '<button class="hn-up__add" data-hn-up-add="' + p.id + '">' + esc(t('add')) + '</button>' +
    '</div>';
  }

  /* --------------------- ANTEPRIMA PRODOTTO (upsell) --------------------- */
  // "Aggiungi" aggiunge SEMPRE subito (prima variante disponibile), a prescindere da quante
  // varianti esistono: la scelta della variante si fa nell'anteprima (Dettagli/immagine/titolo).
  function quickAddUpsell(p, btn, idx) {
    var variants = p.variants || [];
    var v = variants.filter(function (x) { return x.available !== false; })[0] || variants[0];
    if (!v || v.available === false) { announce(t('soldOut')); return; }
    addVariant(v.id, 1, null, btn, null, upsellMeta(p, idx));
  }
  function stripHtml(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }
  /* Le descrizioni reali sono lunghe (1.500-2.500 caratteri) e STRUTTURATE:
     paragrafi, una <table> con "Profuma di / Elementi principali / Potere
     esfoliante" — cioè i fatti che servono a decidere — e una <ul>. textContent
     le appiattiva in un muro di testo unico e il taglio a 320 caratteri le
     troncava dopo il primo paragrafo, prima della tabella. Qui i confini di
     blocco diventano \n (resi da white-space:pre-line) e il testo resta
     ESCAPATO: nessun HTML del prodotto entra nel DOM del carrello, quindi le
     <img> decorative e le tabelle non possono sfondare il layout.
     ⛔ Tranne il GRASSETTO (dal 2026-10-02, merchant: «perché non ha bold?»):
     nelle descrizioni vere segna le etichette che guidano la lettura — «Profuma
     di:», «Caratteristiche principali:», «Peso: 100g». Attraversa textContent e
     l'escape come due caratteri di controllo, e solo alla fine diventa <b>:
     markup NOSTRO, senza attributi. Nessun altro tag del prodotto entra.
     ⚠️ Si legge in un documento INERTE (createHTMLDocument), non in un <div>
     della pagina: lì le <img> decorative partivano davvero (richieste per foto
     mai mostrate) e un `onerror` scritto nella descrizione sarebbe girato. */
  var DESC_MAX = 1200, B_ON = '\u0001', B_OFF = '\u0002';
  function descText(html, keepBold) {
    var doc = (document.implementation && document.implementation.createHTMLDocument)
      ? document.implementation.createHTMLDocument('') : document;
    var d = doc.createElement('div');
    d.innerHTML = String(html || '').replace(/[\u0001\u0002]/g, '');
    d.querySelectorAll('br').forEach(function (b) {
      if (b.parentNode) b.parentNode.replaceChild(doc.createTextNode('\n'), b);
    });
    d.querySelectorAll('li').forEach(function (el) {
      el.insertBefore(doc.createTextNode('• '), el.firstChild);
    });
    d.querySelectorAll('p,div,li,tr,h1,h2,h3,h4,h5,h6').forEach(function (el) {
      el.appendChild(doc.createTextNode('\n'));
    });
    if (keepBold) d.querySelectorAll('b,strong').forEach(function (el) {
      el.insertBefore(doc.createTextNode(B_ON), el.firstChild);
      el.appendChild(doc.createTextNode(B_OFF));
    });
    return (d.textContent || '')
      .replace(/[^\S\n]+/g, ' ')   // spazi orizzontali multipli (nbsp inclusi), newline salvi
      .replace(/ *\n */g, '\n')
      .replace(/\u0001(\s*)\u0002/g, '$1')   // grassetti vuoti
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }
  function descHTML(html) {
    var txt = descText(html, true);
    if (txt.length > DESC_MAX) txt = txt.slice(0, DESC_MAX).replace(/\s+\S*$/, '') + '…';
    // il taglio può cadere dentro un grassetto: si chiude ciò che è rimasto aperto
    var open = 0;
    var out = esc(txt).replace(/[\u0001\u0002]/g, function (c) {
      if (c === B_ON) { open++; return '<b>'; }
      if (!open) return '';
      open--; return '</b>';
    });
    while (open > 0) { out += '</b>'; open--; }
    return out;
  }

  function openProductPreview(p, trigger, meta) {
    state.popTrigger = trigger || null; // per restituire il focus alla chiusura
    state.popMeta = meta || null;       // attribuzione: l'aggiunta dall'anteprima resta un'aggiunta da upsell
    state.popGift = null;               // una risposta in ritardo per un omaggio non scrive qui
    renderPreview(p);
    els.pop.classList.add('is-open');
    els.popCard.setAttribute('aria-label', p.title || '');
    var firstF = els.popCard.querySelector('select,button');
    if (firstF) firstF.focus();
    // se la descrizione manca (spesso nei "consigliati"), prendi il prodotto completo e riempi
    if ((!p.description || !stripHtml(p.description)) && p.handle) {
      API.product(p.handle).then(function (full) {
        if (!full || !els.pop.classList.contains('is-open')) return;
        p.description = full.description;
        if (!p.variants || !p.variants.length) { p.variants = full.variants; p.options = full.options; renderPreview(p); }
        else { var dnode = els.popCard.querySelector('[data-hn-pop-desc]'); if (dnode) dnode.innerHTML = descHTML(full.description); }
      });
    }
  }

  /* ANTEPRIMA DI UN OMAGGIO (dal 2026-10-14): la stessa scheda dei consigliati, ma SOLO
     informazioni — foto, nome, descrizione, «Gratis» col prezzo vero barrato e una riga che dice
     che e' gia' nel carrello. Niente varianti e niente «Aggiungi al carrello»: un omaggio non si
     sceglie e non se ne prende un altro. La descrizione e' quella del prodotto omaggio; se l'omaggio
     non ne ha, quella del gemello a pagamento (x.eq: id diversi, stesso oggetto per il cliente). */
  function openGiftPreview(it, trigger) {
    var p = { id: it.product_id, handle: it.handle, title: it.product_title, featured_image: it.image || '',
              description: '', variants: [], options: [],
              hnGift: { was: Math.round(giftTwinPrice(it) / (it.quantity || 1)) || 0 } };
    state.popTrigger = trigger || null;
    state.popMeta = null;
    state.popGift = p;
    renderPreview(p);
    els.pop.classList.add('is-open');
    els.popCard.setAttribute('aria-label', p.title || '');
    var x = els.popCard.querySelector('button'); if (x) { try { x.focus(); } catch (e) {} }
    var twin = (EQ[it.product_id] || []).map(function (id) { return D.p[id]; }).filter(function (e) { return e && e.h; })[0];
    function pieno(full) { return !!(full && full.description && descText(full.description)); }
    productFull(it.handle).then(function (full) {
      if (pieno(full) || !twin) return { own: full, desc: full };
      return productFull(twin.h).then(function (tf) { return { own: full, desc: pieno(tf) ? tf : null }; });
    }).then(function (r) {
      if (!r || state.popGift !== p || !els.pop.classList.contains('is-open')) return;
      var dnode = els.popCard.querySelector('[data-hn-pop-desc]');
      if (dnode && r.desc) dnode.innerHTML = descHTML(r.desc.description);
      var src = !p.featured_image && r.own && (r.own.featured_image || (r.own.images && r.own.images[0]));
      var scroll = els.popCard.querySelector('.hn-pop__scroll');
      if (src && scroll && !scroll.querySelector('.hn-pop__img')) {
        scroll.insertAdjacentHTML('afterbegin', '<img class="hn-pop__img" src="' + esc(popImg(src)) + '" alt="">');
      }
    }).catch(function () {});
  }
  function openGiftFromEl(el) {
    var key = itemKeyFromEl(el);
    var it = key && state.cart && (state.cart.items || []).filter(function (x) { return x.key === key; })[0];
    if (!it) return;
    var row = el.closest('.hn-item');
    openGiftPreview(it, (row && row.querySelector('[data-hn-gift-info][tabindex]')) || el);
  }
  // immagine dell'anteprima: assoluta, e dal CDN alla misura che serve (la scheda e' larga 210 px)
  function popImg(src) {
    var img = String(src || '');
    if (img.indexOf('//') === 0) img = 'https:' + img;
    if (/cdn\.shopify\.com/.test(img) && !/[?&]width=/.test(img)) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=600';
    return img;
  }

  function renderPreview(p) {
    var opts = p.options || [];
    var optNames = opts.map(function (o) { return typeof o === 'string' ? o : o.name; })
      .filter(function (n) { return n && n !== 'Title'; }); // ignora l'opzione fittizia dei prodotti a variante unica
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var gift = p.hnGift || null;
    if (gift && img) img = popImg(img);

    function optionsSelectors() {
      return optNames.map(function (name, i) {
        var values = distinctValues(p.variants, i);
        return '<div class="hn-pop__opt"><label>' + esc(name) + '</label><select data-opt="' + i + '">' +
          values.map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + '</option>'; }).join('') +
          '</select></div>';
      }).join('');
    }
    // immagine, titolo e descrizione scorrono; varianti, prezzo e CTA restano
    // sempre visibili nel piede (il prezzo cambia col variante selezionato:
    // se scorresse via non si vedrebbe più cosa si sta aggiungendo)
    els.popCard.innerHTML =
      '<button class="hn-pop__close" data-hn-pop-close aria-label="Chiudi">&times;</button>' +
      '<div class="hn-pop__scroll">' +
        (img ? '<img class="hn-pop__img" src="' + esc(img) + '" alt="">' : '') +
        '<p class="hn-pop__title">' + esc(p.title) + '</p>' +
        '<div class="hn-pop__desc" data-hn-pop-desc>' + descHTML(p.description) + '</div>' +
      '</div>' +
      '<div class="hn-pop__foot">' +
        (gift
          ? '<p class="hn-pop__price">' + (gift.was > 0 ? '<s>' + money(gift.was) + '</s>' : '') +
              '<span class="hn-item__free">' + esc(t('free')) + '</span></p>' +
            (t('giftInfo') ? '<p class="hn-pop__giftnote">' + esc(t('giftInfo')) + '</p>' : '')
          : optionsSelectors() +
            '<p class="hn-pop__price" data-hn-pop-price></p>' +
            '<button class="hn-pop__add" data-hn-pop-add>' + esc(t('addToCart')) + '</button>') +
      '</div>';
    if (gift) return; // un omaggio: solo informazioni, niente da scegliere e niente da aggiungere
    var priceEl = els.popCard.querySelector('[data-hn-pop-price]');
    var addBtn = els.popCard.querySelector('[data-hn-pop-add]');

    function currentVariant() {
      var sels = [].slice.call(els.popCard.querySelectorAll('select[data-opt]'));
      if (!sels.length) return (p.variants || [])[0]; // variante unica
      var sel = sels.map(function (s) { return s.value; });
      return (p.variants || []).find(function (v) {
        return sel.every(function (val, i) {
          var vv = v['option' + (i + 1)] != null ? v['option' + (i + 1)] : (v.options && v.options[i]);
          return String(vv) === String(val);
        });
      });
    }
    function sync() {
      var v = currentVariant();
      if (!v) { priceEl.textContent = '—'; addBtn.disabled = true; return; }
      priceEl.textContent = money(v.price);
      addBtn.disabled = v.available === false;
      addBtn.textContent = v.available === false ? t('soldOut') : t('addToCart');
    }
    els.popCard.querySelectorAll('select[data-opt]').forEach(function (s) { s.addEventListener('change', sync); });
    addBtn.addEventListener('click', function () {
      var v = currentVariant(); if (!v || v.available === false) return;
      addVariant(v.id, 1, null, addBtn, function () { closeVariantPopup(); },
        state.popMeta ? Object.assign({}, state.popMeta, { hn_via: 'popup' }) : null);
    });
    sync();
  }
  function distinctValues(variants, i) {
    var seen = Object.create(null), out = []; // set senza prototype: non perde valori tipo "toString"/"constructor"
    (variants || []).forEach(function (v) {
      var val = v['option' + (i + 1)] != null ? v['option' + (i + 1)] : (v.options && v.options[i]);
      if (val != null && !seen[val]) { seen[val] = 1; out.push(val); }
    });
    return out;
  }
  function closeVariantPopup() {
    els.pop.classList.remove('is-open'); els.popCard.innerHTML = '';
    state.popGift = null;
    if (state.popTrigger && state.popTrigger.focus) { try { state.popTrigger.focus(); } catch (e) {} } // ripristina il focus al trigger
    state.popTrigger = null;
  }

  /* ----------------------- OFFERTA AL CHECKOUT (hn_co) -----------------------
     Il foglio «Hai sbloccato un'offerta per questo ordine» che sale DENTRO il
     drawer al clic su «Procedi all'ordine». Decisioni del merchant del
     2026-10-04; contratto, misura e pre-registrazione in tools/hn-co.md.
     UNA proposta sola per foglio (merchant, stesso giorno: «non tutti e 3, uno
     solo, e scrivi qualcosa per venderlo bene»): o un SALTO (togli cio' che hai,
     prendi il set o il kit che lo contiene), o un prodotto in offerta col suo
     testo di vendita. Quale, lo decide una politica che esplora con criterio e
     registra la propria probabilita' (dal 2026-10-05: «troppo deterministico,
     voglio dati su qualsiasi carrello e poi ottimizzare insieme»).
     Qui solo il MECCANISMO:
     - i prodotti in offerta e il loro sconto stanno nel catalogo
       (`x.co` = {pid: [importo in centesimi, "CODICE", bucket di margine dopo lo
       sconto]}); il codice esiste
       nell'admin con lo stesso importo (guardia: tools/hn-co-audit.mjs);
     - come si sceglie (il valore atteso qui sotto), esplorazione, scelta forzata
       per segmento e segmenti ammessi in `w.co`;
     - i testi di vendita di ogni prodotto nei BLOCCHI «Offerta: testo prodotto»
       della sezione HN Cart (`CFG.co.offers`), riscrivibili dall'editor;
     - testi comuni e quota del gruppo di controllo nelle impostazioni della sezione.
     ⚠️ Il prezzo mostrato e' SEMPRE prezzo vivo − importo del codice: e' lo
     stesso conto che fa Shopify, quindi non puo' dire un numero diverso dal
     checkout neanche se domani il merchant cambia il prezzo pieno.
     ⚠️ Niente classi con «checkout» e niente «Procedi all'ordine» qui dentro:
     in GTM due attivatori A CLIC («Begin Checkout», «Begin Checkout 2») li
     guardano, e il foglio farebbe partire due volte begin_checkout.
     ⚠️ Qualunque errore porta al pagamento come prima: il foglio non deve mai
     poter trattenere un cliente che stava pagando. */
  var WCO_DEFAULTS = { v: 'co0', gap: 0, explorePct: 0.1, floor: 0.5, upgradeMaxMult: 7, declineDays: 7, maxShows: 1, only: [], pick: {},
                       priceK: 0, discK: 0, affK: 0, viewBoost: 1, viewDays: 0, prior: {}, never: [] };
  var WCOm = null;
  function coWeights() {
    if (WCOm) return WCOm;
    WCOm = deepMerge(deepMerge(W, WCO_DEFAULTS), (D.w && D.w.co) || {});
    WCOm.seenPenalty = 0; // la memoria fra superfici e' del drawer, non di questo foglio
    return WCOm;
  }
  var CO_TABLE = (D.x && D.x.co) || {};
  /* prodotti che il foglio non propone mai, ne' come aggiunta ne' come salto (`w.co.never`, policy
     nel catalogo): la loro riga in `x.co` puo' restare per altre superfici (il post-acquisto) */
  function coNever(id) {
    return (coWeights().never || []).some(function (x) { return String(x) === String(id); });
  }
  var CO_SEEN_KEY = 'hn_co_seen', CO_NO_KEY = 'hn_co_no', CO_FORCE_KEY = 'hn_co_force',
      CO_N_KEY = 'hn_co_n', CO_NT_KEY = 'hn_co_n_t';
  /* prodotti la cui pagina il cliente ha aperto: `n` del registro di sessione di
     hn-pdp.js e `hn_pv` (localStorage, id -> istante), scritto dallo stesso file */
  var CO_PV_KEY = 'hn_pv';
  var co = { open: false, plan: null, busy: false, el: null, forced: false,
             shows: [0, 0], // apparizioni in memoria [vere, di prova]: tengono il limite anche senza sessionStorage
             nav: function (u) { window.location.href = u; } };

  function coCfg() { return CFG.co || {}; }
  function fnv1a(s) {
    var x = 0x811c9dc5;
    for (var j = 0; j < s.length; j++) { x ^= s.charCodeAt(j); x = Math.imul(x, 16777619) >>> 0; }
    return x;
  }
  /* Lo STESSO visitatore del motore A/B e del gruppo di controllo della pagina
     prodotto (`hn_ab_uid`, stessa lettura di snippets/hn-pdp.liquid), con un
     SALE diverso per ogni sorteggio: i gruppi sono indipendenti fra loro e da
     qualunque esperimento. Se il browser non conserva dati non si sorteggia:
     braccio 0 e niente gruppo di controllo. */
  function coUid() {
    var u = '';
    try { u = window.localStorage.getItem('hn_ab_uid') || ''; } catch (e) {}
    if (!/^[0-9a-f]{16}$/.test(u)) {
      var c = document.cookie.match(/(?:^|; )hn_ab_uid=([0-9a-f]{16})/);
      u = c ? c[1] : '';
    }
    if (!/^[0-9a-f]{16}$/.test(u)) {
      u = '';
      try {
        var b = new Uint8Array(8);
        window.crypto.getRandomValues(b);
        for (var i = 0; i < 8; i++) u += ('0' + b[i].toString(16)).slice(-2);
        window.localStorage.setItem('hn_ab_uid', u);
        if (window.localStorage.getItem('hn_ab_uid') !== u) u = '';
      } catch (e) { u = ''; }
    }
    return u;
  }
  function coDraw(uid, salt, pct) { return (uid && pct > 0 && (fnv1a(uid + '|' + salt) % 100) < pct) ? 1 : 0; }
  /* ?hnco=on: il foglio compare SEMPRE su questo dispositivo (finche' non si
     scrive ?hnco=off) ed e' fuori dalla misura — niente attributo, niente
     eventi, niente memoria di «gia' visto». E' il modo di guardarlo dal
     telefono senza sporcare i dati. */
  function coForced() {
    var q = window.location.search || '', f = false;
    try {
      if (/[?&]hnco=on(&|$)/.test(q)) window.localStorage.setItem(CO_FORCE_KEY, '1');
      if (/[?&]hnco=off(&|$)/.test(q)) window.localStorage.removeItem(CO_FORCE_KEY);
      f = window.localStorage.getItem(CO_FORCE_KEY) === '1';
    } catch (e) {}
    return f || /[?&]hnco=on(&|$)/.test(q);
  }
  /* Quante volte il foglio si e' visto in questa visita. Dal 2026-10-14 al massimo `maxShows` (2;
     merchant: «quando esce l'upsell e il cliente torna indietro deve essere possibile solo 2 volte,
     magari non ha letto "Rifiuto l'offerta" e spinge indietro; dopo la seconda volta che lo vede si
     va direttamente al checkout»). Fino ad allora una sola: `hn_co_seen` = '1', che qui vale 1.
     - Si conta quando il foglio COMPARE: consuma un'apparizione qualunque modo di uscirne senza
       decidere — ×, tocco fuori, Esc, il tasto indietro, un'altra pagina.
     - «Accetto» e «Rifiuto» chiudono la partita per la visita (coDone); il gruppo di controllo si
       valuta una volta sola, come prima.
     - La prova (?hnco=on) ha un conto SUO, riazzerato a ogni pagina aperta col parametro: il
       merchant vede il limite dal telefono e riprova ricaricando il link.
     - La copia in memoria (co.shows) tiene il limite anche dove sessionStorage non funziona. */
  function coMax() { var m = parseInt(coWeights().maxShows, 10); return m >= 1 ? m : 1; }
  function coShows(forced) {
    var n = 0;
    try {
      var ss = window.sessionStorage;
      n = parseInt(ss.getItem(forced ? CO_NT_KEY : CO_N_KEY) || '', 10);
      if (!(n >= 0)) n = (!forced && ss.getItem(CO_SEEN_KEY) === '1') ? 1 : 0;
    } catch (e) { n = 0; }
    return Math.max(n, co.shows[forced ? 1 : 0]);
  }
  function coSetShows(forced, n) {
    co.shows[forced ? 1 : 0] = n;
    try { window.sessionStorage.setItem(forced ? CO_NT_KEY : CO_N_KEY, String(n)); } catch (e) {}
  }
  function coSeen(forced) { return coShows(forced) >= coMax(); }
  function coMarkSeen(forced) { var n = coShows(forced) + 1; coSetShows(forced, n); return n; }
  function coDone(forced) { coSetShows(forced, Math.max(coMax(), coShows(forced))); }
  // una pagina aperta con ?hnco=on: la prova riparte da zero (una volta per caricamento, non a ogni clic)
  if (/[?&]hnco=on(&|$)/.test(window.location.search || '')) {
    try { window.sessionStorage.removeItem(CO_NT_KEY); } catch (e) {}
  }
  /* Dopo «Rifiuto l'offerta» il foglio non torna per `declineDays` giorni su
     questo browser: e' cio' che rende VERO «Prezzi validi solo adesso». */
  function coDeclinedRecently() {
    var days = coWeights().declineDays || 0;
    if (!(days > 0)) return false;
    try {
      var tms = parseInt(window.localStorage.getItem(CO_NO_KEY) || '0', 10);
      return tms > 0 && (Date.now() - tms) < days * 86400000;
    } catch (e) { return false; }
  }

  /* Segmento del carrello: e' la chiave con cui, letti i dati, si decide DOVE
     mostrarlo (`w.co.only`). Si guarda cosa c'e', non quanto vale: la fascia
     di spesa e' una seconda chiave separata. */
  function coSegment(lines) {
    var soap = 0, kit = false, other = false, sets = [];
    lines.forEach(function (it) {
      var e = D.p[it.product_id] || {};
      if (e.cat === 'soap' || e.cat === 'soapset') { soap++; if (e.cat === 'soapset') sets.push(e.su); }
      else if (e.cat === 'kit') kit = true;
      else other = true;
    });
    if (kit) return 'kit';
    if (soap && !other) return (lines.length === 1 && sets.length === 1 && lines[0].quantity === 1) ? 'set' + sets[0] : 'saponi';
    if (soap) return 'misto';
    return 'altro';
  }
  // traguardi a soglia distinti (la barra premi e il tier regalo dicono 75 € due volte)
  function coGoals() {
    var seen = {}, out = [];
    goalList().forEach(function (g) {
      var k = g.type + ':' + g.cents;
      if (!seen[k]) { seen[k] = 1; out.push(g); }
    });
    return out;
  }
  function coBand(q) { var n = 0; coGoals().forEach(function (g) { if (q >= g.cents) n++; }); return 'b' + n; }
  // quali traguardi fa superare un'aggiunta di `delta` centesimi a un carrello da `q`
  function coPerks(q, delta) {
    var out = [];
    coGoals().forEach(function (g) {
      if (q < g.cents && q + delta >= g.cents && out.indexOf(g.type) < 0) out.push(g.type);
    });
    return out;
  }
  function coName(pid, fallback) { var e = D.p[pid]; return (e && e.n) || fallback || ''; }

  /* I SALTI: togli dal carrello cio' che un set o un kit contiene gia', prendi
     il set o il kit. Dal 2026-10-05 sono tutti, non piu' uno solo (merchant:
     «se uno compra il set da 3 offrire quello da 5, e se compra quello da 5
     quello da 7»), e partono anche dai prodotti non-sapone (Crema → Kit Cura
     della Pelle). Una regola sola per tutti, nessun caso scritto a mano:
     - il contenuto di una riga sono i saponi e i pezzi che porta (`sc`/`comp`
       della SUA variante), oppure il prodotto stesso se e' un singolo;
     - si sostituiscono le righe da 1 pezzo il cui contenuto sta TUTTO nella
       variante del contenitore, senza sovrapposizioni fra loro (si perderebbe
       un pezzo);
     - cio' che il contenitore AGGIUNGE non deve essere gia' del cliente (righe
       che restano, omaggi via `x.eq`): mai un doppione;
     - REGOLA DI VERITA': quanto si paga in piu' deve essere positivo e MINORE
       di quanto costerebbe comprare a parte cio' che si aggiunge, ai prezzi di
       oggi. E' cio' che rende vere «risparmia ancora di piu'» e «Risparmi X
       rispetto a comprarli a parte» in ogni salto (al posto della regola «costa
       meno a sapone», che escludeva il 3→5: 5,98 contro 5,97 a sapone, mentre i
       due saponi in piu' costano 6,00 l'uno invece di 6,90);
     - prezzo a prezzo pieno, salvo il contenitore che ha un codice in `x.co`
       (dal 2026-10-28 il Kit Viso: −10; fino ad allora il Kit Cura della Pelle,
       che ora `w.co.never` tiene fuori dal foglio);
     - tetto `upgradeMaxMult` × il carrello, policy nel catalogo.
     Per contenitore si sceglie la variante che sostituisce piu' righe. */
  function coUnitsOf(pid, vid) {
    if (!D.p[pid]) return null;
    var u = scentsOf(pid, vid).concat(compsOf(pid, vid)).map(String);
    return u.length ? u : [String(pid)];
  }
  function coSwaps(cart, ctx, Wc, q) {
    var all = cart.items || [];
    var info = all.filter(function (it) { return !isGift(it) && !isAddon(it); }).map(function (it) {
      /* Un set coi saponi scelti dal cliente non si sostituisce: il salto gli
         toglierebbe la scelta per dargli saponi standard. Resta però nel conto di
         ciò che il carrello ha già, coi saponi veri (il salto non deve aggiungerne
         uno che il cliente ha appena scelto). */
      var ch = chosenScents(it);
      var u = ch ? ch.map(String).concat(compsOf(it.product_id, it.variant_id).map(String)) : coUnitsOf(it.product_id, it.variant_id);
      return { it: it, units: u || [], ok: !!u && it.quantity === 1 && !hasChoice(it) };
    });
    var giftUnits = {};
    all.forEach(function (it) {
      if (!isGift(it)) return;
      [it.product_id].concat(EQ[it.product_id] || []).forEach(function (pid) {
        giftUnits[String(pid)] = 1;
        (coUnitsOf(pid, null) || []).forEach(function (x) { giftUnits[x] = 1; });
      });
    });
    var out = [];
    Object.keys(D.p).forEach(function (id) {
      var e = D.p[id];
      if (!isContainer(id) || e.av === false || NEVER[id] || coNever(id) || ctx.inCart[id]) return;
      if (state.stock[id] === false || state.upsellFailed[id]) return;
      var p = hydrate(id); if (!p) return;
      var row = CO_TABLE[id], amt = (row && row[1] && row[0] > 0) ? row[0] : 0;
      var price = p.price - amt;
      if (!(price > 0) || price > q * (Wc.upgradeMaxMult || 7)) return;
      var vs = (e.vs && e.vs.length) ? e.vs : [{ id: e.vid, sc: e.sc, comp: e.comp, av: e.av }];
      var best = null;
      vs.forEach(function (v) {
        if (v.av === false || state.vsold[v.id]) return;
        var vu = (v.sc || e.sc || []).concat(v.comp || e.comp || []).map(String);
        var has = {}; vu.forEach(function (x) { has[x] = 1; });
        var rep = [], used = {}, clash = false;
        info.forEach(function (L) {
          if (!L.ok || !L.units.every(function (x) { return has[x]; })) return;
          if (L.units.some(function (x) { return used[x]; })) { clash = true; return; }
          L.units.forEach(function (x) { used[x] = 1; });
          rep.push(L);
        });
        if (clash || !rep.length) return;
        var added = vu.filter(function (x) { return !used[x]; });
        if (!added.length) return;
        var rest = {};
        info.forEach(function (L) { if (rep.indexOf(L) < 0) L.units.forEach(function (x) { rest[x] = 1; }); });
        if (added.some(function (x) { return rest[x] || giftUnits[x]; })) return;
        var spend = 0; rep.forEach(function (L) { spend += L.it.final_line_price; });
        var delta = price - spend, sum = 0, known = true;
        added.forEach(function (x) { var ap = hydrate(x); if (!ap || !(ap.price > 0)) known = false; else sum += ap.price; });
        if (!known || !(delta > 0) || !(delta < sum)) return;
        if (!best || rep.length > best.rep.length) {
          best = { p: p, variantId: v.id, rep: rep, added: added, spend: spend, delta: delta, price: price, sum: sum,
                   code: amt ? String(row[1]) : '', amount: amt, om: amt ? row[2] : null };
        }
      });
      if (best) out.push(best);
    });
    return out;
  }
  // «In più: …»: i saponi per nome fino a due, oltre si contano; gli altri pezzi per nome
  function coAddsText(added) {
    var soaps = [], other = [];
    added.forEach(function (x) { ((D.p[x] || {}).cat === 'soap' ? soaps : other).push(coName(x, '')); });
    var head = soaps.length > 2 ? [t('coUpSoaps', { n: soaps.length })] : soaps;
    return head.concat(other).filter(Boolean).join(', ');
  }

  /* Le pagine prodotto aperte dal cliente: in questa sessione, e nelle visite
     degli ultimi `viewDays` giorni. Chi ha guardato un prodotto e non l'ha
     preso e' il cliente piu' vicino a comprarlo: e' il segnale piu' forte che
     il negozio ha sul singolo cliente. */
  function coViewed(Wc) {
    var out = {};
    try {
      var l = JSON.parse(window.sessionStorage.getItem('hn_pdp') || 'null');
      ((l && l.n) || []).forEach(function (k) { out[String(k)] = 1; });
    } catch (e) {}
    var days = Wc.viewDays || 0;
    if (days > 0) {
      try {
        var m = JSON.parse(window.localStorage.getItem(CO_PV_KEY) || 'null') || {}, lim = Date.now() - days * 86400000;
        Object.keys(m).forEach(function (k) { if (m[k] > lim) out[String(k)] = 1; });
      } catch (e) {}
    }
    return out;
  }
  /* VALORE ATTESO di una proposta = probabilita' che il cliente la accetti ×
     margine che resta al negozio. E' il criterio per «il prodotto migliore per
     QUEL cliente e che fa guadagnare di piu'» (merchant, 2026-10-04).
     - margine, in BUCKET (la scala 0..10 di `mt`, mai euro: il catalogo e' un
       file pubblico, e una conversione in euro rivelerebbe i costi): per un
       prodotto il bucket del margine DOPO lo sconto, terzo valore della sua riga
       in `x.co`; per il set la differenza di `mt` fra il set nuovo e cio' che
       sostituisce. Precisione di mezzo bucket per parte: le differenze piu'
       piccole le decidera' la probabilita', e poi i dati.
     - probabilita' (relativa, non una percentuale): parte da 1 ed e'
         × e^(−priceK · prezzo aggiunto ÷ carrello)  piu' costa rispetto a cio'
                                                     che sta comprando, meno passa
         × (1 + discK · sconto ÷ prezzo pieno)       lo sconto profondo attira
         × (1 + affK · affinita' col carrello)       la mappa d'acquisto insieme
         × viewBoost se ha aperto la sua pagina      l'interesse dichiarato
         × prior[id] (o prior.set)                   la correzione che verra' dai dati
     Tutti i numeri sono nel catalogo (`w.co`): lo si ritara li', non qui. */
  function coValue(r, q, ctx, viewed, Wc) {
    var e = D.p[r.p.id] || {}, margin, price;
    if (r.kind === 'swap') {
      var fromMt = 0;
      (r.fromIds || []).forEach(function (id) { fromMt += (D.p[id] || {}).mt || 0; });
      margin = (r.om != null ? r.om : (e.mt || 0)) - fromMt;
      price = r.delta;
    } else {
      margin = r.om != null ? r.om : (e.mt || 0);
      price = r.price;
    }
    var f = {
      prezzo: Math.exp(-(Wc.priceK || 0) * (q > 0 ? Math.max(0, price) / q : 9)),
      /* la profondita' dell'affare: lo sconto del codice per un'aggiunta, il
         risparmio rispetto ai pezzi comprati a parte per un salto */
      sconto: (r.kind === 'offer' && r.full > 0) ? 1 + (Wc.discK || 0) * r.amount / r.full
            : ((r.kind === 'swap' && r.sum > 0) ? 1 + (Wc.discK || 0) * r.save / r.sum : 1),
      affinita: r.kind === 'offer' ? 1 + (Wc.affK || 0) * Math.max(0, dampedAffinity(r.p, ctx)) : 1,
      visto: viewed[String(r.p.id)] ? (Wc.viewBoost || 1) : 1,
      prior: 1
    };
    var pri = Wc.prior || {}, pr = pri[coTag(r)];
    if (!(pr > 0) && r.kind === 'swap') pr = pri.set;
    if (pr > 0) f.prior = pr;
    var p = f.prezzo * f.sconto * f.affinita * f.visto * f.prior;
    r.f = f; r.pAcc = p; r.margin = margin; r.ev = p * Math.max(0, margin); r.viewed = f.visto > 1;
    return r;
  }
  function coTag(r) { return (r.kind === 'swap' ? 'u' : '') + r.p.id; }

  /* LA POLITICA (dal 2026-10-05). Probabilita' di mostrare ciascuna proposta:
       π_i = (1 − ε)·[i = g] + ε·( (1 − γ)·ev_i ÷ Σev + γ ÷ n )
     g = la migliore per valore atteso (o quella fissata da `pick`), ε =
     `explorePct`, γ = `floor`: meta' dell'esplorazione va in proporzione al
     valore, meta' in parti uguali, cosi' NESSUNA proposta resta senza dati.
     La probabilita' della proposta mostrata finisce nell'attributo (`p:`): con
     quella si stima offline quanto avrebbe reso QUALUNQUE altra politica
     (tools/hn-co-report.mjs), senza doverla mettere in produzione. */
  function coPolicy(rows, g, Wc) {
    var n = rows.length, eps = n > 1 ? Math.min(1, Math.max(0, Wc.explorePct || 0)) : 0;
    var gam = Math.min(1, Math.max(0, Wc.floor != null ? Wc.floor : 0.5)), tot = 0;
    rows.forEach(function (r) { tot += r.ev; });
    rows.forEach(function (r) {
      var share = (1 - gam) * (tot > 0 ? r.ev / tot : 1 / n) + gam / n;
      r.pi = (r === g ? 1 - eps : 0) + eps * share;
    });
  }

  /* Il piano: cosa vedrebbe QUESTO carrello. Sincrono e senza rete: la verifica
     di stock e prezzo e' gia' avvenuta (coVerify), e qui si leggono i suoi
     risultati da `state.stock`/`state.price` tramite `hydrate`/`upsellExcluded`.
     `o` serve solo ai test: forza uid, estrazione (`u` in [0,1), `s:0` = la
     migliore), gruppo, visti e `pick`.
     Ritorna {why} se non c'e' niente.
     UNA proposta fra i prodotti in offerta e i salti, estratta con la politica
     (coPolicy): di regola la migliore per valore atteso, o quella che
     `w.co.pick` fissa per il segmento (un id, `u<id>` per un salto, "set" per il
     salto migliore) — la leva per usare i dati. Una proposta che non lascia
     margine (salto verso un contenitore che rende meno di cio' che toglie) non
     e' ammessa nemmeno all'esplorazione: perderebbe soldi a ogni «Accetto». */
  function coPlan(cart, o) {
    o = o || {};
    var Wc = coWeights(), c = coCfg();
    function no(r) { return { why: r }; }
    if (!c.enabled) return no('spento dalle impostazioni');
    if (DESIGN) return no('editor del tema');
    if ((c.country || 'IT') !== 'IT') return no('fuori Italia (' + c.country + ')');
    if (!cart || isForeignCurrency(cart)) return no('valuta estera');
    var lines = (cart.items || []).filter(function (it) { return !isGift(it) && !isAddon(it); });
    if (!lines.length) return no('carrello vuoto');
    var ctx = buildUpsellCtx(cart, Wc, 'co');
    var uid = o.uid != null ? o.uid : coUid();
    function arm(k, salt, pct) { return o[k] != null ? o[k] : coDraw(uid, salt, pct); }
    var seg = coSegment(lines), q = qualifyingSubtotal(cart), band = coBand(q);
    var only = Wc.only || [];
    if (only.length && only.indexOf(seg) < 0 && only.indexOf(seg + '|' + band) < 0) {
      return no('segmento non ammesso (' + seg + '|' + band + ')');
    }
    var viewed = o.viewed || coViewed(Wc);

    var rows = [];
    Object.keys(CO_TABLE).forEach(function (id) {
      var row = CO_TABLE[id], amt = row && row[0], code = row && row[1];
      if (coNever(id)) return;
      var p = hydrate(id);
      if (!p || !code || !(amt > 0)) return;
      if (upsellExcluded(p, ctx)) return;
      /* un pacchetto solo se il carrello non ha NESSUNO dei suoi pezzi, nemmeno
         dentro un altro kit (merchant: Kit Cura della Pelle «se non hanno
         nessuno dei prodotti del kit»). Chi ne ha qualcuno lo vede come SALTO. */
      var comps = compsOf(p.id, null);
      if (comps.some(function (x) { return ctx.inCart[x] || ctx.bundleComp[x]; })) return;
      if (!(p.price - amt > 0)) return;
      var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0] || (p.variants || [])[0] || {};
      rows.push({ kind: 'offer', p: p, variantId: v.id, code: String(code), amount: amt, om: row[2],
                  price: p.price - amt, full: p.price, delta: p.price - amt });
    });
    var elig = rows.map(function (r) { return r.p.id; });
    coSwaps(cart, ctx, Wc, q).forEach(function (w) {
      rows.push({ kind: 'swap', p: w.p, variantId: w.variantId,
                  from: w.rep.map(function (L) { return L.it.key; }),
                  fromIds: w.rep.map(function (L) { return L.it.product_id; }),
                  fromName: w.rep.map(function (L) { return coName(L.it.product_id, L.it.product_title); }).join(', '),
                  added: w.added, price: w.price, full: w.p.price, delta: w.delta, sum: w.sum, save: w.sum - w.delta,
                  code: w.code, amount: w.amount, om: w.om });
    });
    rows.forEach(function (r) { coValue(r, q, ctx, viewed, Wc); r.perks = coPerks(q, r.delta); });
    rows = rows.filter(function (r) { return r.margin > 0; });
    if (!rows.length) return no('niente da proporre a questo carrello');
    rows.sort(function (a, b) { return (b.ev - a.ev) || (coTag(a) < coTag(b) ? -1 : 1); });

    var g = rows[0];
    var pk = o.pick || Wc.pick || {};
    var want = String(pk[seg + '|' + band] || pk[seg] || '');
    if (want) {
      var hit = rows.filter(function (x) { return want === coTag(x) || (want === 'set' && x.kind === 'swap'); })[0];
      if (hit) g = hit;
    }
    coPolicy(rows, g, Wc);
    /* l'estrazione: deterministica per visitatore e carrello. Senza un visitatore
       (il browser non conserva dati) non si sorteggia: la migliore, con p = 1,
       che e' la sua probabilita' vera in quel caso */
    var u = o.u != null ? o.u : (uid ? fnv1a(uid + '|hn-co-pol|' + ctx.sig) / 4294967296 : -1);
    var r = g, pAct = 1;
    if (o.s === 0) { pAct = g.pi; }
    else if (u >= 0) {
      var order = rows.slice().sort(function (a, b) { return coTag(a) < coTag(b) ? -1 : 1; }), acc = 0;
      r = order[order.length - 1];
      for (var i = 0; i < order.length; i++) { acc += order[i].pi; if (u < acc) { r = order[i]; break; } }
      pAct = r.pi;
    }
    var s = rows.length > 1 ? (r === g ? 0 : 1) : '-';
    var anchor = lines.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; })[0];
    /* gruppo di controllo: stesso visitatore, sale suo — indipendente dalla politica */
    var h = arm('h', 'hn-co-holdout', parseInt(c.holdout, 10) || 0);
    return { offer: r, best: g, p: pAct, rank: rows, elig: elig, seg: seg, band: band, s: s, h: h, q: q, uid: uid,
             anchor: coName(anchor.product_id, anchor.product_title) };
  }

  // i prodotti che il foglio puo' mostrare: quelli in offerta e ogni set o kit
  function coVerifyList() {
    var ids = Object.keys(CO_TABLE).filter(function (id) { return !coNever(id); });
    Object.keys(D.p).forEach(function (id) {
      if (isContainer(id) && D.p[id].av !== false && !NEVER[id] && !coNever(id) && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids.map(hydrate).filter(Boolean);
  }
  function coQuickNo() {   // le ragioni per cui non vale nemmeno la pena verificare
    var c = coCfg();
    if (!c.enabled || DESIGN) return true;
    if ((c.country || 'IT') !== 'IT') return true;
    if (!state.cart || isForeignCurrency(state.cart)) return true;
    return false;
  }
  /* All'apertura del drawer si verificano in anticipo stock e prezzi vivi dei
     prodotti del foglio (una volta per sessione: la cache e' quella del drawer),
     cosi' al clic su «Procedi all'ordine» la risposta c'e' gia'. */
  function coPrefetch() {
    var f = coForced();
    if (coQuickNo() || coSeen(f) || (!f && coDeclinedRecently())) return;
    verifyStockFor(coVerifyList());
  }

  /* Formato 4 (dal 2026-10-05, salti e politica con probabilita' registrata):
       e: ogni proposta possibile, in ordine di valore atteso, come
          tag~probabilita' relativa~bucket di margine (`u` davanti ai salti):
          con quei due numeri ogni prior nuovo si ricalcola offline;
       w: le proposte la cui pagina il cliente aveva aperto;
       g: la migliore secondo il modello (o `pick`);
       i: la proposta mostrata;   p: la probabilita' con cui e' stata estratta;
       x: le righe che il salto toglie (id prodotto).
     I formati 1-3 sono del 2026-10-04: si distinguono dal numero in testa. */
  function coAttr(plan, h, outcome) {
    var w = plan.rank.filter(function (x) { return x.viewed; }).map(coTag);
    var r = plan.offer;
    /* n: quale apparizione del foglio ha deciso (dal 2026-10-14 possono essere due per visita).
       Sta subito dopo v: perche' `o:` resta in fondo e chi legge cerca `…|o:<esito>`. */
    return '4;v:' + (coWeights().v || 'co0') + '|n:' + (plan.n || 1) + '|h:' + h + '|c:' + plan.seg + '|b:' + plan.band +
      '|e:' + plan.rank.map(function (x) { return coTag(x) + '~' + x.pAcc.toFixed(2) + '~' + x.margin; }).join(',') +
      (w.length ? '|w:' + w.join(',') : '') +
      '|g:' + coTag(plan.best) + '|i:' + coTag(r) + '|p:' + plan.p.toFixed(3) +
      (r.kind === 'swap' ? '|x:' + r.fromIds.join(',') : '') + '|o:' + outcome;
  }
  /* Scrittura ATTESA dell'attributo, col tetto di 800 ms: `setAttribute` (differito
     di 1,2 s) non arriverebbe mai, perche' subito dopo si naviga al pagamento. */
  function coWriteAttr(val) {
    var p = API.update({ attributes: { hn_co: val } }).catch(function () { return null; });
    var tmo = new Promise(function (res) { setTimeout(function () { res(null); }, 800); });
    return Promise.race([p, tmo]);
  }
  function coTrack(outcome, plan, h) {
    if (co.forced) return;
    track('hn_co_decision', { hn_co_outcome: outcome, hn_co_segment: plan.seg, hn_co_band: plan.band,
                              hn_co_s: String(plan.s), hn_co_h: h, hn_co_n: plan.n || 1, hn_co_item: coTag(plan.offer),
                              hn_co_g: coTag(plan.best), hn_co_p: Math.round(plan.p * 1000) / 1000,
                              hn_co_viewed: plan.offer.viewed ? 1 : 0 });
  }
  function coItem(r) {
    return { item_id: String(r.p.id), item_name: r.p.title || r.p.short_title || '', index: 0,
             price: Math.round(r.price) / 100, discount: r.amount ? Math.round(r.amount) / 100 : 0,
             item_list_id: 'hn-checkout-offer', item_list_name: 'hn_checkout_offer',
             hn_source: r.kind === 'swap' ? 'co_swap' : 'co_offer' };
  }
  function coProceed() {
    coHide();
    trackCheckout();
    co.nav(ROOT + 'checkout');
  }

  /* Ingresso dal pulsante del drawer. Ritorna true se il foglio ha preso in
     carico la navigazione (che allora avverra' da qui, anche solo per scrivere
     l'attributo del gruppo di controllo); false = si va al pagamento come prima. */
  function coStart() {
    if (co.open || co.busy) return true;
    if (coQuickNo()) return false;
    var forced = coForced();
    // gia' visto `maxShows` volte in questa visita (anche in prova), o rifiutato da poco: dritti al pagamento
    if (coSeen(forced) || (!forced && coDeclinedRecently())) return false;
    co.busy = true; co.forced = forced;
    var tmo = new Promise(function (res) { setTimeout(function () { res('lenta'); }, 600); });
    Promise.race([verifyStockFor(coVerifyList()).then(function () { return 'ok'; }, function () { return 'ok'; }), tmo])
      .then(function (esito) {
        co.busy = false;
        if (esito !== 'ok') { coDebugNote('verifica di stock e prezzi troppo lenta: si va al pagamento'); coProceed(); return; }
        var plan = coPlan(state.cart);
        if (!plan.offer) { coDebugNote(plan.why); coProceed(); return; }
        var h = forced ? 0 : plan.h;
        if (h) {
          coDone(false); // il gruppo di controllo si valuta una volta per visita, come prima
          coTrack('holdout', plan, 1);
          coWriteAttr(coAttr(plan, 1, '-')).then(coProceed);
          return;
        }
        plan.n = coMarkSeen(forced);
        coOpen(plan);
      })
      .catch(function () { co.busy = false; coProceed(); });
    return true;
  }

  /* Il testo di vendita del prodotto: dai blocchi della sezione, per id. Senza
     blocco resta il sottotitolo del catalogo (`d`), che almeno dice cos'e'. */
  function coCopy(pid) {
    var list = (coCfg().offers) || [];
    for (var i = 0; i < list.length; i++) if (list[i] && String(list[i].id) === String(pid)) return list[i];
    return null;
  }
  function coPoints(str) {
    return String(str || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 4);
  }
  function coOfferHTML(plan) {
    var r = plan.offer, p = r.p, img = p.featured_image || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img && /cdn\.shopify\.com/.test(img) && !/[?&]width=/.test(img)) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
    var name = p.short_title || p.title, cp = coCopy(p.id) || {};
    var hook, pitch, why, adds = '', save = '';
    if (r.kind === 'swap') {
      hook = t('coUpTitle', { product: (D.p[p.id] && D.p[p.id].n) || name });
      /* il testo del prodotto se c'e' (blocchi della sezione), altrimenti la
         frase del merchant: e' vera in ogni salto per la regola di verita' */
      pitch = cp.t || t('coUpLine');
      why = t('coUpSwap', { from: r.fromName });
      adds = t('coUpAdds', { items: coAddsText(r.added) });
      if (r.save > 0 && t('coUpSave')) save = t('coUpSave', { amount: money(r.save) });
    } else {
      hook = cp.h || '';
      pitch = cp.t || p.subtitle || (D.p[p.id] && D.p[p.id].d) || '';
      why = t('coWhy', { product: plan.anchor });
      if (r.amount && t('coSave')) save = t('coSave', { amount: money(r.amount) });
    }
    var pts = coPoints(cp.b);
    /* barrato SOLO se e' un prezzo vero di oggi (quello pieno, quando c'e' un
       codice); per un salto, accanto, quanto si paga in piu' */
    var price = '<b>' + esc(money(r.price)) + '</b>' + (r.amount ? ' <s>' + esc(money(r.full)) + '</s>' : '') +
      (r.kind === 'swap' ? ' <span class="hn-co__delta">+' + esc(money(r.delta)) + '</span>' : '');
    var perks = (r.perks || []).map(function (k) { return k === 'shipping' ? t('coShip') : (k === 'gift' ? t('coGift') : ''); })
      .filter(Boolean);
    /* entrambi i traguardi: una frase sola («Ottieni la spedizione gratuita e un
       omaggio») invece di due che ripetono l'inizio. Vuota (pagina in cache da prima
       del 2026-10-05) = due badge affiancati. */
    if (perks.length === 2 && t('coBoth')) perks = [t('coBoth')];
    var vsel = '';
    if (r.kind === 'offer' && (p.variants || []).length > 1) {
      vsel = '<select class="hn-co__var" data-hn-co-var aria-label="' + esc(name) + '">' +
        p.variants.map(function (v) {
          return '<option value="' + esc(v.id) + '"' + (String(v.id) === String(r.variantId) ? ' selected' : '') +
            (v.available === false ? ' disabled' : '') + '>' + esc(v.title) + '</option>';
        }).join('') + '</select>';
    }
    return (hook ? '<p class="hn-co__hook">' + esc(hook) + '</p>' : '') +
      '<div class="hn-co__offer" data-hn-co-offer data-id="' + p.id + '" data-kind="' + r.kind + '">' +
        (img ? '<img class="hn-co__img" src="' + esc(img) + '" alt="" width="88" height="88">' : '<span class="hn-co__img"></span>') +
        '<div class="hn-co__info">' +
          '<p class="hn-co__name">' + esc(name) + '</p>' +
          (why ? '<p class="hn-co__why">' + esc(why) + '</p>' : '') +
          (adds ? '<p class="hn-co__adds">' + esc(adds) + '</p>' : '') +
          '<p class="hn-co__price">' + price + '</p>' +
          (save ? '<p class="hn-co__save">' + esc(save) + '</p>' : '') +
        '</div>' +
      '</div>' +
      (pitch ? '<p class="hn-co__pitch">' + esc(pitch) + '</p>' : '') +
      (pts.length ? '<ul class="hn-co__pts">' + pts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
      /* badge, non riga di testo (merchant, 2026-10-05: «si legge troppo piccolo») */
      (perks.length ? '<p class="hn-co__perks">' + perks.map(function (x) { return '<span class="hn-co__perk">' + esc(x) + '</span>'; }).join('') + '</p>' : '') +
      vsel;
  }
  function coOpen(plan) {
    goingDone(); // il foglio prende la scena: dietro, «Procedi all'ordine» torna normale
    co.plan = plan; co.open = true;
    if (!co.el) {
      co.el = document.createElement('div');
      co.el.className = 'hn-co';
      co.el.setAttribute('data-hn-co', '');
      els.panel.appendChild(co.el);
      co.el.addEventListener('click', coOnClick);
      co.el.addEventListener('change', coOnChange);
    }
    co.el.innerHTML =
      '<div class="hn-co__bg" data-hn-co-x></div>' +
      '<div class="hn-co__sheet" role="dialog" aria-modal="true" aria-labelledby="hn-co-title" tabindex="-1">' +
        '<button type="button" class="hn-co__x" data-hn-co-x aria-label="Chiudi">&times;</button>' +
        '<p class="hn-co__title" id="hn-co-title">' + esc(t('coTitle')) + '</p>' +
        coOfferHTML(plan) +
        '<button type="button" class="hn-co__yes" data-hn-co-yes>' + esc(t('coYes')) + '</button>' +
        (t('coSub') ? '<p class="hn-co__sub">' + esc(t('coSub')) + '</p>' : '') +
        '<button type="button" class="hn-co__no" data-hn-co-no>' + esc(t('coNo')) + '</button>' +
        (HN_DEBUG ? '<pre class="hn-co__dbg">' + esc(coDebugText(plan)) + '</pre>' : '') +
      '</div>';
    co.el.classList.add('is-open');
    if (!co.forced) {
      window.dataLayer = window.dataLayer || [];
      if (CFG.analytics && CFG.analytics.dataLayer) window.dataLayer.push({ ecommerce: null });
      var righe = [coItem(plan.offer)];
      track('hn_view_item_list', { item_list_id: 'hn-checkout-offer', item_list_name: 'hn_checkout_offer',
                                   hn_co_segment: plan.seg, hn_co_band: plan.band,
                                   items: righe, ecommerce: { items: righe } });
      coTrack('shown', plan, 0);
    }
    /* il fuoco va al foglio, non al pulsante: un Invio di troppo non deve accettare */
    var sh = co.el.querySelector('.hn-co__sheet'); if (sh) { try { sh.focus(); } catch (e) {} }
  }
  function coHide() {
    co.open = false;
    if (co.el) { co.el.classList.remove('is-open'); co.el.innerHTML = ''; }
  }
  /* × / Esc / tocco fuori: si torna al carrello, niente blocco di 7 giorni. L'apparizione e' gia'
     contata (coStart): al «Procedi» dopo il foglio torna se e' stata la prima, altrimenti si va al
     pagamento (`maxShows`). */
  function coClose() {
    if (!co.open || co.busy) return;
    var plan = co.plan;
    coHide();
    goingDone();
    if (!co.forced && plan) {
      coTrack('close', plan, 0);
      var val = coAttr(plan, 0, 'close');
      enqueue(function () { return API.update({ attributes: { hn_co: val } }).catch(function () {}); });
    }
    var btn = els.foot && els.foot.querySelector('[data-hn-checkout]');
    if (btn) { try { btn.focus(); } catch (e) {} }
  }
  function coDecline() {
    if (!co.open || co.busy) return;
    co.busy = true;
    coDone(co.forced); // decisione presa: in questa visita il foglio non torna
    var no = co.el && co.el.querySelector('[data-hn-co-no]');
    if (no) { no.disabled = true; no.setAttribute('aria-busy', 'true'); no.insertAdjacentHTML('afterbegin', '<span class="hn-spin"></span> '); }
    var plan = co.plan;
    if (!co.forced) { try { window.localStorage.setItem(CO_NO_KEY, String(Date.now())); } catch (e) {} }
    var p = Promise.resolve();
    if (!co.forced) { coTrack('no', plan, 0); p = coWriteAttr(coAttr(plan, 0, 'no')); }
    p.then(function () { co.busy = false; coProceed(); });
  }
  function coOnChange(e) {
    var s = e.target.closest && e.target.closest('[data-hn-co-var]');
    if (!s || !co.plan) return;
    co.plan.offer.variantId = s.value;
  }
  function coOnClick(e) {
    var tg = e.target;
    if (tg.closest('[data-hn-co-x]')) { e.preventDefault(); coClose(); return; }
    if (tg.closest('[data-hn-co-yes]')) { e.preventDefault(); coAccept(); return; }
    if (tg.closest('[data-hn-co-no]')) { e.preventDefault(); coDecline(); return; }
  }

  /* «Accetto l'offerta»: (1) la proposta in UNA richiesta; (2) in un'altra
     richiesta sola: via le righe che il salto sostituisce, il codice sconto
     (quelli gia' presenti si RIMANDANO: l'API sostituisce l'intero set) e
     l'attributo; (3) GET + riconciliazione dei regali, cosi' l'omaggio dei 75 €
     entra PRIMA di andare al pagamento; (4) begin_checkout e navigazione. */
  function coAccept() {
    var plan = co.plan;
    if (!plan || co.busy) return;
    var r = plan.offer;
    co.busy = true;
    var forced = co.forced;
    coDone(forced); // decisione presa: niente seconda offerta in questa visita, qualunque sia l'esito
    var yes = co.el.querySelector('[data-hn-co-yes]');
    if (yes) { yes.disabled = true; yes.innerHTML = '<span class="hn-spin"></span>'; }
    enqueue(function () {
      setBusy(true);
      return API.add([{ id: parseInt(r.variantId, 10), quantity: 1 }])
        .then(function (res) {
          if (!res || res.status) { state.upsellFailed[r.p.id] = true; return { err: true }; }
          var updates = {}, codes = currentDiscountCodes(state.cart), up = codes.map(function (x) { return x.toUpperCase(); });
          var nuovo = false;
          if (r.kind === 'swap') r.from.forEach(function (k) { updates[k] = 0; });
          if (r.code && up.indexOf(r.code.toUpperCase()) < 0) { codes.push(r.code); nuovo = true; }
          var payload = {};
          if (nuovo) payload.discount = codes.join(',');
          if (Object.keys(updates).length) payload.updates = updates;
          if (!forced) payload.attributes = { hn_co: coAttr(plan, 0, 'yes') };
          var invio = Object.keys(payload).length ? API.update(payload) : API.get();
          return invio.then(function (c2) {
            var keys = Object.keys(updates);
            var rimaste = function (cc) {
              return keys.filter(function (k) { return ((cc && cc.items) || []).some(function (it) { return it.key === k; }); });
            };
            var left = rimaste(c2);
            if (!left.length) return { ok: true };
            var u2 = {}; left.forEach(function (k) { u2[k] = 0; });
            return API.update({ updates: u2 }).then(function (c3) { return rimaste(c3).length ? { stuck: true } : { ok: true }; });
          });
        })
        .catch(function () { return { err: true }; })
        .then(function (esito) {
          return finishMutation(false).then(function (cart) { return { esito: esito, cart: cart }; },
                                            function () { return { esito: esito, cart: state.cart }; });
        });
    }).then(function (res) {
      co.busy = false;
      var esito = (res && res.esito) || { err: true }, cart = (res && res.cart) || state.cart;
      if (esito.stuck) {
        /* il contenitore nuovo e' entrato ma cio' che sostituiva non se n'e' andato:
           mai un doppione al pagamento senza che il cliente lo veda — si resta sul carrello */
        coHide(); announce(t('coStuck')); return;
      }
      if (esito.err) {
        if (!forced) { coTrack('err', plan, 0); coWriteAttr(coAttr(plan, 0, 'err')).then(coProceed); }
        else coProceed();
        return;
      }
      var mismatch = coCheckDiscounts(cart, r);
      /* in prova (?hnco=on) niente eventi: l'aggiunta e' vera, la misura no */
      if (!forced) {
        trackAdd(cart, r.variantId, 1, { item_list_id: 'hn-checkout-offer', item_list_name: 'hn_checkout_offer',
          hn_source: r.kind === 'swap' ? 'co_swap' : 'co_offer', hn_via: 'checkout_offer', product_id: r.p.id, index: 0 });
        coTrack('yes', plan, 0);
      }
      if (mismatch && !forced) {
        track('hn_co_mismatch', { hn_co_codes: mismatch });
        coWriteAttr(coAttr(plan, 0, 'err')).then(coProceed);
        return;
      }
      coProceed();
    }, function () { co.busy = false; coProceed(); });
  }
  /* Lo sconto che il carrello ha DAVVERO applicato alla riga contro quello
     promesso. Una differenza vuol dire che il codice nell'admin e il catalogo si
     sono scollati (o che un codice del cliente non combinabile l'ha scalzato):
     resta scritto nell'ordine (`o:err`) e nel dataLayer. '' = tutto torna. */
  function coCheckDiscounts(cart, r) {
    if (!r.code) return '';
    var got = 0;
    (cart.items || []).forEach(function (it) {
      if (String(it.product_id) !== String(r.p.id)) return;
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var da = al && al.discount_application;
        if (da && String(da.title || '').toUpperCase() === r.code.toUpperCase()) got += al.amount || 0;
      });
    });
    return got === r.amount ? '' : r.code + ':' + got;
  }
  /* Codici dell'offerta rimasti senza il loro prodotto (il cliente l'ha tolto
     tornando al carrello): via, come gli omaggi orfani. Non sposterebbero lo
     sconto su altro — ogni codice vale solo per il suo prodotto — ma il drawer
     mostrerebbe un codice «non applicabile» che il cliente non ha mai scritto. */
  function coReconcileCodes(cart) {
    var codes = currentDiscountCodes(cart);
    if (!codes.length) return Promise.resolve(cart);
    var byCode = {};
    Object.keys(CO_TABLE).forEach(function (id) { var r = CO_TABLE[id]; if (r && r[1]) byCode[String(r[1]).toUpperCase()] = id; });
    var inCart = {};
    (cart.items || []).forEach(function (it) { if (!isGift(it)) inCart[it.product_id] = true; });
    var keep = codes.filter(function (cd) { var id = byCode[cd.toUpperCase()]; return !id || inCart[id]; });
    if (keep.length === codes.length) return Promise.resolve(cart);
    return API.update({ discount: keep.join(',') }).then(function (c2) { return (c2 && c2.items) ? c2 : cart; },
                                                          function () { return cart; });
  }

  /* ?hncartdebug=1: il perche' del foglio, senza doverlo indovinare. */
  function coDebugText(plan) {
    if (!plan || !plan.offer) return 'offerta al checkout: NO — ' + ((plan && plan.why) || '?');
    var holdPct = parseInt(coCfg().holdout, 10) || 0, r = plan.offer, prova = co.forced || coForced();
    function eur(x) { return (Math.round(x * 100) / 100).toFixed(2).replace('.', ','); }
    return 'offerta al checkout: segmento ' + plan.seg + ' | fascia ' + plan.band +
      ' | estratta ' + (plan.s === 1 ? 'in esplorazione' : 'la migliore') + ' (p ' + plan.p.toFixed(3) + ')' +
      '\ngruppo di controllo: ' + (plan.h ? 'SI' : 'no') + ' (quota ' + holdPct + '%)' +
      ' | visitatore ' + (plan.uid ? plan.uid.slice(0, 6) + '…' : '(nessuno)') +
      (co.forced ? ' | forzato con hnco=on: fuori misura' : '') +
      '\napparizioni in questa visita: ' + (plan.n ? 'questa e\' la ' + plan.n + 'a' : coShows(prova) + ' gia\' viste') +
      ' su ' + coMax() + (prova ? ' (conto di prova)' : '') +
      '\nproposta: ' + (r.kind === 'swap' ? 'SALTO ' : '') + (r.p.short_title || r.p.title) + ' ' + money(r.price) +
      (r.kind === 'swap' ? ' al posto di ' + r.fromName + ' (+' + money(r.delta) + ', risparmia ' + money(r.save) + ')' : '') +
      (r.code ? ' (' + r.code + ' −' + money(r.amount) + ')' : '') + (r.perks.length ? ' +' + r.perks.join('+') : '') +
      (r.kind === 'offer' && !coCopy(r.p.id) ? ' — SENZA testo di vendita (manca il blocco)' : '') +
      '\nclassifica (valore atteso = probabilita\' relativa × bucket di margine; π = probabilita\' di essere mostrata):\n' +
      plan.rank.map(function (x, k) {
        return (k + 1) + '. ' + (x.kind === 'swap' ? 'SALTO ' : '') + coName(x.p.id, x.p.title) +
          (x === plan.best ? ' [migliore]' : '') + '  π ' + x.pi.toFixed(3) + '  ' + eur(x.ev) +
          ' = ' + x.pAcc.toFixed(2) + ' × margine ' + x.margin +
          '  [prezzo ' + x.f.prezzo.toFixed(2) + ', sconto ' + x.f.sconto.toFixed(2) + ', affinita\' ' + x.f.affinita.toFixed(2) +
          (x.viewed ? ', VISTO ×' + x.f.visto : '') + (x.f.prior !== 1 ? ', prior ' + x.f.prior : '') + ']';
      }).join('\n');
  }
  function coDebugNote(why) {
    if (!HN_DEBUG) return;
    try { console.info('[hn-co] ' + why); } catch (e) {}
    window.__hnCoDbg = why;
  }

  /* ------------------------------ ADD-ONS ------------------------------ */
  function renderAddons(cart) {
    var host = els.body.querySelector('[data-hn-addons]');
    if (!host) return;
    var items = (CFG.addons && CFG.addons.enabled) ? (CFG.addons.items || []).filter(function (a) { return a.variantId; }) : [];
    if (!items.length) { host.innerHTML = ''; return; }
    host.innerHTML = '<div class="hn-cart__section-h">' + esc(t('addonsHeading')) + '</div>' +
      items.map(function (a) {
        var inCart = (cart.items || []).some(function (i) { return String(i.variant_id) === String(a.variantId); });
        var img = a.image ? esc(a.image) : '';
        return '<label class="hn-addon"><input type="checkbox" data-hn-addon="' + esc(a.variantId) + '"' + (inCart ? ' checked' : '') + '>' +
          (img ? '<img class="hn-addon__img" src="' + img + '" alt="">' : '') +
          '<span class="hn-addon__main"><span class="hn-addon__title">' + esc(a.title) + '</span>' +
          '<span class="hn-addon__price">' + money(toCents(a.price)) + '</span></span></label>';
      }).join('');
    host.querySelectorAll('[data-hn-addon]').forEach(function (cb) {
      cb.addEventListener('change', function () { onAddonToggle(cb); });
    });
  }
  function onAddonToggle(cb) {
    var vid = cb.getAttribute('data-hn-addon');
    if (cb.checked) {
      enqueue(function () {
        setBusy(true);
        return API.add([{ id: parseInt(vid, 10), quantity: 1, properties: { _hn_addon: 'true' } }])
          .then(function () { return finishMutation(false); });
      }).catch(mutationFailed);
    } else {
      var line = (state.cart.items || []).filter(function (i) { return String(i.variant_id) === String(vid); })[0];
      if (!line) return;
      enqueue(function () {
        setBusy(true);
        return API.change({ id: line.key, quantity: 0 }).then(function (c) { return finishMutation(false, c); });
      }).catch(mutationFailed);
    }
  }

  /* ------------------------------ FOOTER ------------------------------ */
  function renderFoot(cart) {
    if (!cart.items || !cart.items.length) { els.foot.innerHTML = ''; return; }
    // risparmio totale = prezzi barrati (compare-at) + sconti di riga + sconti carrello
    var savings = 0;
    (cart.items || []).forEach(function (it) {
      var baseLine = Math.max(compareAtUnit(it), it.original_price) * it.quantity;
      if (baseLine > it.final_line_price) savings += baseLine - it.final_line_price;
    });
    var cartLevel = (cart.items_subtotal_price || cart.total_price) - cart.total_price;
    if (cartLevel > 0) savings += cartLevel;
    var termsCfg = CFG.terms || {};
    // hn-cart__trust (testo) e hn-cart__pay (icone) sono indipendenti: il merchant può
    // tenere l'uno, l'altro, entrambi o nessuno dei due dal Personalizza tema.
    var trustHtml = (CFG.trust && CFG.trust.enabled && (CFG.trust.badges || []).length) ?
      '<div class="hn-cart__trust">' + CFG.trust.badges.map(function (b) { return '<span>' + esc(b) + '</span>'; }).join('') + '</div>' : '';
    var pay = CFG.paymentIcons || {};
    // pay.html arriva già pronto da sections/hn-cart.liquid (payment_type_svg_tag +
    // la nostra icona Contrassegno): è markup nostro, non testo libero — non va da esc().
    var payHtml = (pay.enabled && pay.html) ? '<div class="hn-cart__pay">' + pay.html + '</div>' : '';
    /* Riga "Consegna stimata entro <data>". Il testo iniziale e' la frase generica:
       se il motore non arrivasse (rete), resta una promessa vera invece di una riga
       vuota — e *:empty{display:none} di base.css la spegnerebbe comunque.
       ⚠️ data-hn-del-nostock: il drawer vive anche sulle pagine prodotto, e senza
       questo una variante esaurita nasconderebbe la data pure qui, dove cio' che e'
       gia' nel carrello e' per definizione acquistabile. */
    var del = CFG.delivery || {};
    /* un carrello di soli buoni regalo non si spedisce: niente data di consegna (GC1) */
    var delHtml = (del.enabled && del.cfg && cart.item_count && cart.requires_shipping !== false) ?
      '<div class="hn-cart__del hn-del" data-hn-del-nostock data-hn-delivery="' + esc(del.cfg) + '">' +
        '<span class="hn-del__dot" aria-hidden="true"></span>' +
        '<span class="hn-del__txt" data-hn-del-txt>Consegna in 24-48 ore</span>' +
      '</div>' : '';
    els.foot.innerHTML =
      (termsCfg.enabled ? '<div class="hn-cart__terms"><input type="checkbox" id="hn-terms" data-hn-terms>' +
        '<label for="hn-terms">' + esc(t('termsText')) +
        (termsCfg.url ? ' <a href="' + esc(termsCfg.url) + '" target="_blank" rel="noopener">↗</a>' : '') + '</label></div>' : '') +
      (savings > 0 ? '<div class="hn-cart__savings"><span>' + esc(t('savedLabel')) + '</span><span>−' + money(savings) + '</span></div>' : '') +
      (t('taxesNote') ? '<div class="hn-cart__taxes">' + esc(t('taxesNote')) + '</div>' : '') +
      '<button class="hn-cart__checkout' + (state.goingOut ? ' is-going" aria-busy="true' : '') + '" data-hn-checkout>' + esc(t('checkout')) + ' • ' + money(cart.total_price) + '</button>' +
      delHtml + trustHtml + payHtml +
      (HN_DEBUG ? '<pre class="hn-co__dbg">' + esc(coDebugText(coPlan(cart))) + '</pre>' : '');

    /* Il motore delle date e' assets/hn-delivery.js, lo STESSO della pagina prodotto:
       qui non si calcola nulla. Sulle pagine prodotto e' gia' in memoria (lo carica
       snippets/hn-delivery.liquid); altrove si scarica alla prima apertura del
       drawer — non al caricamento della pagina, cosi' chi non apre il carrello non
       lo paga. Stessa forma del caricamento pigro di Swiper in ss-testimonial-8. */
    if (delHtml) ensureDeliveryEngine();
  }

  /* ⚠️ Una sola promise per pagina: due render ravvicinati del piede (ricalcolo del
     carrello) chiederebbero altrimenti due volte lo stesso file. */
  var delEnginePending = null;
  function ensureDeliveryEngine() {
    if (window.HNDelivery) { window.HNDelivery.boot(); return; }
    var url = (CFG.delivery || {}).engine;
    if (!url || delEnginePending) return;
    delEnginePending = true;
    var sc = document.createElement('script');
    sc.src = url;
    sc.onload = function () { if (window.HNDelivery) window.HNDelivery.boot(); };
    document.head.appendChild(sc);
  }

  /* ------------------------------ URGENCY (sotto il titolo, indipendente dal carrello) ------------------------------ */
  var urgencyTimer = null;
  function urgencyEnabled() { return !!(CFG.urgency && CFG.urgency.countdown && CFG.urgency.countdown.enabled); }
  function urgencyDeadline() {
    if (!urgencyEnabled()) return 0;
    var mins = CFG.urgency.countdown.minutes || 15;
    var k = 'hn_cart_deadline';
    var dl = parseInt(sessionStorage.getItem(k) || '0', 10);
    var now = Date.now();
    if (!dl || dl < now) { dl = now + mins * 60000; try { sessionStorage.setItem(k, String(dl)); } catch (e) {} }
    return dl;
  }
  function renderUrgency() {
    var dl = urgencyDeadline(); if (!dl) return '';
    var left = Math.max(0, dl - Date.now());
    var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    return esc(t('urgencyText')) + ' <b>' + m + ':' + (s < 10 ? '0' : '') + s + '</b>';
  }
  function startUrgency() {
    if (!urgencyEnabled()) return;
    if (urgencyTimer) clearInterval(urgencyTimer);
    urgencyTimer = setInterval(function () {
      var node = els.root.querySelector('[data-hn-urgency]');
      if (!node) { clearInterval(urgencyTimer); return; }
      node.innerHTML = renderUrgency();
    }, 1000);
  }

  /* ------------------------- azioni linee/quantità ------------------------- */
  function itemKeyFromEl(node) {
    var wrap = node.closest('[data-key]'); return wrap ? wrap.getAttribute('data-key') : null;
  }
  /* ⚡ Risposta SUBITO al tocco (2026-10-08, merchant: «clicco sul secchio per toglierlo
     ed e' molto lento ad aggiornare»). Prima l'unico segno che qualcosa stesse succedendo
     era il cursore «progress», che sul telefono non esiste: per un secondo o due non si
     muoveva niente. Ora la riga reagisce al tocco (quantita' nuova, oppure la riga che
     sbiadisce se va tolta) e Shopify conferma dopo. Se l'operazione fallisce, il carrello
     si ridisegna com'era. */
  function lineEl(key) {
    var found = null;
    if (els.body) els.body.querySelectorAll('.hn-item[data-key]').forEach(function (n) { if (n.getAttribute('data-key') === key) found = n; });
    return found;
  }
  function paintOptim(key) {
    var el = lineEl(key), o = state.optimQty[key];
    if (!el || !o) return;
    var sp = el.querySelector('.hn-qty span'); if (sp) sp.textContent = o.q;
    el.classList.add('is-pending');
    if (o.q === 0) el.classList.add('is-removing');
  }
  function optimDone(key) {
    var o = state.optimQty[key];
    if (o && --o.n <= 0) delete state.optimQty[key];
  }
  function mutationFailed() { setBusy(false); state.optimQty = {}; render(); }
  function changeQty(key, delta) {
    var it0 = ((state.cart && state.cart.items) || []).filter(function (i) { return i.key === key; })[0];
    if (!it0) return;
    var o = state.optimQty[key] || { n: 0, q: it0.quantity };
    o.n++; o.q = Math.max(0, o.q + delta);
    state.optimQty[key] = o;
    paintOptim(key);
    tlStart('quantita\' ' + (delta > 0 ? '+' : '−'));
    // lookup + calcolo DENTRO la coda: ogni op legge lo stato più fresco, così i click
    // rapidi +/- si sommano invece di sovrascriversi (change.js usa quantità ASSOLUTE)
    enqueue(function () {
      var it = (state.cart.items || []).filter(function (i) { return i.key === key; })[0];
      if (!it) { optimDone(key); return; }
      var q = Math.max(0, it.quantity + delta);
      setBusy(true);
      return API.change({ id: key, quantity: q }).then(function (c) { optimDone(key); return finishMutation(false, c); });
    }).catch(mutationFailed);
  }
  function removeLine(key) {
    var el = lineEl(key);
    if (el) el.classList.add('is-removing');
    tlStart('cestino');
    enqueue(function () {
      setBusy(true);
      return API.change({ id: key, quantity: 0 }).then(function (c) { return finishMutation(false, c); });
    }).catch(mutationFailed);
  }
  // meta (opzionale) = attribuzione upsell: arricchisce l'evento add_to_cart con
  // item_list_name/sorgente. I percorsi legacy (sticky ATC, form) non lo passano
  // -> payload IDENTICO a prima, nessun tag GTM esistente si rompe.
  function addVariant(variantId, qty, props, btn, done, meta, fail) {
    if (!variantId) return;
    var prevLabel;
    if (btn) { prevLabel = btn.textContent; btn.disabled = true; btn.innerHTML = '<span class="hn-spin"></span>'; }
    enqueue(function () {
      setBusy(true);
      return API.add([{ id: parseInt(variantId, 10), quantity: qty || 1, properties: props || undefined }])
        .then(function (res) {
          if (res && res.status) { // errore (es. esaurito)
            announce(res.description || t('soldOut'));
            if (btn) { btn.disabled = false; btn.textContent = prevLabel || t('add'); }
            // upsell fallito (es. esaurito con dati catalogo stantii): non riproporlo in sessione
            if (meta && meta.product_id != null) { state.upsellFailed[meta.product_id] = true; render(); }
            // chi ha proposto la variante (la pagina prodotto) deve saperlo: altrimenti «non succede nulla»
            if (state.vsold[variantId] === undefined && D.p[meta && meta.product_id]) {
              state.vsold[variantId] = 1;
              try { sessionStorage.setItem(VSOLD_KEY, JSON.stringify({ sold: state.vsold, seen: state.vseen })); } catch (e3) {}
            }
            setBusy(false);
            if (fail) try { fail(res); } catch (e4) {}
            return;
          }
          // dalla card dei consigliati: «Aggiunto ✓» resta in vista, i consigliati si aggiornano dopo.
          // L'attesa va fissata PRIMA di noteRecoAdd, che ne tiene conto per scrivere hn_reco.
          if (meta && meta.item_list_id === 'hn-cart-upsell') state.upsellHold = Date.now() + UPSELL_HOLD;
          noteRecoAdd(meta);
          if (btn) { btn.textContent = t('added'); }
          state.flashAdds = true;
          if (done) done();
          /* L'evento parte DOPO finishMutation perche' solo li' si conosce il
             carrello, e quindi nome e prezzo della riga aggiunta. Un giro di rete
             di ritardo su un evento di misurazione non cambia nulla. */
          return finishMutation(true).then(function (cart) {
            trackAdd(cart, variantId, qty || 1, meta);
            return cart;
          });
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = prevLabel || t('add'); } setBusy(false); });
    });
  }
  /* Aggiunta di PIÙ righe in UNA sola richiesta: è ciò che serve al pulsante
     «Aggiungi tutti» del pacchetto in pagina prodotto. Non è un ciclo su
     `addVariant`, che farebbe N richieste, N riconciliazioni dei regali e N
     aperture del drawer — e con `enqueue` le farebbe pure in sequenza, quindi
     lente. Un solo `API.add`, un solo `finishMutation`, un `trackAdd` per riga
     (gli stessi due call-site di sempre: H3 resta a 2). */
  function addMany(items, metas, btn, done) {
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) return;
    metas = metas || [];
    var prevLabel;
    if (btn) { prevLabel = btn.textContent; btn.disabled = true; btn.innerHTML = '<span class="hn-spin"></span>'; }
    enqueue(function () {
      setBusy(true);
      return API.add(items.map(function (i) {
        return { id: parseInt(i.id, 10), quantity: i.quantity || 1, properties: i.properties || undefined };
      })).then(function (res) {
        if (res && res.status) {
          announce(res.description || t('soldOut'));
          if (btn) { btn.disabled = false; btn.textContent = prevLabel || t('add'); }
          /* Shopify rifiuta l'INTERA richiesta (422) senza dire quale riga:
             si marcano tutte come fallite per la sessione, così la pagina le
             sostituisce invece di riproporre un pacchetto che il carrello
             rifiuta di nuovo. */
          metas.forEach(function (m) { if (m && m.product_id != null) state.upsellFailed[m.product_id] = true; });
          render(); setBusy(false); return;
        }
        metas.forEach(noteRecoAdd);
        if (btn) { btn.textContent = t('added'); }
        state.flashAdds = true;
        if (done) done();
        return finishMutation(true).then(function (cart) {
          items.forEach(function (i, k) { trackAdd(cart, i.id, i.quantity || 1, metas[k]); });
          return cart;
        });
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = prevLabel || t('add'); }
        setBusy(false);
      });
    });
  }
  // dopo una mutazione: riconcilia regali, aggiorna stato, ridisegna, apri se richiesto
  // (la cache upsell si invalida da sola quando cambia la "firma" del carrello)
  /* `resp`: la risposta della mutazione stessa. /cart/change.js e /cart/update.js
     restituiscono il carrello INTERO, quindi rileggerlo con /cart.js era un secondo giro
     di rete in fila per niente (il cestino ne pagava due). /cart/add.js invece
     restituisce solo le righe aggiunte: li' la rilettura resta. */
  function isFullCart(c) {
    return !!(c && typeof c === 'object' && !c.status && Array.isArray(c.items) && c.token &&
              typeof c.item_count === 'number' && typeof c.total_price === 'number');
  }
  function finishMutation(openIfClosed, resp) {
    return (isFullCart(resp) ? Promise.resolve(resp) : API.get())
      .then(function (cart) { return coReconcileCodes(cart); })
      .then(function (cart) { return reconcileCart(cart); })
      .then(function (cart) { return ensureProductData(cart); })
      .then(function (cart) {
        state.cart = cart; state.lastSig = cartSig(cart); poll.last = Date.now(); render(); syncNativeBubble(cart); setBusy(false);
        tlMark('carrello disegnato');
        if (openIfClosed && !state.open && CFG.drawer.openOnAdd) openDrawer();
        return cart;
      });
  }

  /* ------------------------ discount / note (tools) ------------------------ */
  /* «Applica»: rotellina sul pulsante e un secondo tocco che non rimanda lo stesso codice;
     il disegno successivo rimette il pulsante com'era (anche dopo un errore di rete). */
  function discBusyBtn(b) {
    if (!b) return;
    setTimeout(function () { b.disabled = true; b.setAttribute('aria-busy', 'true'); b.innerHTML = '<span class="hn-spin"></span>'; }, 0);
  }
  function applyDiscount(code) {
    if (!code || state.discBusy) return;
    state.discBusy = true;
    discBusyBtn(els.body.querySelector('[data-hn-disc-apply]'));
    enqueue(function () {
      setBusy(true);
      // ACCODA il codice al set esistente. L'AJAX cart SOSTITUISCE l'intero set con quello inviato
      // ({discount:'A,B'}), quindi per aggiungere bisogna re-inviare i codici già presenti + il
      // nuovo. Dedup case-insensitive (Shopify tratta i codici come case-insensitive).
      var upper = code.toUpperCase();
      var all = currentDiscountCodes(state.cart).filter(function (c) { return c.toUpperCase() !== upper; });
      all.push(code);
      return API.update({ discount: all.join(',') }).then(function (raw) {
        // esito PER QUESTO codice: presente e applicabile nella risposta?
        var entry = (raw.discount_codes || []).filter(function (d) { return (d.code || '').toUpperCase() === upper; })[0];
        var ok = !!(entry && entry.applicable);
        // GROUND TRUTH (solo con ?hncartdebug): distingue "accodamento rotto" (leggo/invio solo il
        // nuovo codice, o la risposta di update.js non ha discount_codes) da "Shopify disattiva il
        // primo a livello carrello" (invio A,B ma la risposta li marca diversamente dal checkout).
        if (HN_DEBUG) window.__hnDiscDbg = {
          azione: 'apply:' + code,
          letto_prima: currentDiscountCodes(state.cart),
          inviato: all.join(','),
          update_risposta_ha_campo_discount_codes: ('discount_codes' in raw),
          risposta_discount_codes: raw.discount_codes || null,
          risposta_total_discount: raw.total_discount
        };
        return reconcileCart(raw).then(function (cart) { // uno sconto può far scendere sotto soglia -> togli il regalo
          state.cart = cart; state.lastSig = cartSig(cart); render(); syncNativeBubble(cart);
          var m2 = els.body.querySelector('[data-hn-disc-msg]');
          if (m2) { m2.className = 'hn-disc__msg ' + (ok ? 'ok' : 'err'); m2.textContent = ok ? t('discountApplied') : t('discountInvalid'); }
          setBusy(false);
        });
      }).catch(function () { setBusy(false); render(); });
    }).then(function () { state.discBusy = false; }, function () { state.discBusy = false; });
  }
  function removeDiscount(code, btn) {
    if (state.discBusy) return;
    state.discBusy = true;
    discBusyBtn(btn);
    enqueue(function () {
      setBusy(true);
      // rimuove UN codice specifico: re-invia tutti gli altri (stringa vuota se era l'ultimo)
      var upper = (code || '').toUpperCase();
      var remaining = currentDiscountCodes(state.cart).filter(function (c) { return c.toUpperCase() !== upper; });
      return API.update({ discount: remaining.join(',') }).then(function (c) { return finishMutation(false, c); });
    }).catch(mutationFailed).then(function () { state.discBusy = false; });
  }
  function saveNote(val) {
    enqueue(function () { return API.update({ note: val }); });
  }

  /* --------------------------- eventi (delega) --------------------------- */
  function bindStaticEvents() {
    // fase di cattura: registra se l'anteprima era GIÀ aperta PRIMA di questo click, prima che
    // il listener diretto su titolo/immagine/"Dettagli" (che apre l'anteprima) possa modificarne
    // lo stato — altrimenti il click che APRE l'anteprima la chiuderebbe subito dopo, nella
    // stessa gestione dell'evento (bubbling), perché al momento di raggiungere questo delegate
    // risulterebbe già "aperta"
    var popWasOpen = false;
    els.root.addEventListener('click', function (e) { popWasOpen = els.pop.classList.contains('is-open'); }, true);
    els.root.addEventListener('click', function (e) {
      var target = e.target;
      // anteprima prodotto GIÀ aperta: QUALSIASI click fuori dalla card (overlay interno, overlay
      // esterno del drawer, tasto X del drawer stesso) chiude solo l'anteprima e torna al carrello,
      // non chiude anche il drawer
      if (popWasOpen) {
        if (!els.popCard.contains(target) || target.closest('[data-hn-pop-close]')) {
          e.preventDefault(); closeVariantPopup();
        }
        return;
      }
      if (target.closest('[data-hn-close]')) { e.preventDefault(); closeDrawer(); return; }
      if (target.closest('[data-hn-pop-close]')) { e.preventDefault(); closeVariantPopup(); return; }
      // foto o nome di un omaggio: l'anteprima, mai la pagina prodotto (itemHTML)
      var gi = target.closest('[data-hn-gift-info]');
      if (gi) { e.preventDefault(); openGiftFromEl(gi); return; }
      var qb = target.closest('[data-hn-qty]');
      if (qb) { var key = itemKeyFromEl(qb); if (key) changeQty(key, parseInt(qb.getAttribute('data-hn-qty'), 10)); return; }
      var rm = target.closest('[data-hn-remove]');
      if (rm) { var k2 = itemKeyFromEl(rm); if (k2) removeLine(k2); return; }
      if (target.closest('[data-hn-disc-apply]')) {
        var inp = els.body.querySelector('[data-hn-disc]'); if (inp) applyDiscount(inp.value.trim()); return;
      }
      var rmDisc = target.closest('[data-hn-disc-remove]');
      if (rmDisc) { removeDiscount(rmDisc.getAttribute('data-hn-disc-remove'), rmDisc); return; }
      var chg = target.closest('[data-hn-disc-change]');
      if (chg) {
        var form = els.body.querySelector('[data-hn-disc-form]');
        if (form) { form.hidden = false; chg.style.display = 'none'; var fi = form.querySelector('[data-hn-disc]'); if (fi) fi.focus(); }
        return;
      }
      if (target.closest('[data-hn-note-save]')) {
        var ta = els.body.querySelector('[data-hn-note]'); if (ta) { saveNote(ta.value); flash(target.closest('[data-hn-note-save]')); } return;
      }
      if (target.closest('[data-hn-checkout]')) { e.preventDefault(); goToCheckout(); return; }
    });
    // ESC per chiudere
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) {
        if (co.open) coClose();
        else if (els.pop.classList.contains('is-open')) closeVariantPopup();
        else closeDrawer();
      }
    });
    // il nome di un omaggio e' un pulsante (role=button): Invio e spazio aprono l'anteprima
    els.root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var gi = e.target && e.target.closest && e.target.closest('[data-hn-gift-info]');
      if (!gi) return;
      e.preventDefault(); openGiftFromEl(gi);
    });
    // focus trap
    els.root.addEventListener('keydown', trapFocus);
  }
  function bindToolEvents() {
    var ta = els.body.querySelector('[data-hn-note]');
    if (ta) ta.addEventListener('blur', function () { saveNote(ta.value); });
    var inp = els.body.querySelector('[data-hn-disc]');
    if (inp) inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyDiscount(inp.value.trim()); } });
  }
  function flash(btn) { if (!btn) return; var o = btn.textContent; btn.textContent = '✓'; setTimeout(function () { btn.textContent = o; }, 1200); }

  function goToCheckout() {
    if (CFG.terms && CFG.terms.enabled) {
      var cb = els.foot.querySelector('[data-hn-terms]');
      if (cb && !cb.checked) {
        var box = els.foot.querySelector('.hn-cart__terms'); if (box) box.classList.add('err');
        announce(t('termsError')); return;
      }
    }
    if (state.goingOut) return;          // un secondo tocco non fa partire un secondo giro
    state.goingOut = true;
    checkoutBusy(true);
    clearTimeout(state.goingTimer);
    state.goingTimer = setTimeout(goingDone, 12000); // se la pagina non e' cambiata, il pulsante torna normale
    whenIdle(8000).then(function () {
      /* L'offerta al checkout (sopra) prende in carico la navigazione quando ha
         qualcosa da proporre — o da registrare per il gruppo di controllo. */
      if (coStart()) return;
      trackCheckout();
      co.nav(ROOT + 'checkout');
    });
  }
  /* ⛔ «Procedi all'ordine» aspetta che il carrello sia FERMO (2026-10-08). Dal cestino la
     riga sbiadisce subito (removeLine), quindi un tocco svelto sul pagamento partiva mentre
     Shopify stava ancora togliendo il prodotto: al checkout il cliente l'avrebbe ritrovato.
     Vale anche per +/−, codici sconto, regali e un'aggiunta del tema in volo — e l'offerta
     al checkout si calcola cosi' sul carrello vero. Mai trattenere chi paga: dopo 8 s si va
     comunque. Intanto il pulsante mostra la rotellina e un secondo tocco non conta. */
  function whenIdle(max) {
    return new Promise(function (res) {
      var done = false;
      function fine() { if (!done) { done = true; res(); } }
      setTimeout(fine, max);
      (function chk() {
        if (done) return;
        if (!state.adding && !state.refreshPending && !state.busy) { enqueueRaw(function () {}).then(fine, fine); return; }
        setTimeout(chk, 40);
      })();
    });
  }
  function goingDone() { state.goingOut = false; clearTimeout(state.goingTimer); checkoutBusy(false); }
  function checkoutBusy(on) {
    /* un giro DOPO il clic: GTM legge testo e classi del pulsante cliccato dopo di noi
       (gli attivatori a clic «Begin Checkout»), e devono restare quelli di sempre */
    setTimeout(function () {
      var b = els.foot && els.foot.querySelector('[data-hn-checkout]');
      if (!b) return;
      b.classList.toggle('is-going', !!on);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    }, 0);
  }

  /* ------------------------------ open/close ------------------------------ */
  var savedScrollY = 0;
  function lockScroll() { // iOS-safe: overflow:hidden non basta su Safari mobile
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.overflow = 'hidden';
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-savedScrollY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlockScroll() {
    document.documentElement.style.overflow = '';
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, savedScrollY);
  }
  function openDrawer() {
    if (!els.root) return;
    if (state.open) return; // già aperto: non sovrascrivere lastFocus né ri-lockare lo scroll
    state.lastFocus = document.activeElement;
    clearTimeout(state.closeTimer);
    els.root.classList.remove('is-closing');
    // "monta" il pannello (display:block) ma SENZA ancora aggiungere is-open: se display e
    // transform cambiassero nella stessa passata di stile il browser salterebbe dritto allo
    // stato finale senza animare (l'elemento non ha un frame "prima" da cui partire). Il
    // reflow forzato (offsetHeight) fa sì che il browser registri il pannello nella sua
    // posizione di PARTENZA (fuori schermo) prima che il prossimo frame lo faccia scivolare
    // verso translateX(0) — stesso trucco del doppio requestAnimationFrame usato per la barra premi.
    els.root.classList.add('is-mounted');
    void els.root.offsetHeight;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { els.root.classList.add('is-open'); });
    });
    state.open = true;
    // Blocchiamo lo scroll di fondo SOLO su mobile (il drawer copre tutto lo schermo).
    // Su desktop il sito a sinistra resta scrollabile e cliccabile (vedi CSS pointer-events).
    if (isMobileViewport()) { lockScroll(); state.scrollLocked = true; } else { state.scrollLocked = false; }
    // aperto mentre l'aggiunta e' in volo: la «vista carrello» si misura sul carrello che la contiene
    if (state.adding) state.viewPending = true; else trackViewCart();
    schedulePrefetch();
    tlMark('carrello aperto');
    // aperto a mano (icona): un controllo subito, per un carrello cambiato altrove (altra scheda)
    if (!state.adding && Date.now() - poll.last > 3000) pollCart();
    state.rewardPct = 0; if (state.cart) renderRewards(state.cart); // ri-anima la barra da zero all'apertura
    var closeBtn = els.root.querySelector('.hn-cart__close'); if (closeBtn) closeBtn.focus();
  }
  /* Le verifiche dell'offerta al checkout (10 schede prodotto, alla prima apertura della
     sessione) partivano nello stesso istante dell'apertura, cioe' mentre il carrello
     aspettava la risposta di Shopify all'aggiunta: banda e connessioni del telefono
     contese proprio nel momento che il cliente sta guardando. Ora partono quando il
     carrello ha finito (400 ms dopo), e se si clicca «Procedi all'ordine» prima la
     verifica la fa coStart da se', come sempre. */
  function schedulePrefetch() {
    clearTimeout(state.prefetchTimer);
    state.prefetchTimer = setTimeout(function () {
      if (!state.open) return;
      if (state.busy || state.adding) { schedulePrefetch(); return; }
      coPrefetch();
    }, 400);
  }
  function closeDrawer() {
    if (!state.open) return;
    if (state.adding) state.addDismissed = true; // chiuso mentre l'aggiunta e' in volo: non riaprirlo all'arrivo
    els.root.classList.remove('is-open');
    els.root.classList.add('is-closing'); // resta "montato" (display:block) finché non scivola fuori del tutto
    state.open = false;
    if (state.scrollLocked) { unlockScroll(); state.scrollLocked = false; }
    if (state.lastFocus && state.lastFocus.focus) try { state.lastFocus.focus(); } catch (e) {}
    clearTimeout(state.closeTimer);
    state.closeTimer = setTimeout(function () {
      els.root.classList.remove('is-mounted', 'is-closing');
    }, 320); // poco più della transizione (.3s) del pannello
  }

  /* Il TEMA mette una classe sul <body> dopo ogni aggiunta (add-to-cart-show) per mostrare il
     suo popup, e quella classe accende anche il suo velo nero condiviso .background-overlay
     (assets/component-add-to-cart.css:312). Il tema la toglie SOLO al primo clic sul documento
     (assets/theme.js:3321-3326) — e chiudere il carrello col DITO non produce un clic, quindi
     il velo restava appeso sullo schermo col carrello gia' chiuso.
     Su telefono il velo e' spento in CSS (hn-cart.css, blocco "VELO NERO DEL TEMA"); qui si
     copre il caso che il CSS non vede: un dispositivo TOUCH piu' largo di 600px. Su desktop
     non cambia niente, perche' lo swipe non esiste (e il velo la' resta, per scelta del
     merchant). I nomi delle classi sono POLICY, non meccanismo: stanno nello snippet. */
  function clearThemeStateClasses() {
    var cls = (CFG.drawer && CFG.drawer.themeStateClasses) || [];
    for (var i = 0; i < cls.length; i++) {
      try { document.body.classList.remove(cls[i]); } catch (e) {}
    }
  }

  /* --------------------------- swipe per chiudere (mobile) --------------------------- */
  function initSwipeToClose() {
    if (!els.panel) return;
    var startX = null, startY = null, startT = 0;
    els.panel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; startT = Date.now();
    }, { passive: true });
    els.panel.addEventListener('touchend', function (e) {
      if (startX == null) return;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX, dy = touch.clientY - startY, dt = Date.now() - startT;
      startX = null;
      if (els.pop.classList.contains('is-open')) return; // non chiudere il carrello mentre l'anteprima prodotto è aperta
      if (co.open) return;                                // ne' mentre e' aperta l'offerta al checkout
      if (Math.abs(dy) > Math.abs(dx)) return; // gesto verticale (scroll del carrello) -> ignora
      var pos = els.root.getAttribute('data-pos');
      var isClosingSwipe = pos === 'left' ? (dx < -70) : (dx > 70); // verso il bordo da cui esce il drawer
      if (isClosingSwipe && dt < 600) { clearThemeStateClasses(); closeDrawer(); }
    }, { passive: true });
  }
  function trapFocus(e) {
    if (e.key !== 'Tab' || !state.open) return;
    // se il popup variante è aperto, il trap va limitato al popup (che sta sopra il drawer)
    var scope = co.open && co.el ? co.el : (els.pop.classList.contains('is-open') ? els.pop : els.root);
    var f = scope.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])');
    f = [].slice.call(f).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* --------------------- intercetta carrello del tema --------------------- */
  function isCartMutationUrl(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || ''); }
  function isAddUrl(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url || ''); }

  /* ⚡ Aggiunta dal tema o da un'app (2026-10-08). Il merchant: «quando aggiungo al
     carrello si vede una piccola animazione sul pulsante, ma poi ci vogliono almeno due
     secondi prima che aggiunge al carrello e lo apre». L'animazione e' la verifica che il
     tema fa PRIMA dell'aggiunta (theme.js, actionAddToCart2: legge /cart.js), e finisce
     prima che l'aggiunta parta; poi niente si muoveva fino a: risposta dell'aggiunta +
     rilettura del carrello + scheda del prodotto. Ora il carrello si APRE quando l'aggiunta
     PARTE, con la barra di attesa in cima (`is-adding`), e si riempie appena Shopify
     risponde. Se il cliente lo chiude nel frattempo, non si riapre da solo.
     Le nostre aggiunte (upsell, pagina prodotto, regali) passano da `_fetch`, non da qui. */
  function addedVariantIds(body) {
    var out = [];
    if (!body) return out;
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) { if (body.get('id')) out.push(body.get('id')); return out; }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) { if (body.get('id')) out.push(body.get('id')); return out; }
      if (typeof body === 'string') {
        if (/^\s*[{\[]/.test(body)) {
          var j = JSON.parse(body);
          (j.items || [j]).forEach(function (x) { if (x && x.id) out.push(x.id); });
        } else {
          var m = /(?:^|&)id=(\d+)/.exec(body); if (m) out.push(m[1]);
        }
      }
    } catch (e) {}
    return out;
  }
  function startExternalAdd(body) {
    bump();
    tlStart('aggiunta dal sito (tema o app)');
    tlMark('POST /cart/add.js partita (tema)');
    addedVariantIds(body).forEach(prefetchVariant);
    if (!state.adding) state.addDismissed = false;
    state.adding++;
    state.extrasLate = true; // i consigliati entreranno DOPO il prodotto (renderBody, hn-late)
    state.flashAdds = true;  // e la riga del prodotto si illumina quando arriva
    if (els.root) els.root.classList.add('is-adding');
    clearTimeout(state.addingTimer);
    state.addingTimer = setTimeout(function () { state.adding = 0; endExternalAdd(); }, 15000); // rete di sicurezza
    if (CFG.drawer && CFG.drawer.openOnAdd && !state.addDismissed) openDrawer();
    paintAdding();
    // il pulsante che l'ha fatta partire resta «in corso» fino al prodotto in carrello
    if (addBtn.el && Date.now() - addBtn.at < 3000) { clearTimeout(addBtn.timer); markAddBtn(addBtn.el, true); }
  }
  function addResponded(esito) {
    state.adding = Math.max(0, state.adding - 1);
    tlMark('risposta /cart/add.js al tema: ' + esito);
  }
  function endExternalAdd() {
    if (state.adding) return;
    releaseAddBtn();
    clearTimeout(state.addingTimer);
    if (els.root) els.root.classList.remove('is-adding');
    var ph = els.body && els.body.querySelector('.hn-adding');
    if (ph && state.cart) render(); // la riga d'attesa se ne va anche se il disegno vero non e' passato di qui
    state.extrasLate = false;
  }

  /* ⛔ Il doppio tocco su «Aggiungi al carrello» del TEMA (2026-10-08, merchant: «i
     feedback devono rassicurare il cliente ed evitare che clicchi due volte»). Il tema
     mette la rotellina (`is-loading`) durante la SUA verifica del carrello e la toglie
     appena finita, cioe' PRIMA che l'aggiunta sia fatta (theme.js, actionAddToCart2): per
     quasi un secondo il pulsante sembrava di nuovo libero, e un secondo tocco aggiungeva un
     secondo pezzo. Su telefono il carrello aperto copre il pulsante; su computer no.
     Ora un tocco su un pulsante che sta gia' aggiungendo non arriva al tema, e la
     rotellina resta fino al prodotto in carrello. Tre cose da non cambiare:
       - mai `disabled`: hn-delivery e la barra d'acquisto lo leggono come «esaurito»;
       - classe e aria-busy si mettono un giro DOPO il clic: GTM legge le classi del
         pulsante cliccato dopo di noi, e devono restare quelle di sempre;
       - si segna al tocco solo il pulsante di un modulo prodotto, dove un tocco e' sempre
         un'aggiunta; quello di una scheda puo' aprire la scelta delle varianti, e lo si
         segna solo quando l'aggiunta parte davvero. Se l'aggiunta non parte entro 3 s (la
         verifica del tema l'ha fermata), il pulsante torna libero. */
  var addBtn = { el: null, at: 0, timer: null };
  function markAddBtn(b, on) {
    if (!b) return;
    b.__hnBusy = on ? Date.now() : 0;
    setTimeout(function () {
      if (on) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); }
      else { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }
    }, 0);
  }
  function releaseAddBtn() {
    clearTimeout(addBtn.timer);
    if (addBtn.el && addBtn.el.__hnBusy) markAddBtn(addBtn.el, false);
    addBtn.el = null;
  }
  function guardAddButtons() {
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-btn-addtocart]');
      if (!b) return;
      if (b.__hnBusy && Date.now() - b.__hnBusy < 15000) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (addBtn.el && addBtn.el !== b && addBtn.el.__hnBusy && !state.adding) markAddBtn(addBtn.el, false);
      addBtn.el = b; addBtn.at = Date.now();
      if (!b.closest('product-form')) return;
      markAddBtn(b, true);
      clearTimeout(addBtn.timer);
      addBtn.timer = setTimeout(function () { if (!state.adding) releaseAddBtn(); }, 3000);
    }, true);
  }

  var debounceTimer = null, pendingAdd = false;
  function onExternalMutation(wasAdd) {
    /* il flag dell'aggiunta si SOMMA nella finestra di 60 ms: prima vinceva l'ultima
       chiamata, quindi una seconda mutazione arrivata subito dopo l'aggiunta (un'app
       che scrive un attributo) spegneva l'apertura del carrello — «a volte non lo apre» */
    if (wasAdd) pendingAdd = true;
    clearTimeout(debounceTimer);
    state.refreshPending = true;
    debounceTimer = setTimeout(function () {
      var add = pendingAdd; pendingAdd = false;
      state.refreshPending = false;
      refresh({ open: add && CFG.drawer.openOnAdd && !state.addDismissed, fromAdd: add });
    }, 60);
  }

  function patchFetch() {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mut = isCartMutationUrl(url), add = mut && isAddUrl(url);
      var args = arguments;
      /* Un set aggiunto dal tema o da un'app parte COL SUO PREDEFINITO (vedi «SET A SCELTA»):
         le note si scrivono nel corpo PRIMA che la richiesta parta, su una copia — il corpo
         del chiamante non si tocca. Senza nulla da scrivere `bysBody` restituisce lo stesso oggetto. */
      if (add && BYS && init && init.body != null) {
        var nb = bysBody(init.body);
        if (nb !== init.body) { init = Object.assign({}, init, { body: nb }); args = [input, init]; }
      }
      var p = orig.apply(this, args);
      // DOPO aver spedito la richiesta: aprire il carrello costa un ricalcolo della pagina
      if (add) startExternalAdd(init && init.body); else if (mut) bump();
      if (mut) {
        p.then(function (r) {
          if (add) addResponded(r ? r.status : '?');
          onExternalMutation(add);
          /* `clone()` DEVE avvenire prima che il chiamante consumi il corpo, e
             avviene: questo handler e' registrato prima del suo, quindi gira
             prima nella coda dei microtask. */
          if (add && r && r.ok && typeof r.clone === 'function') {
            try { r.clone().text().then(leggiRispostaAdd, function () {}); } catch (e) {}
          }
        }, function () {
          // rete caduta: il carrello va comunque riletto, e la barra di attesa spenta
          if (add) addResponded('errore di rete');
          onExternalMutation(add);
        });
      }
      return p;
    };
  }
  function patchXHR() {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__hnUrl = url; return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var self = this;
      var mut = isCartMutationUrl(self.__hnUrl), add = mut && isAddUrl(self.__hnUrl);
      if (mut) {
        self.addEventListener('load', function () {
          if (add && self.status >= 200 && self.status < 300) {
            /* responseText non si "consuma": leggerlo qui non toglie nulla a
               jQuery, che legge lo stesso oggetto. */
            try { leggiRispostaAdd(self.responseType && self.responseType !== 'text' ? null : self.responseText); } catch (e) {}
          }
        });
        // loadend arriva anche per errore, abort e timeout: prima un errore lasciava il carrello fermo
        self.addEventListener('loadend', function () {
          if (add) addResponded(self.status || 'errore di rete');
          onExternalMutation(add);
        });
      }
      var args = arguments;
      // il corpo e' quello di jQuery («quantity=1&id=123» da Shopify.addItem) o di un'app: stessa regola del fetch
      if (add && BYS && body != null) {
        var nb = bysBody(body);
        if (nb !== body) { args = [nb]; body = nb; }
      }
      var ret = send.apply(this, args);
      if (add) startExternalAdd(body); else if (mut) bump(); // dopo l'invio, come per fetch
      return ret;
    };
  }
  // click sull'icona/link carrello del tema -> apri il NOSTRO drawer
  function patchCartTriggers() {
    if (!(CFG.drawer && CFG.drawer.openOnCartClick)) return;
    var sels = (CFG.drawer.cartTriggerSelectors || []).join(',');
    document.addEventListener('click', function (e) {
      if (!sels) return;
      var trg = e.target.closest(sels);
      if (!trg) return;
      // non intercettare link che aprono in nuova scheda / con modificatori
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (CFG.drawer.disableThemeCart) e.stopPropagation();
      openDrawer();
    }, true); // capture: prima del tema
  }
  // nasconde i popup/drawer carrello nativi del tema (evita doppia UI)
  function injectSuppressionCSS() {
    if (!(CFG.drawer && CFG.drawer.disableThemeCart)) return;
    var sels = (CFG.drawer.hideThemeNodes || []).filter(Boolean);
    if (!sels.length) return;
    var st = document.createElement('style');
    st.setAttribute('data-hn-suppress', '');
    st.textContent = sels.join(',') + '{display:none !important;}';
    (document.head || document.documentElement).appendChild(st);
  }
  // rinforzo via JS del punto sopra: un foglio di stile con selettore "povero" (es. il solo tag
  // "cart-notification") ha specificità bassissima e PERDE contro una regola più specifica (es.
  // ".active"/[open]) che un'altra app usa per mostrare il suo popup — è il caso più probabile per
  // cui il popup nativo continua a lampeggiare nonostante il CSS sopra. Qui forziamo lo stesso
  // display:none in stile INLINE (che batte qualunque selettore esterno, a prescindere dalla sua
  // specificità) sui nodi già presenti E su OGNI nodo futuro, non appena viene creato — copre
  // anche il caso in cui l'altra app crei/mostri il popup DOPO il nostro avvio.
  function watchThemeNodes() {
    if (!(CFG.drawer && CFG.drawer.disableThemeCart)) return;
    var sels = (CFG.drawer.hideThemeNodes || []).filter(Boolean);
    if (!sels.length) return;
    var sel = sels.join(',');
    function forceHide(el) {
      if (!el || el.nodeType !== 1) return;
      try {
        if (el.matches && el.matches(sel)) el.style.setProperty('display', 'none', 'important');
        if (el.querySelectorAll) {
          var kids = el.querySelectorAll(sel);
          for (var i = 0; i < kids.length; i++) kids[i].style.setProperty('display', 'none', 'important');
        }
      } catch (e) {}
    }
    document.querySelectorAll(sel).forEach(forceHide);
    // Copre anche il caso (molto comune per un popup "toast") in cui il nodo NON è nuovo: esiste
    // già dal caricamento della pagina ed è il tema/l'app stesso a mostrarlo di nuovo ad ogni
    // add-to-cart cambiando la SUA classe/stile/attributo — es. el.style.display='flex' o
    // classList.add('active'). Un'assegnazione diretta a el.style.display SOSTITUISCE il nostro
    // display:none!important precedente (non è una regola CSS concorrente: è lo stesso slot di
    // stile inline), quindi serve ri-applicare la soppressione OGNI VOLTA che questi attributi
    // cambiano, non solo quando compare un nodo nuovo (childList da solo non lo vede).
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') { forceHide(m.target); continue; }
        var added = m.addedNodes;
        for (var j = 0; j < added.length; j++) forceHide(added[j]);
      }
    }).observe(document.documentElement, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['style', 'class', 'open', 'aria-hidden']
    });
  }

  // Diagnostica (solo con ?hncartdebug): il popup segnalato continua a comparire nonostante DUE
  // giri di fix sulla soppressione — vuol dire che l'ipotesi sul tag/classe da nascondere
  // (hideThemeNodes) potrebbe essere sbagliata, o il nodo reale è diverso. Invece di continuare a
  // indovinare, questo osservatore cerca QUALUNQUE elemento il cui testo assomigli al popup reale
  // ("Continua a fare acquisti" / "Visualizza carrello" / "Prodotto aggiunto") e riporta a video
  // tag/id/classi ESATTI, se è visibile e se il NOSTRO selettore di soppressione lo intercetta —
  // così un solo screenshot dice la verità invece di un'altra ipotesi.
  function watchPopupDebug() {
    if (!HN_DEBUG) return;
    var reported = {};
    var RX = /continua a (fare )?acquisti|visualizza\s*carrello|prodotto aggiunto|continue shopping|view cart|added to (your )?cart/i;
    function describe(el) {
      var sels = ((CFG.drawer && CFG.drawer.hideThemeNodes) || []).filter(Boolean).join(',');
      var matches = false;
      try { matches = !!(sels && el.matches && el.matches(sels)); } catch (e) {}
      var cs = getComputedStyle(el);
      return {
        tag: el.tagName.toLowerCase(), id: el.id || '',
        cls: (typeof el.className === 'string' ? el.className : (el.className && el.className.baseVal) || ''),
        display: cs.display, visibility: cs.visibility, opacity: cs.opacity,
        matches: matches, parentTag: el.parentElement ? el.parentElement.tagName.toLowerCase() : ''
      };
    }
    function report(el) {
      try {
        var d = describe(el);
        var box = document.getElementById('hn-popup-debug');
        if (!box) {
          box = document.createElement('div');
          box.id = 'hn-popup-debug';
          box.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;max-width:94vw;' +
            'max-height:40vh;overflow:auto;background:#fff8f0;border:2px solid #c00;color:#900;' +
            'font:11px/1.4 monospace;padding:8px;border-radius:6px;white-space:pre-wrap;word-break:break-all';
          document.body.appendChild(box);
        }
        var line = document.createElement('div');
        line.style.cssText = 'margin-bottom:6px;padding-bottom:6px;border-bottom:1px dashed #c00';
        line.textContent = 'POPUP <' + d.tag + (d.id ? '#' + d.id : '') + (d.cls ? ' class="' + d.cls + '"' : '') + '> ' +
          'display=' + d.display + ' visibility=' + d.visibility + ' opacity=' + d.opacity +
          ' | soppresso-dal-nostro-selettore=' + d.matches + ' | genitore=<' + d.parentTag + '>';
        box.appendChild(line);
      } catch (e) {}
    }
    function check(el) {
      if (!el || el.nodeType !== 1) return;
      var txt = (el.textContent || '').trim();
      if (!txt.length || txt.length > 400 || !RX.test(txt)) return;
      // risali al contenitore più esterno con lo STESSO testo (non ogni singolo span annidato)
      var top = el, hops = 0;
      while (top.parentElement && hops < 6 && (top.parentElement.textContent || '').trim() === txt) { top = top.parentElement; hops++; }
      var key = top.tagName + '|' + top.id + '|' + top.className;
      if (reported[key]) return;
      reported[key] = true;
      report(top);
    }
    document.querySelectorAll('body *').forEach(check);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.addedNodes) for (var j = 0; j < m.addedNodes.length; j++) check(m.addedNodes[j]);
        if (m.type === 'attributes' && m.target) check(m.target);
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'open', 'hidden'] });
  }

  // intercetta submit dei form add-to-cart (SOLO temi senza AJAX: drawer.interceptForms=true)
  function patchForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;
      e.preventDefault();
      var fd = new FormData(form);
      var id = fd.get('id'); var qty = fd.get('quantity') || 1;
      if (!id) return;
      var props = {};
      fd.forEach(function (v, k) { if (k.indexOf('properties[') === 0) { props[k.slice(11, -1)] = v; } });
      // NON passiamo il bottone del tema (resterebbe disabilitato dopo l'add): l'apertura del drawer è già il feedback
      addVariant(id, parseInt(qty, 10) || 1, Object.keys(props).length ? props : null, null);
    }, true);
  }

  /* La barra fissa d'acquisto della pagina prodotto NON vive più qui (era
     `initStickyAtc`, mai accesa in produzione e tolta il 2026-10-05): è
     snippets/hn-buybar.liquid + assets/hn-buybar.js, e clicca il bottone del tema. */

  /* ---------------------- sincronizza contatore nativo ---------------------- */
  function syncNativeBubble(cart) {
    // aggiorna i contatori tipici del tema, così l'icona resta coerente
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count], .cart-count').forEach(function (n) {
      n.textContent = cart.item_count;
    });
  }

  // true su /cart, /it/cart, /cart/ ecc.: patchCartTriggers intercetta solo i CLICK
  // sull'icona carrello, non l'arrivo diretto sulla pagina (URL digitato, link esterno,
  // back del browser) — questo copre anche quel caso, aprendo il nostro drawer al posto
  // del contenuto nativo di /cart (già nascosto via hideThemeNodes: 'cart-items').
  function isCartPage() {
    return /\/cart\/?$/.test((window.location.pathname || '').replace(/\/+$/, '') + '/');
  }

  /* ------------------------------ boot ------------------------------ */
  function init() {
    buildDOM();
    initSwipeToClose();
    if (!DESIGN) {
      // comportamento normale sullo storefront
      injectSuppressionCSS();
      watchThemeNodes();
      watchPopupDebug();
      patchFetch();
      patchXHR();
      patchCartTriggers();
      guardAddButtons();
      if (CFG.drawer && CFG.drawer.interceptForms) patchForms();
      startPolling(); // rete di sicurezza indipendente dall'intercettazione fetch/XHR
      // tornando indietro dal pagamento il browser puo' restituire la pagina com'era: rotellina compresa
      window.addEventListener('pageshow', function (e) { if (e && e.persisted) goingDone(); });
    }
    // Nell'editor del tema NON intercettiamo nulla (per non rompere l'editor):
    // carichiamo lo stato e apriamo il drawer così il merchant vede l'anteprima dello stile.
    var openOnCartPage = !DESIGN && CFG.drawer && CFG.drawer.openOnCartPageLoad && isCartPage();
    refresh({ open: DESIGN || openOnCartPage });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // API pubblica minima (comoda per debug / integrazioni)
  window.HNCart = {
    open: openDrawer, close: closeDrawer, refresh: function () { return refresh({ open: false }); },
    get state() { return state; }, config: CFG,
    /* Set a scelta (assets/hn-bys.js): UNA sola copia della regola del predefinito e del
       formato delle note, qui. Il modulo della pagina prodotto la chiede al motore invece di
       riscriverla — due copie sono il difetto numero uno di questo repo. Vedi «SET A SCELTA». */
    bys: {
      enabled: function () { return !!BYS; },
      has: function (pid) { return !!(BYS && BYS.sets[String(pid)]); },
      base: bysBase,            // il predefinito: i primi N saponi disponibili (mappa id -> pezzi) o null
      sku: bysSku,              // cosa spedisce lo SKU di una variante (mappa id -> pezzi)
      same: bysSame,
      props: bysProps,          // le note della riga per una scelta (oggetto), o null
      plan: bysPlan,            // le note SOLO se lo SKU ha un sapone esaurito: {sel, props} o null
      get soaps() { return BYS ? BYS.soaps.map(function (s) { return { id: s.id, a: s.a }; }) : []; }
    },
    /* Superficie per i moduli della PAGINA PRODOTTO (hn-pdp). Espone il motore,
       non lo duplica: un secondo scorer sarebbe la seconda copia da tenere
       allineata a mano — il difetto numero uno di questo repo — e divergerebbe
       dal drawer al primo cambio di catalogo. */
    reco: {
      forProduct: forProduct,             // ranking sul carrello virtuale
      needs: needsOf,                     // bisogni di un prodotto (derivati dal catalogo)
      containersOf: containersOf,         // risalita ai set/kit che contengono l'ancora
      isContainer: isContainer,
      add: addVariant,
      addMany: addMany,
      setAttribute: setAttribute,
      verify: verifyStockFor,
      checked: checked,                   // stock E varianti già letti in questa sessione
      product: productFull,               // /products/<handle>.js, una volta per pagina
      description: descHTML,              // descrizione resa come nell'anteprima del drawer
      hydrate: hydrate,
      money: money, t: t,
      mapVersion: mapVersion,
      pdpMapVersion: function () { return (pdpWeights().v) || mapVersion(); },
      weights: pdpWeights,
      goals: goalList,                    // soglie in centesimi, per la riga del vantaggio del pacchetto
      cartSnapshot: readCartSnapshot,
      get cart() { return state.cart; }
    },
    /* Offerta al checkout: il piano (per i censimenti dei test) e la navigazione
       sostituibile — `location.href` non e' ridefinibile in Chromium, e senza
       questo un test non potrebbe vedere cosa succede DOPO il clic. */
    _co: {
      plan: function (o) { return coPlan(state.cart, o); },
      attr: function (plan, h, outcome) { return coAttr(plan, h, outcome); },
      setNav: function (fn) { co.nav = fn; },
      get open() { return co.open; }
    }
  };
  /* Rete di sicurezza per chi si aggancia: `init()` gira PRIMA di questa
     assegnazione, quindi un evento lanciato in coda a init partirebbe con
     `window.HNCart` ancora undefined. Con `defer` gli script dei blocchi girano
     comunque dopo tutto questo file — l'evento serve a chi arriva prima. */
  try { document.dispatchEvent(new CustomEvent('hn:cart:ready')); } catch (e) {}
})();
